// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { ApproveCycleApiV1ReviewCyclesContractIdApprovePostData, ApproveCycleApiV1ReviewCyclesContractIdApprovePostErrors, ApproveCycleApiV1ReviewCyclesContractIdApprovePostResponses, ApproveDeltaApiV1DeltasDeltaIdApprovePostData, ApproveDeltaApiV1DeltasDeltaIdApprovePostErrors, ApproveDeltaApiV1DeltasDeltaIdApprovePostResponses, ApproveItemApiV1ReviewItemsDeltaIdApprovePostData, ApproveItemApiV1ReviewItemsDeltaIdApprovePostErrors, ApproveItemApiV1ReviewItemsDeltaIdApprovePostResponses, ApproveSnapshotApiV1SnapshotsSnapshotIdApprovePostData, ApproveSnapshotApiV1SnapshotsSnapshotIdApprovePostErrors, ApproveSnapshotApiV1SnapshotsSnapshotIdApprovePostResponses, CancelDeltaApiV1DeltasDeltaIdCancelPostData, CancelDeltaApiV1DeltasDeltaIdCancelPostErrors, CancelDeltaApiV1DeltasDeltaIdCancelPostResponses, CaptureWorkerListApiV1EsocialWorkerListsPostData, CaptureWorkerListApiV1EsocialWorkerListsPostErrors, CaptureWorkerListApiV1EsocialWorkerListsPostResponses, ClearClockApiV1ClockDeleteData, ClearClockApiV1ClockDeleteErrors, ClearClockApiV1ClockDeleteResponses, CollectWorkerReportApiV1EsocialWorkerReportsReportIdCollectPostData, CollectWorkerReportApiV1EsocialWorkerReportsReportIdCollectPostErrors, CollectWorkerReportApiV1EsocialWorkerReportsReportIdCollectPostResponses, CompareSnapshotApiV1SnapshotsSnapshotIdComparisonGetData, CompareSnapshotApiV1SnapshotsSnapshotIdComparisonGetErrors, CompareSnapshotApiV1SnapshotsSnapshotIdComparisonGetResponses, ConfirmCompanySpreadsheetUploadApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdConfirmPostData, ConfirmCompanySpreadsheetUploadApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdConfirmPostErrors, ConfirmCompanySpreadsheetUploadApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdConfirmPostResponses, ConfirmFetchApiV1EsocialFetchesFetchIdConfirmPostData, ConfirmFetchApiV1EsocialFetchesFetchIdConfirmPostErrors, ConfirmFetchApiV1EsocialFetchesFetchIdConfirmPostResponses, ConfirmGroupSpreadsheetUploadApiV1GroupsGroupIdSpreadsheetUploadsUploadIdConfirmPostData, ConfirmGroupSpreadsheetUploadApiV1GroupsGroupIdSpreadsheetUploadsUploadIdConfirmPostErrors, ConfirmGroupSpreadsheetUploadApiV1GroupsGroupIdSpreadsheetUploadsUploadIdConfirmPostResponses, ConfirmSpreadsheetUploadApiV1ContractsContractIdSpreadsheetUploadsUploadIdConfirmPostData, ConfirmSpreadsheetUploadApiV1ContractsContractIdSpreadsheetUploadsUploadIdConfirmPostErrors, ConfirmSpreadsheetUploadApiV1ContractsContractIdSpreadsheetUploadsUploadIdConfirmPostResponses, CorrectEffectiveDateApiV1ReviewItemsDeltaIdEffectiveDatePostData, CorrectEffectiveDateApiV1ReviewItemsDeltaIdEffectiveDatePostErrors, CorrectEffectiveDateApiV1ReviewItemsDeltaIdEffectiveDatePostResponses, CreateCompanyApiV1CompaniesPostData, CreateCompanyApiV1CompaniesPostErrors, CreateCompanyApiV1CompaniesPostResponses, CreateContractApiV1ContractsPostData, CreateContractApiV1ContractsPostErrors, CreateContractApiV1ContractsPostResponses, CreateGroupApiV1GroupsPostData, CreateGroupApiV1GroupsPostErrors, CreateGroupApiV1GroupsPostResponses, CreateInsurerApiV1InsurersPostData, CreateInsurerApiV1InsurersPostErrors, CreateInsurerApiV1InsurersPostResponses, CreateUserApiV1UsersPostData, CreateUserApiV1UsersPostErrors, CreateUserApiV1UsersPostResponses, DeactivateCertificateApiV1CertificatesCertificateIdDeactivationPostData, DeactivateCertificateApiV1CertificatesCertificateIdDeactivationPostErrors, DeactivateCertificateApiV1CertificatesCertificateIdDeactivationPostResponses, DeactivateUserApiV1UsersUserIdDeactivationPostData, DeactivateUserApiV1UsersUserIdDeactivationPostErrors, DeactivateUserApiV1UsersUserIdDeactivationPostResponses, DiscardMessageApiV1MailboxMessagesMessageIdDiscardPostData, DiscardMessageApiV1MailboxMessagesMessageIdDiscardPostErrors, DiscardMessageApiV1MailboxMessagesMessageIdDiscardPostResponses, DownloadBaselineImportSourceApiV1ContractsContractIdBaselineImportsBaselineImportIdSourceGetData, DownloadBaselineImportSourceApiV1ContractsContractIdBaselineImportsBaselineImportIdSourceGetErrors, DownloadBaselineImportSourceApiV1ContractsContractIdBaselineImportsBaselineImportIdSourceGetResponses, DownloadCompanySpreadsheetUploadSourceApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdSourceGetData, DownloadCompanySpreadsheetUploadSourceApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdSourceGetErrors, DownloadCompanySpreadsheetUploadSourceApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdSourceGetResponses, DownloadConsolidatedFileApiV1SubmissionsConsolidatedConsolidatedIdFileGetData, DownloadConsolidatedFileApiV1SubmissionsConsolidatedConsolidatedIdFileGetErrors, DownloadConsolidatedFileApiV1SubmissionsConsolidatedConsolidatedIdFileGetResponses, DownloadDocumentApiV1DocumentsDocumentIdContentGetData, DownloadDocumentApiV1DocumentsDocumentIdContentGetErrors, DownloadDocumentApiV1DocumentsDocumentIdContentGetResponses, DownloadEventSourceApiV1EsocialEventsEventIdSourceGetData, DownloadEventSourceApiV1EsocialEventsEventIdSourceGetErrors, DownloadEventSourceApiV1EsocialEventsEventIdSourceGetResponses, DownloadGroupFileApiV1SubmissionsGroupFilesGroupFileIdFileGetData, DownloadGroupFileApiV1SubmissionsGroupFilesGroupFileIdFileGetErrors, DownloadGroupFileApiV1SubmissionsGroupFilesGroupFileIdFileGetResponses, DownloadGroupSpreadsheetUploadSourceApiV1GroupsGroupIdSpreadsheetUploadsUploadIdSourceGetData, DownloadGroupSpreadsheetUploadSourceApiV1GroupsGroupIdSpreadsheetUploadsUploadIdSourceGetErrors, DownloadGroupSpreadsheetUploadSourceApiV1GroupsGroupIdSpreadsheetUploadsUploadIdSourceGetResponses, DownloadMessageSourceApiV1MailboxMessagesMessageIdSourceGetData, DownloadMessageSourceApiV1MailboxMessagesMessageIdSourceGetErrors, DownloadMessageSourceApiV1MailboxMessagesMessageIdSourceGetResponses, DownloadNoticeFileApiV1OffCycleNoticesNoticeIdFileGetData, DownloadNoticeFileApiV1OffCycleNoticesNoticeIdFileGetErrors, DownloadNoticeFileApiV1OffCycleNoticesNoticeIdFileGetResponses, DownloadPortalWalkBundleApiV1EsocialPortalWalksRunIdBundleGetData, DownloadPortalWalkBundleApiV1EsocialPortalWalksRunIdBundleGetErrors, DownloadPortalWalkBundleApiV1EsocialPortalWalksRunIdBundleGetResponses, DownloadSnapshotFileApiV1SnapshotsSnapshotIdFileGetData, DownloadSnapshotFileApiV1SnapshotsSnapshotIdFileGetErrors, DownloadSnapshotFileApiV1SnapshotsSnapshotIdFileGetResponses, DownloadSpreadsheetUploadSourceApiV1ContractsContractIdSpreadsheetUploadsUploadIdSourceGetData, DownloadSpreadsheetUploadSourceApiV1ContractsContractIdSpreadsheetUploadsUploadIdSourceGetErrors, DownloadSpreadsheetUploadSourceApiV1ContractsContractIdSpreadsheetUploadsUploadIdSourceGetResponses, DownloadTemplateApiV1SpreadsheetUploadsTemplateGetData, DownloadTemplateApiV1SpreadsheetUploadsTemplateGetErrors, DownloadTemplateApiV1SpreadsheetUploadsTemplateGetResponses, FetchEventsApiV1EsocialFetchesPostData, FetchEventsApiV1EsocialFetchesPostErrors, FetchEventsApiV1EsocialFetchesPostResponses, GenerateSnapshotApiV1ContractsContractIdSnapshotsPostData, GenerateSnapshotApiV1ContractsContractIdSnapshotsPostErrors, GenerateSnapshotApiV1ContractsContractIdSnapshotsPostResponses, GetBaselineImportApiV1ContractsContractIdBaselineImportsBaselineImportIdGetData, GetBaselineImportApiV1ContractsContractIdBaselineImportsBaselineImportIdGetErrors, GetBaselineImportApiV1ContractsContractIdBaselineImportsBaselineImportIdGetResponses, GetCertificateApiV1CertificatesCertificateIdGetData, GetCertificateApiV1CertificatesCertificateIdGetErrors, GetCertificateApiV1CertificatesCertificateIdGetResponses, GetCompanyApiV1CompaniesCompanyIdGetData, GetCompanyApiV1CompaniesCompanyIdGetErrors, GetCompanyApiV1CompaniesCompanyIdGetResponses, GetCompanySpreadsheetUploadApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdGetData, GetCompanySpreadsheetUploadApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdGetErrors, GetCompanySpreadsheetUploadApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdGetResponses, GetContractApiV1ContractsContractIdGetData, GetContractApiV1ContractsContractIdGetErrors, GetContractApiV1ContractsContractIdGetResponses, GetDeltaApiV1DeltasDeltaIdGetData, GetDeltaApiV1DeltasDeltaIdGetErrors, GetDeltaApiV1DeltasDeltaIdGetResponses, GetDocumentApiV1DocumentsDocumentIdGetData, GetDocumentApiV1DocumentsDocumentIdGetErrors, GetDocumentApiV1DocumentsDocumentIdGetResponses, GetGroupApiV1GroupsGroupIdGetData, GetGroupApiV1GroupsGroupIdGetErrors, GetGroupApiV1GroupsGroupIdGetResponses, GetGroupSpreadsheetUploadApiV1GroupsGroupIdSpreadsheetUploadsUploadIdGetData, GetGroupSpreadsheetUploadApiV1GroupsGroupIdSpreadsheetUploadsUploadIdGetErrors, GetGroupSpreadsheetUploadApiV1GroupsGroupIdSpreadsheetUploadsUploadIdGetResponses, GetInsurerApiV1InsurersInsurerIdGetData, GetInsurerApiV1InsurersInsurerIdGetErrors, GetInsurerApiV1InsurersInsurerIdGetResponses, GetMachineClientApiV1MachineClientsMachineClientIdGetData, GetMachineClientApiV1MachineClientsMachineClientIdGetErrors, GetMachineClientApiV1MachineClientsMachineClientIdGetResponses, GetMessageApiV1MailboxMessagesMessageIdGetData, GetMessageApiV1MailboxMessagesMessageIdGetErrors, GetMessageApiV1MailboxMessagesMessageIdGetResponses, GetPersonHistoryApiV1ContractsContractIdInsuredPeopleInsuredPersonIdHistoryGetData, GetPersonHistoryApiV1ContractsContractIdInsuredPeopleInsuredPersonIdHistoryGetErrors, GetPersonHistoryApiV1ContractsContractIdInsuredPeopleInsuredPersonIdHistoryGetResponses, GetSnapshotApiV1SnapshotsSnapshotIdGetData, GetSnapshotApiV1SnapshotsSnapshotIdGetErrors, GetSnapshotApiV1SnapshotsSnapshotIdGetResponses, GetSpreadsheetUploadApiV1ContractsContractIdSpreadsheetUploadsUploadIdGetData, GetSpreadsheetUploadApiV1ContractsContractIdSpreadsheetUploadsUploadIdGetErrors, GetSpreadsheetUploadApiV1ContractsContractIdSpreadsheetUploadsUploadIdGetResponses, GetSubmissionCycleApiV1ContractsContractIdSubmissionCycleGetData, GetSubmissionCycleApiV1ContractsContractIdSubmissionCycleGetErrors, GetSubmissionCycleApiV1ContractsContractIdSubmissionCycleGetResponses, GetUserApiV1UsersUserIdGetData, GetUserApiV1UsersUserIdGetErrors, GetUserApiV1UsersUserIdGetResponses, HealthApiV1HealthGetData, HealthApiV1HealthGetErrors, HealthApiV1HealthGetResponses, ImportBaselineApiV1ContractsContractIdBaselineImportsPostData, ImportBaselineApiV1ContractsContractIdBaselineImportsPostErrors, ImportBaselineApiV1ContractsContractIdBaselineImportsPostResponses, ImportCompanyBaselineApiV1CompaniesCompanyIdBaselineImportsPostData, ImportCompanyBaselineApiV1CompaniesCompanyIdBaselineImportsPostErrors, ImportCompanyBaselineApiV1CompaniesCompanyIdBaselineImportsPostResponses, ImportGroupBaselineApiV1GroupsGroupIdBaselineImportsPostData, ImportGroupBaselineApiV1GroupsGroupIdBaselineImportsPostErrors, ImportGroupBaselineApiV1GroupsGroupIdBaselineImportsPostResponses, IssueMachineClientApiV1MachineClientsPostData, IssueMachineClientApiV1MachineClientsPostErrors, IssueMachineClientApiV1MachineClientsPostResponses, LinkDocumentApiV1DocumentsDocumentIdLinksPostData, LinkDocumentApiV1DocumentsDocumentIdLinksPostErrors, LinkDocumentApiV1DocumentsDocumentIdLinksPostResponses, ListAuditEntriesApiV1AuditEntriesGetData, ListAuditEntriesApiV1AuditEntriesGetErrors, ListAuditEntriesApiV1AuditEntriesGetResponses, ListBaselineImportsApiV1ContractsContractIdBaselineImportsGetData, ListBaselineImportsApiV1ContractsContractIdBaselineImportsGetErrors, ListBaselineImportsApiV1ContractsContractIdBaselineImportsGetResponses, ListCertificatesApiV1CertificatesGetData, ListCertificatesApiV1CertificatesGetErrors, ListCertificatesApiV1CertificatesGetResponses, ListCompaniesApiV1CompaniesGetData, ListCompaniesApiV1CompaniesGetErrors, ListCompaniesApiV1CompaniesGetResponses, ListCompanySpreadsheetUploadAbsencesApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdAbsencesGetData, ListCompanySpreadsheetUploadAbsencesApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdAbsencesGetErrors, ListCompanySpreadsheetUploadAbsencesApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdAbsencesGetResponses, ListCompanySpreadsheetUploadRowsApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdRowsGetData, ListCompanySpreadsheetUploadRowsApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdRowsGetErrors, ListCompanySpreadsheetUploadRowsApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdRowsGetResponses, ListCompanySpreadsheetUploadsApiV1CompaniesCompanyIdSpreadsheetUploadsGetData, ListCompanySpreadsheetUploadsApiV1CompaniesCompanyIdSpreadsheetUploadsGetErrors, ListCompanySpreadsheetUploadsApiV1CompaniesCompanyIdSpreadsheetUploadsGetResponses, ListContractsApiV1ContractsGetData, ListContractsApiV1ContractsGetErrors, ListContractsApiV1ContractsGetResponses, ListDeltasApiV1DeltasGetData, ListDeltasApiV1DeltasGetErrors, ListDeltasApiV1DeltasGetResponses, ListDocumentsApiV1DocumentsGetData, ListDocumentsApiV1DocumentsGetErrors, ListDocumentsApiV1DocumentsGetResponses, ListDocumentsForDeltaApiV1DeltasDeltaIdDocumentsGetData, ListDocumentsForDeltaApiV1DeltasDeltaIdDocumentsGetErrors, ListDocumentsForDeltaApiV1DeltasDeltaIdDocumentsGetResponses, ListEventsApiV1EsocialEventsGetData, ListEventsApiV1EsocialEventsGetErrors, ListEventsApiV1EsocialEventsGetResponses, ListFetchesApiV1EsocialFetchesGetData, ListFetchesApiV1EsocialFetchesGetErrors, ListFetchesApiV1EsocialFetchesGetResponses, ListGroupsApiV1GroupsGetData, ListGroupsApiV1GroupsGetErrors, ListGroupsApiV1GroupsGetResponses, ListGroupSpreadsheetUploadAbsencesApiV1GroupsGroupIdSpreadsheetUploadsUploadIdAbsencesGetData, ListGroupSpreadsheetUploadAbsencesApiV1GroupsGroupIdSpreadsheetUploadsUploadIdAbsencesGetErrors, ListGroupSpreadsheetUploadAbsencesApiV1GroupsGroupIdSpreadsheetUploadsUploadIdAbsencesGetResponses, ListGroupSpreadsheetUploadRowsApiV1GroupsGroupIdSpreadsheetUploadsUploadIdRowsGetData, ListGroupSpreadsheetUploadRowsApiV1GroupsGroupIdSpreadsheetUploadsUploadIdRowsGetErrors, ListGroupSpreadsheetUploadRowsApiV1GroupsGroupIdSpreadsheetUploadsUploadIdRowsGetResponses, ListGroupSpreadsheetUploadsApiV1GroupsGroupIdSpreadsheetUploadsGetData, ListGroupSpreadsheetUploadsApiV1GroupsGroupIdSpreadsheetUploadsGetErrors, ListGroupSpreadsheetUploadsApiV1GroupsGroupIdSpreadsheetUploadsGetResponses, ListInsurersApiV1InsurersGetData, ListInsurersApiV1InsurersGetErrors, ListInsurersApiV1InsurersGetResponses, ListLayoutsApiV1SnapshotLayoutsGetData, ListLayoutsApiV1SnapshotLayoutsGetErrors, ListLayoutsApiV1SnapshotLayoutsGetResponses, ListMachineClientsApiV1MachineClientsGetData, ListMachineClientsApiV1MachineClientsGetErrors, ListMachineClientsApiV1MachineClientsGetResponses, ListMessagesApiV1MailboxMessagesGetData, ListMessagesApiV1MailboxMessagesGetErrors, ListMessagesApiV1MailboxMessagesGetResponses, ListNoticesApiV1OffCycleNoticesGetData, ListNoticesApiV1OffCycleNoticesGetErrors, ListNoticesApiV1OffCycleNoticesGetResponses, ListNotificationsApiV1NotificationsGetData, ListNotificationsApiV1NotificationsGetErrors, ListNotificationsApiV1NotificationsGetResponses, ListPortalSessionsApiV1EsocialPortalSessionsGetData, ListPortalSessionsApiV1EsocialPortalSessionsGetErrors, ListPortalSessionsApiV1EsocialPortalSessionsGetResponses, ListPortalWalksApiV1EsocialPortalWalksGetData, ListPortalWalksApiV1EsocialPortalWalksGetErrors, ListPortalWalksApiV1EsocialPortalWalksGetResponses, ListSendersApiV1MailboxSendersGetData, ListSendersApiV1MailboxSendersGetErrors, ListSendersApiV1MailboxSendersGetResponses, ListSnapshotsApiV1SnapshotsGetData, ListSnapshotsApiV1SnapshotsGetErrors, ListSnapshotsApiV1SnapshotsGetResponses, ListSpreadsheetUploadAbsencesApiV1ContractsContractIdSpreadsheetUploadsUploadIdAbsencesGetData, ListSpreadsheetUploadAbsencesApiV1ContractsContractIdSpreadsheetUploadsUploadIdAbsencesGetErrors, ListSpreadsheetUploadAbsencesApiV1ContractsContractIdSpreadsheetUploadsUploadIdAbsencesGetResponses, ListSpreadsheetUploadRowsApiV1ContractsContractIdSpreadsheetUploadsUploadIdRowsGetData, ListSpreadsheetUploadRowsApiV1ContractsContractIdSpreadsheetUploadsUploadIdRowsGetErrors, ListSpreadsheetUploadRowsApiV1ContractsContractIdSpreadsheetUploadsUploadIdRowsGetResponses, ListSpreadsheetUploadsApiV1ContractsContractIdSpreadsheetUploadsGetData, ListSpreadsheetUploadsApiV1ContractsContractIdSpreadsheetUploadsGetErrors, ListSpreadsheetUploadsApiV1ContractsContractIdSpreadsheetUploadsGetResponses, ListUsersApiV1UsersGetData, ListUsersApiV1UsersGetErrors, ListUsersApiV1UsersGetResponses, ListWorkerListsApiV1EsocialWorkerListsGetData, ListWorkerListsApiV1EsocialWorkerListsGetErrors, ListWorkerListsApiV1EsocialWorkerListsGetResponses, ListWorkerReportsApiV1EsocialWorkerReportsGetData, ListWorkerReportsApiV1EsocialWorkerReportsGetErrors, ListWorkerReportsApiV1EsocialWorkerReportsGetResponses, LookUpCompanyInsuredPersonApiV1CompaniesCompanyIdInsuredPeopleLookupPostData, LookUpCompanyInsuredPersonApiV1CompaniesCompanyIdInsuredPeopleLookupPostErrors, LookUpCompanyInsuredPersonApiV1CompaniesCompanyIdInsuredPeopleLookupPostResponses, LookUpGroupInsuredPersonApiV1GroupsGroupIdInsuredPeopleLookupPostData, LookUpGroupInsuredPersonApiV1GroupsGroupIdInsuredPeopleLookupPostErrors, LookUpGroupInsuredPersonApiV1GroupsGroupIdInsuredPeopleLookupPostResponses, MachineTokenApiV1AuthMachineTokenPostData, MachineTokenApiV1AuthMachineTokenPostErrors, MachineTokenApiV1AuthMachineTokenPostResponses, MarkAllNotificationsReadApiV1NotificationsReadPostData, MarkAllNotificationsReadApiV1NotificationsReadPostErrors, MarkAllNotificationsReadApiV1NotificationsReadPostResponses, MarkConsolidatedFailedApiV1SubmissionsConsolidatedConsolidatedIdFailedPostData, MarkConsolidatedFailedApiV1SubmissionsConsolidatedConsolidatedIdFailedPostErrors, MarkConsolidatedFailedApiV1SubmissionsConsolidatedConsolidatedIdFailedPostResponses, MarkConsolidatedSentApiV1SubmissionsConsolidatedConsolidatedIdSentPostData, MarkConsolidatedSentApiV1SubmissionsConsolidatedConsolidatedIdSentPostErrors, MarkConsolidatedSentApiV1SubmissionsConsolidatedConsolidatedIdSentPostResponses, MarkGroupFileFailedApiV1SubmissionsGroupFilesGroupFileIdFailedPostData, MarkGroupFileFailedApiV1SubmissionsGroupFilesGroupFileIdFailedPostErrors, MarkGroupFileFailedApiV1SubmissionsGroupFilesGroupFileIdFailedPostResponses, MarkGroupFileSentApiV1SubmissionsGroupFilesGroupFileIdSentPostData, MarkGroupFileSentApiV1SubmissionsGroupFilesGroupFileIdSentPostErrors, MarkGroupFileSentApiV1SubmissionsGroupFilesGroupFileIdSentPostResponses, MarkNoticeFailedApiV1OffCycleNoticesNoticeIdFailedPostData, MarkNoticeFailedApiV1OffCycleNoticesNoticeIdFailedPostErrors, MarkNoticeFailedApiV1OffCycleNoticesNoticeIdFailedPostResponses, MarkNoticeSentApiV1OffCycleNoticesNoticeIdSentPostData, MarkNoticeSentApiV1OffCycleNoticesNoticeIdSentPostErrors, MarkNoticeSentApiV1OffCycleNoticesNoticeIdSentPostResponses, MarkNotificationReadApiV1NotificationsNotificationIdReadPostData, MarkNotificationReadApiV1NotificationsNotificationIdReadPostErrors, MarkNotificationReadApiV1NotificationsNotificationIdReadPostResponses, MarkSubmissionFailedApiV1SubmissionsSubmissionIdFailedPostData, MarkSubmissionFailedApiV1SubmissionsSubmissionIdFailedPostErrors, MarkSubmissionFailedApiV1SubmissionsSubmissionIdFailedPostResponses, MarkSubmissionSentApiV1SubmissionsSubmissionIdSentPostData, MarkSubmissionSentApiV1SubmissionsSubmissionIdSentPostErrors, MarkSubmissionSentApiV1SubmissionsSubmissionIdSentPostResponses, PollMailboxApiV1MailboxPollsPostData, PollMailboxApiV1MailboxPollsPostErrors, PollMailboxApiV1MailboxPollsPostResponses, PrepareConsolidatedApiV1SubmissionsCompaniesCompanyIdInsurersInsurerIdPreparePostData, PrepareConsolidatedApiV1SubmissionsCompaniesCompanyIdInsurersInsurerIdPreparePostErrors, PrepareConsolidatedApiV1SubmissionsCompaniesCompanyIdInsurersInsurerIdPreparePostResponses, PrepareGroupFileApiV1SubmissionsGroupsGroupIdInsurersInsurerIdPreparePostData, PrepareGroupFileApiV1SubmissionsGroupsGroupIdInsurersInsurerIdPreparePostErrors, PrepareGroupFileApiV1SubmissionsGroupsGroupIdInsurersInsurerIdPreparePostResponses, PrepareSubmissionApiV1SubmissionsContractsContractIdPreparePostData, PrepareSubmissionApiV1SubmissionsContractsContractIdPreparePostErrors, PrepareSubmissionApiV1SubmissionsContractsContractIdPreparePostResponses, PreviewCycleApiV1ReviewCyclesContractIdPreviewPostData, PreviewCycleApiV1ReviewCyclesContractIdPreviewPostErrors, PreviewCycleApiV1ReviewCyclesContractIdPreviewPostResponses, ProjectCompanyRosterApiV1CompaniesCompanyIdRosterGetData, ProjectCompanyRosterApiV1CompaniesCompanyIdRosterGetErrors, ProjectCompanyRosterApiV1CompaniesCompanyIdRosterGetResponses, ProjectGroupRosterApiV1GroupsGroupIdRosterGetData, ProjectGroupRosterApiV1GroupsGroupIdRosterGetErrors, ProjectGroupRosterApiV1GroupsGroupIdRosterGetResponses, ProjectRosterApiV1ContractsContractIdRosterGetData, ProjectRosterApiV1ContractsContractIdRosterGetErrors, ProjectRosterApiV1ContractsContractIdRosterGetResponses, ProjectSnapshotApiV1ContractsContractIdSnapshotProjectionGetData, ProjectSnapshotApiV1ContractsContractIdSnapshotProjectionGetErrors, ProjectSnapshotApiV1ContractsContractIdSnapshotProjectionGetResponses, RaiseNoticeApiV1OffCycleNoticesContractsContractIdPostData, RaiseNoticeApiV1OffCycleNoticesContractsContractIdPostErrors, RaiseNoticeApiV1OffCycleNoticesContractsContractIdPostResponses, ReadApprovalsApiV1ReviewCyclesContractIdApprovalsGetData, ReadApprovalsApiV1ReviewCyclesContractIdApprovalsGetErrors, ReadApprovalsApiV1ReviewCyclesContractIdApprovalsGetResponses, ReadCalendarApiV1SubmissionsGetData, ReadCalendarApiV1SubmissionsGetErrors, ReadCalendarApiV1SubmissionsGetResponses, ReadClockApiV1ClockGetData, ReadClockApiV1ClockGetErrors, ReadClockApiV1ClockGetResponses, ReadConsolidatedApiV1SubmissionsConsolidatedConsolidatedIdGetData, ReadConsolidatedApiV1SubmissionsConsolidatedConsolidatedIdGetErrors, ReadConsolidatedApiV1SubmissionsConsolidatedConsolidatedIdGetResponses, ReadConsolidatedStandingApiV1SubmissionsCompaniesCompanyIdInsurersInsurerIdGetData, ReadConsolidatedStandingApiV1SubmissionsCompaniesCompanyIdInsurersInsurerIdGetErrors, ReadConsolidatedStandingApiV1SubmissionsCompaniesCompanyIdInsurersInsurerIdGetResponses, ReadCycleApiV1ReviewCyclesContractIdGetData, ReadCycleApiV1ReviewCyclesContractIdGetErrors, ReadCycleApiV1ReviewCyclesContractIdGetResponses, ReadEligibleApiV1OffCycleNoticesContractsContractIdEligibleGetData, ReadEligibleApiV1OffCycleNoticesContractsContractIdEligibleGetErrors, ReadEligibleApiV1OffCycleNoticesContractsContractIdEligibleGetResponses, ReadGroupFileApiV1SubmissionsGroupFilesGroupFileIdGetData, ReadGroupFileApiV1SubmissionsGroupFilesGroupFileIdGetErrors, ReadGroupFileApiV1SubmissionsGroupFilesGroupFileIdGetResponses, ReadGroupStandingApiV1SubmissionsGroupsGroupIdInsurersInsurerIdGetData, ReadGroupStandingApiV1SubmissionsGroupsGroupIdInsurersInsurerIdGetErrors, ReadGroupStandingApiV1SubmissionsGroupsGroupIdInsurersInsurerIdGetResponses, ReadHistoryApiV1SubmissionsContractsContractIdHistoryGetData, ReadHistoryApiV1SubmissionsContractsContractIdHistoryGetErrors, ReadHistoryApiV1SubmissionsContractsContractIdHistoryGetResponses, ReadLateArrivalsApiV1ReviewCyclesContractIdLateArrivalsGetData, ReadLateArrivalsApiV1ReviewCyclesContractIdLateArrivalsGetErrors, ReadLateArrivalsApiV1ReviewCyclesContractIdLateArrivalsGetResponses, ReadMeApiV1AuthMeGetData, ReadMeApiV1AuthMeGetErrors, ReadMeApiV1AuthMeGetResponses, ReadMovementStatusApiV1ContractsContractIdMovementStatusGetData, ReadMovementStatusApiV1ContractsContractIdMovementStatusGetErrors, ReadMovementStatusApiV1ContractsContractIdMovementStatusGetResponses, ReadNoticeApiV1OffCycleNoticesNoticeIdGetData, ReadNoticeApiV1OffCycleNoticesNoticeIdGetErrors, ReadNoticeApiV1OffCycleNoticesNoticeIdGetResponses, ReadPortalBrowserApiV1EsocialPortalBrowserGetData, ReadPortalBrowserApiV1EsocialPortalBrowserGetErrors, ReadPortalBrowserApiV1EsocialPortalBrowserGetResponses, ReadPortalSessionActionScreenshotApiV1EsocialPortalSessionsSessionIdLoginActionsNumberGetData, ReadPortalSessionActionScreenshotApiV1EsocialPortalSessionsSessionIdLoginActionsNumberGetErrors, ReadPortalSessionActionScreenshotApiV1EsocialPortalSessionsSessionIdLoginActionsNumberGetResponses, ReadPortalSessionApiV1EsocialPortalSessionsSessionIdGetData, ReadPortalSessionApiV1EsocialPortalSessionsSessionIdGetErrors, ReadPortalSessionApiV1EsocialPortalSessionsSessionIdGetResponses, ReadPortalSessionEvidenceApiV1EsocialPortalSessionsSessionIdLoginArtefactGetData, ReadPortalSessionEvidenceApiV1EsocialPortalSessionsSessionIdLoginArtefactGetErrors, ReadPortalSessionEvidenceApiV1EsocialPortalSessionsSessionIdLoginArtefactGetResponses, ReadPortalWalkActionScreenshotApiV1EsocialPortalWalksRunIdStagesIndexActionsNumberGetData, ReadPortalWalkActionScreenshotApiV1EsocialPortalWalksRunIdStagesIndexActionsNumberGetErrors, ReadPortalWalkActionScreenshotApiV1EsocialPortalWalksRunIdStagesIndexActionsNumberGetResponses, ReadPortalWalkApiV1EsocialPortalWalksRunIdGetData, ReadPortalWalkApiV1EsocialPortalWalksRunIdGetErrors, ReadPortalWalkApiV1EsocialPortalWalksRunIdGetResponses, ReadPortalWalkEvidenceApiV1EsocialPortalWalksRunIdStagesIndexArtefactGetData, ReadPortalWalkEvidenceApiV1EsocialPortalWalksRunIdStagesIndexArtefactGetErrors, ReadPortalWalkEvidenceApiV1EsocialPortalWalksRunIdStagesIndexArtefactGetResponses, ReadPreviewApiV1ReviewCyclesContractIdPreviewGetData, ReadPreviewApiV1ReviewCyclesContractIdPreviewGetErrors, ReadPreviewApiV1ReviewCyclesContractIdPreviewGetResponses, ReadProbeEvidenceApiV1EsocialProbesRunIdStepsStepIndexDirectionGetData, ReadProbeEvidenceApiV1EsocialProbesRunIdStepsStepIndexDirectionGetErrors, ReadProbeEvidenceApiV1EsocialProbesRunIdStepsStepIndexDirectionGetResponses, ReadQueueApiV1ReviewQueueGetData, ReadQueueApiV1ReviewQueueGetErrors, ReadQueueApiV1ReviewQueueGetResponses, ReadStandingApiV1SubmissionsContractsContractIdGetData, ReadStandingApiV1SubmissionsContractsContractIdGetErrors, ReadStandingApiV1SubmissionsContractsContractIdGetResponses, ReadSubmissionApiV1SubmissionsSubmissionIdGetData, ReadSubmissionApiV1SubmissionsSubmissionIdGetErrors, ReadSubmissionApiV1SubmissionsSubmissionIdGetResponses, ReadUpcomingApiV1ReviewCyclesContractIdUpcomingGetData, ReadUpcomingApiV1ReviewCyclesContractIdUpcomingGetErrors, ReadUpcomingApiV1ReviewCyclesContractIdUpcomingGetResponses, ReadWorkerListApiV1EsocialWorkerListsListIdGetData, ReadWorkerListApiV1EsocialWorkerListsListIdGetErrors, ReadWorkerListApiV1EsocialWorkerListsListIdGetResponses, ReadWorkerReportApiV1EsocialWorkerReportsReportIdGetData, ReadWorkerReportApiV1EsocialWorkerReportsReportIdGetErrors, ReadWorkerReportApiV1EsocialWorkerReportsReportIdGetResponses, ReadWorkerReportFileApiV1EsocialWorkerReportsReportIdFileGetData, ReadWorkerReportFileApiV1EsocialWorkerReportsReportIdFileGetErrors, ReadWorkerReportFileApiV1EsocialWorkerReportsReportIdFileGetResponses, RecordSnapshotSubmissionApiV1ContractsContractIdSnapshotSubmissionsPostData, RecordSnapshotSubmissionApiV1ContractsContractIdSnapshotSubmissionsPostErrors, RecordSnapshotSubmissionApiV1ContractsContractIdSnapshotSubmissionsPostResponses, RefreshSessionApiV1AuthRefreshPostData, RefreshSessionApiV1AuthRefreshPostErrors, RefreshSessionApiV1AuthRefreshPostResponses, RegisterSenderApiV1MailboxSendersPostData, RegisterSenderApiV1MailboxSendersPostErrors, RegisterSenderApiV1MailboxSendersPostResponses, RejectDeltaApiV1DeltasDeltaIdRejectPostData, RejectDeltaApiV1DeltasDeltaIdRejectPostErrors, RejectDeltaApiV1DeltasDeltaIdRejectPostResponses, RejectItemApiV1ReviewItemsDeltaIdRejectPostData, RejectItemApiV1ReviewItemsDeltaIdRejectPostErrors, RejectItemApiV1ReviewItemsDeltaIdRejectPostResponses, RememberTableColumnsApiV1AuthMeTableColumnsTableIdPutData, RememberTableColumnsApiV1AuthMeTableColumnsTableIdPutErrors, RememberTableColumnsApiV1AuthMeTableColumnsTableIdPutResponses, RenameGroupApiV1GroupsGroupIdPatchData, RenameGroupApiV1GroupsGroupIdPatchErrors, RenameGroupApiV1GroupsGroupIdPatchResponses, ReopenCycleApiV1ReviewCyclesContractIdReopenPostData, ReopenCycleApiV1ReviewCyclesContractIdReopenPostErrors, ReopenCycleApiV1ReviewCyclesContractIdReopenPostResponses, RequestWorkerReportApiV1EsocialWorkerReportsPostData, RequestWorkerReportApiV1EsocialWorkerReportsPostErrors, RequestWorkerReportApiV1EsocialWorkerReportsPostResponses, RetryMessageApiV1MailboxMessagesMessageIdRetryPostData, RetryMessageApiV1MailboxMessagesMessageIdRetryPostErrors, RetryMessageApiV1MailboxMessagesMessageIdRetryPostResponses, ReturnItemApiV1ReviewItemsDeltaIdReturnPostData, ReturnItemApiV1ReviewItemsDeltaIdReturnPostErrors, ReturnItemApiV1ReviewItemsDeltaIdReturnPostResponses, RevokeMachineClientApiV1MachineClientsMachineClientIdRevocationPostData, RevokeMachineClientApiV1MachineClientsMachineClientIdRevocationPostErrors, RevokeMachineClientApiV1MachineClientsMachineClientIdRevocationPostResponses, RevokeSenderApiV1MailboxSendersSenderIdRevocationPostData, RevokeSenderApiV1MailboxSendersSenderIdRevocationPostErrors, RevokeSenderApiV1MailboxSendersSenderIdRevocationPostResponses, RotateMachineClientApiV1MachineClientsMachineClientIdRotationPostData, RotateMachineClientApiV1MachineClientsMachineClientIdRotationPostErrors, RotateMachineClientApiV1MachineClientsMachineClientIdRotationPostResponses, RunDiagnosticsApiV1EsocialDiagnosticsPostData, RunDiagnosticsApiV1EsocialDiagnosticsPostErrors, RunDiagnosticsApiV1EsocialDiagnosticsPostResponses, RunPortalSessionApiV1EsocialPortalSessionsPostData, RunPortalSessionApiV1EsocialPortalSessionsPostErrors, RunPortalSessionApiV1EsocialPortalSessionsPostResponses, RunPortalWalkApiV1EsocialPortalWalksPostData, RunPortalWalkApiV1EsocialPortalWalksPostErrors, RunPortalWalkApiV1EsocialPortalWalksPostResponses, RunProbeApiV1EsocialProbesPostData, RunProbeApiV1EsocialProbesPostErrors, RunProbeApiV1EsocialProbesPostResponses, SelectCompanyApiV1AuthMeSelectedCompanyPutData, SelectCompanyApiV1AuthMeSelectedCompanyPutErrors, SelectCompanyApiV1AuthMeSelectedCompanyPutResponses, SetClockApiV1ClockPutData, SetClockApiV1ClockPutErrors, SetClockApiV1ClockPutResponses, SetCompanyCnpjApiV1CompaniesCompanyIdCnpjPostData, SetCompanyCnpjApiV1CompaniesCompanyIdCnpjPostErrors, SetCompanyCnpjApiV1CompaniesCompanyIdCnpjPostResponses, SetCompanyFileNameLabelApiV1CompaniesCompanyIdFileNameLabelPostData, SetCompanyFileNameLabelApiV1CompaniesCompanyIdFileNameLabelPostErrors, SetCompanyFileNameLabelApiV1CompaniesCompanyIdFileNameLabelPostResponses, SetCompanyGroupApiV1CompaniesCompanyIdGroupPutData, SetCompanyGroupApiV1CompaniesCompanyIdGroupPutErrors, SetCompanyGroupApiV1CompaniesCompanyIdGroupPutResponses, SetCompanyTerminationDocumentPolicyApiV1CompaniesCompanyIdTerminationDocumentPolicyPutData, SetCompanyTerminationDocumentPolicyApiV1CompaniesCompanyIdTerminationDocumentPolicyPutErrors, SetCompanyTerminationDocumentPolicyApiV1CompaniesCompanyIdTerminationDocumentPolicyPutResponses, SetGroupFileNameLabelApiV1GroupsGroupIdFileNameLabelPostData, SetGroupFileNameLabelApiV1GroupsGroupIdFileNameLabelPostErrors, SetGroupFileNameLabelApiV1GroupsGroupIdFileNameLabelPostResponses, SetInsurerLayoutApiV1InsurersInsurerIdLayoutPutData, SetInsurerLayoutApiV1InsurersInsurerIdLayoutPutErrors, SetInsurerLayoutApiV1InsurersInsurerIdLayoutPutResponses, SetInsurerValuesApiV1ContractsContractIdInsuredPeopleInsuredPersonIdInsurerValuesPatchData, SetInsurerValuesApiV1ContractsContractIdInsuredPeopleInsuredPersonIdInsurerValuesPatchErrors, SetInsurerValuesApiV1ContractsContractIdInsuredPeopleInsuredPersonIdInsurerValuesPatchResponses, SignInApiV1AuthTokenPostData, SignInApiV1AuthTokenPostErrors, SignInApiV1AuthTokenPostResponses, SignOutApiV1AuthLogoutPostData, SignOutApiV1AuthLogoutPostErrors, SignOutApiV1AuthLogoutPostResponses, SubmitDeltaApiV1ContractsContractIdDeltasPostData, SubmitDeltaApiV1ContractsContractIdDeltasPostErrors, SubmitDeltaApiV1ContractsContractIdDeltasPostResponses, SubmitDeltasInBulkApiV1ContractsContractIdDeltasBulkPostData, SubmitDeltasInBulkApiV1ContractsContractIdDeltasBulkPostErrors, SubmitDeltasInBulkApiV1ContractsContractIdDeltasBulkPostResponses, SupersedeDocumentApiV1DocumentsDocumentIdSupersedePostData, SupersedeDocumentApiV1DocumentsDocumentIdSupersedePostErrors, SupersedeDocumentApiV1DocumentsDocumentIdSupersedePostResponses, UnlinkDocumentApiV1DocumentsDocumentIdLinksDeltaIdDeleteData, UnlinkDocumentApiV1DocumentsDocumentIdLinksDeltaIdDeleteErrors, UnlinkDocumentApiV1DocumentsDocumentIdLinksDeltaIdDeleteResponses, UpdateContractApiV1ContractsContractIdPatchData, UpdateContractApiV1ContractsContractIdPatchErrors, UpdateContractApiV1ContractsContractIdPatchResponses, UploadCertificateApiV1CertificatesPostData, UploadCertificateApiV1CertificatesPostErrors, UploadCertificateApiV1CertificatesPostResponses, UploadCompanySpreadsheetApiV1CompaniesCompanyIdSpreadsheetUploadsPostData, UploadCompanySpreadsheetApiV1CompaniesCompanyIdSpreadsheetUploadsPostErrors, UploadCompanySpreadsheetApiV1CompaniesCompanyIdSpreadsheetUploadsPostResponses, UploadDocumentApiV1DocumentsPostData, UploadDocumentApiV1DocumentsPostErrors, UploadDocumentApiV1DocumentsPostResponses, UploadGroupSpreadsheetApiV1GroupsGroupIdSpreadsheetUploadsPostData, UploadGroupSpreadsheetApiV1GroupsGroupIdSpreadsheetUploadsPostErrors, UploadGroupSpreadsheetApiV1GroupsGroupIdSpreadsheetUploadsPostResponses, UploadSpreadsheetApiV1ContractsContractIdSpreadsheetUploadsPostData, UploadSpreadsheetApiV1ContractsContractIdSpreadsheetUploadsPostErrors, UploadSpreadsheetApiV1ContractsContractIdSpreadsheetUploadsPostResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Read the audit trail
 *
 * The append-only record of who changed what, when and through which channel, most recent first.
 *
 * **Scope.** A customer principal reads its own company's entries and nothing else; naming another company with `X-Company-Id` is refused with `403`. vyttech staff read across every company by default, or inside one by sending the same header. Entries that belong to no tenant -- an insurer, a vyttech staff account, a sign-in attempt we could not attribute to a company -- are visible to staff only.
 *
 * **Filters.** By entity (`entity_type`, and `entity_id` for one record's whole history), by action, by time range, by the correlation id a single request's entries share, and by actor. `occurred_from` is inclusive and `occurred_to` is exclusive, so adjacent ranges neither overlap nor leave a gap.
 *
 * **Values.** `changes` carries each changed field with its value before and after. They are encrypted at rest with the same envelope the roster uses and are decrypted only to build this response.
 */
export const listAuditEntriesApiV1AuditEntriesGet = <ThrowOnError extends boolean = false>(options?: Options<ListAuditEntriesApiV1AuditEntriesGetData, ThrowOnError>): RequestResult<ListAuditEntriesApiV1AuditEntriesGetResponses, ListAuditEntriesApiV1AuditEntriesGetErrors, ThrowOnError> => (options?.client ?? client).get<ListAuditEntriesApiV1AuditEntriesGetResponses, ListAuditEntriesApiV1AuditEntriesGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/audit-entries',
    ...options
});

/**
 * End a browser session and clear its refresh cookie
 *
 * Revokes the session the refresh cookie names and clears the cookie. Always `204`, whether or not the cookie named a session we still believed in: signing out has one outcome, and an endpoint that reported which cookies were real would answer the one question the holder of a stolen one wants answered.
 *
 * It needs no access token -- an expired one is exactly when somebody wants to sign out -- and takes no request body.
 */
export const signOutApiV1AuthLogoutPost = <ThrowOnError extends boolean = false>(options?: Options<SignOutApiV1AuthLogoutPostData, ThrowOnError>): RequestResult<SignOutApiV1AuthLogoutPostResponses, SignOutApiV1AuthLogoutPostErrors, ThrowOnError> => (options?.client ?? client).post<SignOutApiV1AuthLogoutPostResponses, SignOutApiV1AuthLogoutPostErrors, ThrowOnError>({ url: '/api/v1/auth/logout', ...options });

/**
 * Exchange machine client credentials for a token
 *
 * Exchanges an issued client id and client secret for an access token scoped to exactly one customer company -- the company the credential was issued for. Nothing in the request can widen that scope.
 *
 * Credentials are issued and revoked by vyttech staff. A revoked credential is refused here, and a token already issued to it stops working on its next request.
 *
 * No cookie is set: a machine client has no browser and nothing to reload, and comes back here for a fresh token whenever it needs one.
 */
export const machineTokenApiV1AuthMachineTokenPost = <ThrowOnError extends boolean = false>(options: Options<MachineTokenApiV1AuthMachineTokenPostData, ThrowOnError>): RequestResult<MachineTokenApiV1AuthMachineTokenPostResponses, MachineTokenApiV1AuthMachineTokenPostErrors, ThrowOnError> => (options.client ?? client).post<MachineTokenApiV1AuthMachineTokenPostResponses, MachineTokenApiV1AuthMachineTokenPostErrors, ThrowOnError>({
    url: '/api/v1/auth/machine/token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The principal resolved for this request
 *
 * Returns who the server decided the caller is: kind, role, company and the full set of permissions the role carries. A client can render its own navigation from this rather than decoding the token.
 */
export const readMeApiV1AuthMeGet = <ThrowOnError extends boolean = false>(options?: Options<ReadMeApiV1AuthMeGetData, ThrowOnError>): RequestResult<ReadMeApiV1AuthMeGetResponses, ReadMeApiV1AuthMeGetErrors, ThrowOnError> => (options?.client ?? client).get<ReadMeApiV1AuthMeGetResponses, ReadMeApiV1AuthMeGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/auth/me',
    ...options
});

/**
 * Remember the company the customer portal opens on
 *
 * Records the company the signed-in customer user has just chosen, so that the portal opens on it next time -- after a reload, after signing in again, or on another browser. It comes back as `selected_company` on the principal from `POST /auth/token`, `POST /auth/refresh` and `GET /auth/me`, for as long as the user may still act for that company.
 *
 * It changes no scope: every company-scoped request still names its company in `X-Company-Id`, checked on every call.
 *
 * `company_id` must be one of the companies the user may act for -- for a user registered at a company group, an active company currently in the group; for anyone else, their own company. Any other is `403` and the stored choice is left as it was. vyttech staff and machine clients have no portal to open and are refused with `403`. Returns the updated principal.
 */
export const selectCompanyApiV1AuthMeSelectedCompanyPut = <ThrowOnError extends boolean = false>(options: Options<SelectCompanyApiV1AuthMeSelectedCompanyPutData, ThrowOnError>): RequestResult<SelectCompanyApiV1AuthMeSelectedCompanyPutResponses, SelectCompanyApiV1AuthMeSelectedCompanyPutErrors, ThrowOnError> => (options.client ?? client).put<SelectCompanyApiV1AuthMeSelectedCompanyPutResponses, SelectCompanyApiV1AuthMeSelectedCompanyPutErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/auth/me/selected-company',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remember the columns hidden in one table of the web app
 *
 * Records which columns the signed-in user has hidden in one table of the web app, so the table opens the same way next time -- after a reload, after signing in again, or on another browser. It comes back as `hidden_columns` on the principal from `POST /auth/token`, `POST /auth/refresh` and `GET /auth/me`.
 *
 * `table_id` is a short lowercase slug naming the table, the same for every record it shows. `hidden` replaces whatever was stored for that table; an empty list clears the entry. A malformed table id, a malformed or over-long key, more than 48 keys, or a preference for more than 100 tables is `422`.
 *
 * Any signed-in person may call it; machine clients have no screen and are refused with `403`. A display preference, so nothing is written to the audit trail. Returns the updated principal.
 */
export const rememberTableColumnsApiV1AuthMeTableColumnsTableIdPut = <ThrowOnError extends boolean = false>(options: Options<RememberTableColumnsApiV1AuthMeTableColumnsTableIdPutData, ThrowOnError>): RequestResult<RememberTableColumnsApiV1AuthMeTableColumnsTableIdPutResponses, RememberTableColumnsApiV1AuthMeTableColumnsTableIdPutErrors, ThrowOnError> => (options.client ?? client).put<RememberTableColumnsApiV1AuthMeTableColumnsTableIdPutResponses, RememberTableColumnsApiV1AuthMeTableColumnsTableIdPutErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/auth/me/table-columns/{table_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Renew a browser session from its refresh cookie
 *
 * Exchanges the refresh cookie set at sign-in for a fresh access token, and replaces the cookie with the next one in the chain. The response body is the one `POST /auth/token` returns, so a client that has just reloaded ends up in the same state as one that has just signed in.
 *
 * Send it with credentials included; it takes no request body and reads nothing but the cookie.
 *
 * **Each refresh token is good once.** Presenting one that has already been exchanged revokes the whole session, on the basis that two parties holding one cookie is a stolen cookie and there is no way to tell from here which of them is the person. A missing, expired, revoked or already-used cookie is the same `401` with the same message.
 *
 * Machine clients have no session to renew: they exchange their credentials at `POST /auth/machine/token` whenever they need a token.
 */
export const refreshSessionApiV1AuthRefreshPost = <ThrowOnError extends boolean = false>(options?: Options<RefreshSessionApiV1AuthRefreshPostData, ThrowOnError>): RequestResult<RefreshSessionApiV1AuthRefreshPostResponses, RefreshSessionApiV1AuthRefreshPostErrors, ThrowOnError> => (options?.client ?? client).post<RefreshSessionApiV1AuthRefreshPostResponses, RefreshSessionApiV1AuthRefreshPostErrors, ThrowOnError>({ url: '/api/v1/auth/refresh', ...options });

/**
 * Sign in with an email address and password
 *
 * Exchanges a human user's email address and password for a session token. Present the token as `Authorization: Bearer <access_token>` on every other request.
 *
 * A rejected sign-in never says which part was wrong, so the endpoint cannot be used to discover which addresses are registered.
 *
 * The response also sets a refresh cookie -- `HttpOnly`, `Secure`, `SameSite=Strict`, scoped to `/api/v1/auth` and with no `Max-Age`, so it lasts exactly as long as the browser stays open. A browser client sends it back to `POST /auth/refresh` to survive a page reload without keeping the access token anywhere it could be read. Non-browser callers can ignore it: it is not needed to use the API, and machine clients are not issued one.
 */
export const signInApiV1AuthTokenPost = <ThrowOnError extends boolean = false>(options: Options<SignInApiV1AuthTokenPostData, ThrowOnError>): RequestResult<SignInApiV1AuthTokenPostResponses, SignInApiV1AuthTokenPostErrors, ThrowOnError> => (options.client ?? client).post<SignInApiV1AuthTokenPostResponses, SignInApiV1AuthTokenPostErrors, ThrowOnError>({
    url: '/api/v1/auth/token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the installed A1 certificates
 *
 * Every certificate the platform holds, newest upload first. vyttech administrators only.
 *
 * Superseded, deactivated and expired ones are included: "what did we sign April's filings with?" is a question about a certificate that is no longer current. `status` says which is which, and is derived on every read rather than stored -- so a certificate that expired an hour ago says so.
 *
 * **Metadata only.** No response in this router carries the archive, the private key or the password.
 */
export const listCertificatesApiV1CertificatesGet = <ThrowOnError extends boolean = false>(options?: Options<ListCertificatesApiV1CertificatesGetData, ThrowOnError>): RequestResult<ListCertificatesApiV1CertificatesGetResponses, ListCertificatesApiV1CertificatesGetErrors, ThrowOnError> => (options?.client ?? client).get<ListCertificatesApiV1CertificatesGetResponses, ListCertificatesApiV1CertificatesGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/certificates',
    ...options
});

/**
 * Install an A1 certificate
 *
 * Uploads a PKCS#12 archive and the password that opens it. vyttech administrators only.
 *
 * **The archive is opened before anything is stored.** A file that is not PKCS#12 is `415`; a password that does not open it is `422`; an archive without both a private key and its certificate is `422`; and a certificate whose subject carries no CNPJ is `422`, because it is not an e-CNPJ certificate and cannot file with eSocial. None of the four creates a row.
 *
 * Each refusal names what is at fault in `details[].field`, so a client can say which of the four it was in its own words: `file` for bytes that are not a PKCS#12 archive (or are empty, or too large), `password` for a password that does not open one, `certificate` for an archive missing a half of the credential, and `subject_cnpj` for a certificate that carries no CNPJ.
 *
 * The response is metadata read out of the certificate itself -- holder, CNPJ, validity window, fingerprint. **The archive and the password are not in it, and there is no endpoint that returns either.**
 *
 * **Uploading a certificate for a CNPJ that already has one replaces it.** The previous certificate is marked `superseded`, both rows are kept, and `supersedes_certificate_id` on this response names what was replaced. Certificates for different CNPJs coexist untouched: this store is deliberately not a singleton.
 */
export const uploadCertificateApiV1CertificatesPost = <ThrowOnError extends boolean = false>(options: Options<UploadCertificateApiV1CertificatesPostData, ThrowOnError>): RequestResult<UploadCertificateApiV1CertificatesPostResponses, UploadCertificateApiV1CertificatesPostErrors, ThrowOnError> => (options.client ?? client).post<UploadCertificateApiV1CertificatesPostResponses, UploadCertificateApiV1CertificatesPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/certificates',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Fetch one installed A1 certificate
 *
 * One certificate's metadata, by its own identifier. vyttech administrators only. Carries no more than the listing does: there is no detail view of the archive, the key or the password anywhere in this API.
 */
export const getCertificateApiV1CertificatesCertificateIdGet = <ThrowOnError extends boolean = false>(options: Options<GetCertificateApiV1CertificatesCertificateIdGetData, ThrowOnError>): RequestResult<GetCertificateApiV1CertificatesCertificateIdGetResponses, GetCertificateApiV1CertificatesCertificateIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetCertificateApiV1CertificatesCertificateIdGetResponses, GetCertificateApiV1CertificatesCertificateIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/certificates/{certificate_id}',
    ...options
});

/**
 * Stop using an A1 certificate
 *
 * Takes a certificate out of service without replacing it. vyttech administrators only.
 *
 * For the case a replacement does not cover: a key believed to have leaked, where waiting for the authority to issue a successor is not an option. To *replace* a certificate, upload the new one instead: the upload marks its predecessor superseded on its own.
 *
 * The row is kept, as every row in this store is; nothing here deletes anything. Stopping an already-stopped certificate is a no-op with the same response, so a retry is safe. Stopping one that has already been superseded is `409`: it is already out of service, and reporting a change that did not happen would be worse than the refusal.
 */
export const deactivateCertificateApiV1CertificatesCertificateIdDeactivationPost = <ThrowOnError extends boolean = false>(options: Options<DeactivateCertificateApiV1CertificatesCertificateIdDeactivationPostData, ThrowOnError>): RequestResult<DeactivateCertificateApiV1CertificatesCertificateIdDeactivationPostResponses, DeactivateCertificateApiV1CertificatesCertificateIdDeactivationPostErrors, ThrowOnError> => (options.client ?? client).post<DeactivateCertificateApiV1CertificatesCertificateIdDeactivationPostResponses, DeactivateCertificateApiV1CertificatesCertificateIdDeactivationPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/certificates/{certificate_id}/deactivation',
    ...options
});

/**
 * Return the deployment to the real clock
 *
 * vyttech staff only. Removes the stored offset, so every part of this deployment reads the machine's clock again from the next request onwards.
 *
 * Succeeds whether or not a simulation was running, and records the attempt either way — what an operator pressed is worth knowing even when it turned out to change nothing.
 */
export const clearClockApiV1ClockDelete = <ThrowOnError extends boolean = false>(options?: Options<ClearClockApiV1ClockDeleteData, ThrowOnError>): RequestResult<ClearClockApiV1ClockDeleteResponses, ClearClockApiV1ClockDeleteErrors, ThrowOnError> => (options?.client ?? client).delete<ClearClockApiV1ClockDeleteResponses, ClearClockApiV1ClockDeleteErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/clock',
    ...options
});

/**
 * Read the deployment's clock
 *
 * Any signed-in person, customers included: a clock somebody moved is moved for every tenant on the deployment, so everyone working under it is entitled to be told. Moving it is another matter — see `PUT`.
 *
 * The real instant, the instant the rest of this deployment believes it to be, and whether the two differ because somebody moved it.
 *
 * This resource is not registered in production: there, this path is a `404`, and a client should read that as *no simulation here* rather than as an error.
 */
export const readClockApiV1ClockGet = <ThrowOnError extends boolean = false>(options?: Options<ReadClockApiV1ClockGetData, ThrowOnError>): RequestResult<ReadClockApiV1ClockGetResponses, ReadClockApiV1ClockGetErrors, ThrowOnError> => (options?.client ?? client).get<ReadClockApiV1ClockGetResponses, ReadClockApiV1ClockGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/clock',
    ...options
});

/**
 * Set the simulated current datetime
 *
 * vyttech staff only. Moves this deployment's clock to the instant given and leaves it running from there.
 *
 * What is stored is the **difference** from the real clock, in one row shared by the whole deployment — so the simulation survives a restart, every worker and every background script sees the same one, and simulated time goes on advancing rather than standing still.
 *
 * A naive `simulated_now` is read as São Paulo wall-clock time. Repeating the call replaces the offset rather than compounding it: the new one is always measured from the real clock.
 *
 * Session and refresh-token expiry deliberately keep the real clock, so moving the clock a year ahead does not sign the caller out.
 */
export const setClockApiV1ClockPut = <ThrowOnError extends boolean = false>(options: Options<SetClockApiV1ClockPutData, ThrowOnError>): RequestResult<SetClockApiV1ClockPutResponses, SetClockApiV1ClockPutErrors, ThrowOnError> => (options.client ?? client).put<SetClockApiV1ClockPutResponses, SetClockApiV1ClockPutErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/clock',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List customer companies
 *
 * vyttech staff see every company. A customer or machine principal sees only its own, so the same call is safe to make from any client. A user registered at a company group sees the active companies currently in its group -- the ones it may act for.
 *
 * Every parameter is optional, and a call with none of them returns every company in scope, by name, unpaged. The filters narrow that scope and never widen it: a customer searching finds itself or nothing. Each filter narrows what the others leave, `q` included. In every text filter the match is case-insensitive and anywhere in the column, `%` and `_` are matched as themselves, and blank is the same as absent.
 *
 * * `q` -- free text, matched anywhere in the name or the slug, and in the CNPJ once dots, slashes, dashes and spaces are taken out of it (`12.345.678/0001` finds `12345678000195`).
 * * `name` -- text the name contains.
 * * `slug` -- text the slug contains.
 * * `cnpj` -- digits the CNPJ contains, once dots, slashes, dashes and spaces are taken out (`12.345.678` finds `12345678000195`). Text that is nothing but punctuation matches no company.
 * * `group` -- text the name of the company's economic group contains. A company in no group never matches, so with `without_group=true` the list is empty.
 * * `without_group=true` -- only companies in no economic group. `false` applies no group filter.
 * * `created_from` and `created_to` -- only companies created on those calendar days in São Paulo or between them, both inclusive. Either may be sent alone; `created_from` after `created_to` is a `422`.
 * * `sort` -- `name` (the default), `slug`, `cnpj`, `group` (the group's name) or `created_at`, and `direction` -- `asc` (the default) or `desc`. Companies with no CNPJ, or in no group, come last in either direction. Ties are broken by name and then by identifier, both ascending, so the order is the same on every page and paging never repeats or skips a company. Any other value of either is a `422`.
 * * `limit` (1 to 200) and `offset` -- one page of the result. With no `limit` the list is not paged and `offset` is ignored.
 *
 * `count` is how many companies match across every page, so with no `limit` it is the number of `items`.
 *
 * `order`, which this list took before `sort` and `direction` replaced it, is refused with a `422` rather than ignored.
 */
export const listCompaniesApiV1CompaniesGet = <ThrowOnError extends boolean = false>(options?: Options<ListCompaniesApiV1CompaniesGetData, ThrowOnError>): RequestResult<ListCompaniesApiV1CompaniesGetResponses, ListCompaniesApiV1CompaniesGetErrors, ThrowOnError> => (options?.client ?? client).get<ListCompaniesApiV1CompaniesGetResponses, ListCompaniesApiV1CompaniesGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/companies',
    ...options
});

/**
 * Create a customer company
 *
 * Creates a tenant. vyttech staff only; customers do not create companies.
 *
 * The CNPJ is required and validated: a number whose check digits do not match is a `422` saying so, and one that already belongs to another company is a `409` naming that company.
 *
 * `slug` is optional. Left out, it is derived from `name` -- `Indústria Têxtil Ação & Cia.` becomes `industria-textil-acao-cia` -- and a name another company already turned into that slug gets `-2`, then `-3`, and so on, so registering a second company of the same name succeeds. A name with no letter or digit in it is a `422` on `name`; send `slug` explicitly for such a company. An explicit slug is stored as given and one that already exists is a `409` naming it. When the CNPJ and the slug both collide, the `409` names the CNPJ. The response, and the audit entry, carry the slug that was stored.
 */
export const createCompanyApiV1CompaniesPost = <ThrowOnError extends boolean = false>(options: Options<CreateCompanyApiV1CompaniesPostData, ThrowOnError>): RequestResult<CreateCompanyApiV1CompaniesPostResponses, CreateCompanyApiV1CompaniesPostErrors, ThrowOnError> => (options.client ?? client).post<CreateCompanyApiV1CompaniesPostResponses, CreateCompanyApiV1CompaniesPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/companies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fetch a customer company
 *
 * A principal that does not belong to this company receives `404`, whether or not the company exists: the response does not confirm the identifier.
 */
export const getCompanyApiV1CompaniesCompanyIdGet = <ThrowOnError extends boolean = false>(options: Options<GetCompanyApiV1CompaniesCompanyIdGetData, ThrowOnError>): RequestResult<GetCompanyApiV1CompaniesCompanyIdGetResponses, GetCompanyApiV1CompaniesCompanyIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetCompanyApiV1CompaniesCompanyIdGetResponses, GetCompanyApiV1CompaniesCompanyIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/companies/{company_id}',
    ...options
});

/**
 * Import a company's baseline population across its contracts
 *
 * Loads the population already insured under several of this company's contracts from one sheet, effective from `baseline_date` or from each row's own coverage start. vyttech staff only; the company is the one in the path, so `X-Company-Id` is not needed and, if sent, must name the same company.
 *
 * The source is the sheet customers hand over: an `.xlsx` workbook (its first sheet) or a CSV in the legacy layout -- Subestipulante, Módulo, Nome, Data de nascimento, CPF, Salário, INCLUSAO, EXCLUSÃO, ALTERAÇÃO SALARIO. `Subestipulante`, the name, birth date, CPF and salary columns are required; the rest are optional, and extra columns are ignored. The spellings, encodings, dates and amounts the per-contract import accepts are accepted here too, as are a CPF that a number cell stripped of its leading zeros, a company name typed alone on a line between blocks of people (skipped) and blank trailing columns. A pre-2007 `.xls` is refused with a request to save it as `.xlsx` or `.csv`.
 *
 * **Each row goes to the contract its Subestipulante names.** A filled Módulo must be that contract's; a blank one asserts nothing. A Subestipulante that names no contract of the company, or several that Módulo does not tell apart, is a problem with that row.
 *
 * **Coverage may start per row.** An optional `Início da cobertura` column (also read as `coverage_start`, `Data de início da cobertura`, `Data início` and similar spellings) gives each person the date their coverage and salary start; a filled cell wins over `baseline_date`, and a blank cell or a file without the column uses `baseline_date`. A start before the person's birth date, or a cell that is not a date, is a problem with that row. `Data de vigência` is not this column, and is ignored like any extra column.
 *
 * **The file states who is insured on its dates.** A row marked in EXCLUSÃO is a problem -- the person should not be in it. Marks in INCLUSAO or ALTERAÇÃO SALARIO are ignored and the row is loaded like any other.
 *
 * **Nothing is imported unless everything can be**, across every contract. A bad CPF, an unreadable or implausible birth date or coverage start, an empty required cell, an unreadable salary, or a CPF repeated under the same contract rejects the whole file with `422` and one `details` entry per problem, naming the row and column and quoting nothing from the file. The same CPF under two contracts is two roster entries and is accepted.
 *
 * If any contract the file touches has moved on -- an admission, a termination, a snapshot already sent, or coverage or a salary on a date the file does not carry -- the whole file is refused with `409`, with one `details` entry per such contract naming its subestipulante and módulo, and proceeds only when `override` is set.
 *
 * Each contract that received rows gets its own baseline import record, holding the whole file, so the per-contract history, detail and source download read it like any other import. Re-running the same file writes nothing new and reports every row as `already_present`.
 */
export const importCompanyBaselineApiV1CompaniesCompanyIdBaselineImportsPost = <ThrowOnError extends boolean = false>(options: Options<ImportCompanyBaselineApiV1CompaniesCompanyIdBaselineImportsPostData, ThrowOnError>): RequestResult<ImportCompanyBaselineApiV1CompaniesCompanyIdBaselineImportsPostResponses, ImportCompanyBaselineApiV1CompaniesCompanyIdBaselineImportsPostErrors, ThrowOnError> => (options.client ?? client).post<ImportCompanyBaselineApiV1CompaniesCompanyIdBaselineImportsPostResponses, ImportCompanyBaselineApiV1CompaniesCompanyIdBaselineImportsPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/companies/{company_id}/baseline-imports',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Set or correct a company's CNPJ
 *
 * Establishes the registry number of a company that predates the field, or replaces one that was recorded wrongly. vyttech staff only: a customer cannot restate who its own employer is to us.
 *
 * A sub-resource rather than a general company `PATCH` because this is not an edit of a label -- it is the key eSocial and the insurers file this employer under, so it gets its own permission surface and its own entry in the trail (`company.cnpj_set`), carrying the number before and the number after.
 *
 * Restating the CNPJ a company already has succeeds and records nothing: nothing changed. A number that belongs to another company is a `409` naming it, exactly as creating a company with it would be.
 */
export const setCompanyCnpjApiV1CompaniesCompanyIdCnpjPost = <ThrowOnError extends boolean = false>(options: Options<SetCompanyCnpjApiV1CompaniesCompanyIdCnpjPostData, ThrowOnError>): RequestResult<SetCompanyCnpjApiV1CompaniesCompanyIdCnpjPostResponses, SetCompanyCnpjApiV1CompaniesCompanyIdCnpjPostErrors, ThrowOnError> => (options.client ?? client).post<SetCompanyCnpjApiV1CompaniesCompanyIdCnpjPostResponses, SetCompanyCnpjApiV1CompaniesCompanyIdCnpjPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/companies/{company_id}/cnpj',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set or clear a company's insurer file-name label
 *
 * Sets what insurer file names carry in place of the company's registered name -- `Actega` for a company registered as `ACTEGA` -- or, with `null`, clears it. The registered name stays what the app displays everywhere; only file names change. vyttech staff only.
 *
 * A file name uses the company's own label, otherwise its group's label, otherwise the registered name; `file_name_label_in_force` on the response says which label that is. Case is kept as typed and each space becomes an underscore. Letters, digits, `_`, `-` and spaces only, at most 100 characters; anything else, or a blank value, is a `422` on `file_name_label` and nothing is stored.
 *
 * Restating the current label succeeds and records nothing; a real change is in the trail as `company.file_name_label_set`, with the label before and after. Files already generated keep their names; a draft month regenerated afterwards picks up the label.
 */
export const setCompanyFileNameLabelApiV1CompaniesCompanyIdFileNameLabelPost = <ThrowOnError extends boolean = false>(options: Options<SetCompanyFileNameLabelApiV1CompaniesCompanyIdFileNameLabelPostData, ThrowOnError>): RequestResult<SetCompanyFileNameLabelApiV1CompaniesCompanyIdFileNameLabelPostResponses, SetCompanyFileNameLabelApiV1CompaniesCompanyIdFileNameLabelPostErrors, ThrowOnError> => (options.client ?? client).post<SetCompanyFileNameLabelApiV1CompaniesCompanyIdFileNameLabelPostResponses, SetCompanyFileNameLabelApiV1CompaniesCompanyIdFileNameLabelPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/companies/{company_id}/file-name-label',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set, move or clear a company's economic group
 *
 * Puts the company in the *grupo econômico* `group_id` names, moves it there from the group it was in, or -- with `null` -- takes it out of its group. A company is in at most one group, so assigning a second one is a move. vyttech staff only.
 *
 * A group that does not exist is a `404` and changes nothing. Naming the group the company is already in succeeds and records nothing. Each change is in the trail as `company.group_assigned`, `company.group_moved` or `company.group_removed`, with the group before and the group after.
 *
 * Membership changes nobody's access: a customer of a grouped company still sees only its own company.
 */
export const setCompanyGroupApiV1CompaniesCompanyIdGroupPut = <ThrowOnError extends boolean = false>(options: Options<SetCompanyGroupApiV1CompaniesCompanyIdGroupPutData, ThrowOnError>): RequestResult<SetCompanyGroupApiV1CompaniesCompanyIdGroupPutResponses, SetCompanyGroupApiV1CompaniesCompanyIdGroupPutErrors, ThrowOnError> => (options.client ?? client).put<SetCompanyGroupApiV1CompaniesCompanyIdGroupPutResponses, SetCompanyGroupApiV1CompaniesCompanyIdGroupPutErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/companies/{company_id}/group',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Find one person by CPF across a company's contracts
 *
 * The person with this CPF under every contract in scope that carries them, covered today or not, each entry saying whether it is `covered_today` (in America/Sao_Paulo) so a caller knows which are live without a second call. Read an entry's history through `GET /contracts/{contract_id}/insured-people/{insured_person_id}/history`.
 *
 * A `POST` so the CPF travels in the body and never in a URL, where a proxy or an access log would keep it. Punctuated and plain CPFs find the same person; one whose check digits fail is a `422`. A CPF that no contract in scope carries is `404`, with the same message whoever else might carry it. A read, and not audited.
 *
 * The company is the one in the path. A customer or machine principal reads its own and gets the `404` an unknown company gets for any other. vyttech staff read any company without `X-Company-Id`; one naming a different company is refused with `400`.
 */
export const lookUpCompanyInsuredPersonApiV1CompaniesCompanyIdInsuredPeopleLookupPost = <ThrowOnError extends boolean = false>(options: Options<LookUpCompanyInsuredPersonApiV1CompaniesCompanyIdInsuredPeopleLookupPostData, ThrowOnError>): RequestResult<LookUpCompanyInsuredPersonApiV1CompaniesCompanyIdInsuredPeopleLookupPostResponses, LookUpCompanyInsuredPersonApiV1CompaniesCompanyIdInsuredPeopleLookupPostErrors, ThrowOnError> => (options.client ?? client).post<LookUpCompanyInsuredPersonApiV1CompaniesCompanyIdInsuredPeopleLookupPostResponses, LookUpCompanyInsuredPersonApiV1CompaniesCompanyIdInsuredPeopleLookupPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/companies/{company_id}/insured-people/lookup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Project a company's insured population on a date, across its contracts
 *
 * Everyone insured on `as_of` under any contract of the company -- vida and saúde alike -- with, for each contract, what `GET /contracts/{contract_id}/roster` says about them on that date.
 *
 * One item per person, merged by CPF: somebody under two contracts is one item with an entry for each, and somebody covered on `as_of` under one contract and not the other has only the covering contract's entry. Each entry carries what the per-contract projection carries for that person on that contract -- the coverage period, the salary in force on `as_of` and the insurer's values, which are current rather than dated.
 *
 * Entries are ordered by contract kind (`vida` before `saude`), then by when the contract was created, then by id; the item's `full_name` and `birth_date` are the first entry's, and two contracts that disagree are not reconciled here. Items are sorted by name without regard to case, then by CPF.
 *
 * A read, and not audited, as the per-contract projection is not.
 *
 * The company is the one in the path. A customer or machine principal reads its own and gets the `404` an unknown company gets for any other. vyttech staff read any company without `X-Company-Id`; one naming a different company is refused with `400`.
 */
export const projectCompanyRosterApiV1CompaniesCompanyIdRosterGet = <ThrowOnError extends boolean = false>(options: Options<ProjectCompanyRosterApiV1CompaniesCompanyIdRosterGetData, ThrowOnError>): RequestResult<ProjectCompanyRosterApiV1CompaniesCompanyIdRosterGetResponses, ProjectCompanyRosterApiV1CompaniesCompanyIdRosterGetErrors, ThrowOnError> => (options.client ?? client).get<ProjectCompanyRosterApiV1CompaniesCompanyIdRosterGetResponses, ProjectCompanyRosterApiV1CompaniesCompanyIdRosterGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/companies/{company_id}/roster',
    ...options
});

/**
 * List a company's spreadsheet uploads
 *
 * Every upload of the company, company-level and per-contract alike, most recent first. Counts, per-contract counts and provenance; the rows are read one batch at a time.
 */
export const listCompanySpreadsheetUploadsApiV1CompaniesCompanyIdSpreadsheetUploadsGet = <ThrowOnError extends boolean = false>(options: Options<ListCompanySpreadsheetUploadsApiV1CompaniesCompanyIdSpreadsheetUploadsGetData, ThrowOnError>): RequestResult<ListCompanySpreadsheetUploadsApiV1CompaniesCompanyIdSpreadsheetUploadsGetResponses, ListCompanySpreadsheetUploadsApiV1CompaniesCompanyIdSpreadsheetUploadsGetErrors, ThrowOnError> => (options.client ?? client).get<ListCompanySpreadsheetUploadsApiV1CompaniesCompanyIdSpreadsheetUploadsGetResponses, ListCompanySpreadsheetUploadsApiV1CompaniesCompanyIdSpreadsheetUploadsGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/companies/{company_id}/spreadsheet-uploads',
    ...options
});

/**
 * Upload one sheet for all of a company's contracts and preview it
 *
 * The per-contract upload, for a sheet that lists people of several of the company's contracts. **No delta is created here.** Confirming the returned batch is what creates them, each on its row's contract.
 *
 * Each row is routed to one of the company's contracts by its `Subestipulante`, and additionally by its `Módulo` when that cell is filled; the row's `contract` says which. A row whose codes fit no contract of the company is rejected as `contract_mismatch`. A row they fit more than one contract of -- the same `Subestipulante` under several módulos or insurers with `Módulo` blank -- is rejected as `ambiguous_contract`, and filling in `Módulo` routes it. A blank `Subestipulante` routes only when the company has exactly one contract, and is `ambiguous_contract` otherwise. Unmarked rows are routed too, refused the same way when their codes do not route, and compared with the roster of the contract they route to. Absences are reported for every contract of the company. The file selects a contract; it never sets its codes.
 *
 * Everything else is the per-contract upload's, per row and against the row's own contract: the roster check, and the rule of one movement per person per contract per sheet -- the same CPF under two contracts is two people's movements, since people are registered per contract. `upload.contract_id` is `null` and `upload.contract_counts` breaks the totals down per contract.
 *
 * Re-sending a file that has already been committed anywhere in this company answers `200` with the batch that holds those deltas and `is_duplicate` set, rather than previewing it again.
 */
export const uploadCompanySpreadsheetApiV1CompaniesCompanyIdSpreadsheetUploadsPost = <ThrowOnError extends boolean = false>(options: Options<UploadCompanySpreadsheetApiV1CompaniesCompanyIdSpreadsheetUploadsPostData, ThrowOnError>): RequestResult<UploadCompanySpreadsheetApiV1CompaniesCompanyIdSpreadsheetUploadsPostResponses, UploadCompanySpreadsheetApiV1CompaniesCompanyIdSpreadsheetUploadsPostErrors, ThrowOnError> => (options.client ?? client).post<UploadCompanySpreadsheetApiV1CompaniesCompanyIdSpreadsheetUploadsPostResponses, UploadCompanySpreadsheetApiV1CompaniesCompanyIdSpreadsheetUploadsPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/companies/{company_id}/spreadsheet-uploads',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Fetch a company's upload and its rows
 *
 * The same document the upload answered with, re-read at any time, each row with the contract it was routed to. `outcome=rejected` narrows it to the rows that need correcting.
 */
export const getCompanySpreadsheetUploadApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdGet = <ThrowOnError extends boolean = false>(options: Options<GetCompanySpreadsheetUploadApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdGetData, ThrowOnError>): RequestResult<GetCompanySpreadsheetUploadApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdGetResponses, GetCompanySpreadsheetUploadApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetCompanySpreadsheetUploadApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdGetResponses, GetCompanySpreadsheetUploadApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/companies/{company_id}/spreadsheet-uploads/{upload_id}',
    ...options
});

/**
 * Read who on the roster a company's upload left out
 *
 * People covered on the comparison date -- the upload's `default_effective_date`, or the day it was sent -- under a contract the upload covers, whose CPF is on no line of the file, ordered by contract and name. Only a file with at least one row with no action marked lists everybody, so a file of movements alone has none. Stored with the batch: the list is the same before and after confirming.
 *
 * Nothing is done about them. An absence is never a delta and never an exclusão; the person stays insured unless an exclusão is sent. Reading a non-empty list is reading personal data, and is recorded in the audit trail.
 */
export const listCompanySpreadsheetUploadAbsencesApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdAbsencesGet = <ThrowOnError extends boolean = false>(options: Options<ListCompanySpreadsheetUploadAbsencesApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdAbsencesGetData, ThrowOnError>): RequestResult<ListCompanySpreadsheetUploadAbsencesApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdAbsencesGetResponses, ListCompanySpreadsheetUploadAbsencesApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdAbsencesGetErrors, ThrowOnError> => (options.client ?? client).get<ListCompanySpreadsheetUploadAbsencesApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdAbsencesGetResponses, ListCompanySpreadsheetUploadAbsencesApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdAbsencesGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/companies/{company_id}/spreadsheet-uploads/{upload_id}/absences',
    ...options
});

/**
 * Commit the ready rows of a company's upload
 *
 * Submits one delta per `ready` row, each on the contract the row was routed to, exactly as confirming a per-contract upload does: `submitted`, not approved; rejected rows produce nothing; the roster is re-checked per row against the row's own contract.
 *
 * Any upload of this company can be confirmed here, per-contract ones included. Confirming twice is refused with `409`, as is confirming a company-level batch whose file another batch of this company has already committed; both name the batch that holds the deltas in `details`.
 *
 * A company's part of a group upload (`group_upload_id` set) is refused with `409` too: it is confirmed with the group upload, for every company at once. `details` names the group upload, with `field` `group_upload_id`.
 */
export const confirmCompanySpreadsheetUploadApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdConfirmPost = <ThrowOnError extends boolean = false>(options: Options<ConfirmCompanySpreadsheetUploadApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdConfirmPostData, ThrowOnError>): RequestResult<ConfirmCompanySpreadsheetUploadApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdConfirmPostResponses, ConfirmCompanySpreadsheetUploadApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdConfirmPostErrors, ThrowOnError> => (options.client ?? client).post<ConfirmCompanySpreadsheetUploadApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdConfirmPostResponses, ConfirmCompanySpreadsheetUploadApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdConfirmPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/companies/{company_id}/spreadsheet-uploads/{upload_id}/confirm',
    ...options
});

/**
 * Read a company's upload rows on their own
 *
 * The lines of a batch, each with the contract it was routed to.
 */
export const listCompanySpreadsheetUploadRowsApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdRowsGet = <ThrowOnError extends boolean = false>(options: Options<ListCompanySpreadsheetUploadRowsApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdRowsGetData, ThrowOnError>): RequestResult<ListCompanySpreadsheetUploadRowsApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdRowsGetResponses, ListCompanySpreadsheetUploadRowsApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdRowsGetErrors, ThrowOnError> => (options.client ?? client).get<ListCompanySpreadsheetUploadRowsApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdRowsGetResponses, ListCompanySpreadsheetUploadRowsApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdRowsGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/companies/{company_id}/spreadsheet-uploads/{upload_id}/rows',
    ...options
});

/**
 * Download the file a company's upload came from
 *
 * The uploaded bytes, unchanged, decrypted only to serve this response. A company's part of a group upload has no file of its own -- the file lists every company of the group -- and answers `404`.
 */
export const downloadCompanySpreadsheetUploadSourceApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdSourceGet = <ThrowOnError extends boolean = false>(options: Options<DownloadCompanySpreadsheetUploadSourceApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdSourceGetData, ThrowOnError>): RequestResult<DownloadCompanySpreadsheetUploadSourceApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdSourceGetResponses, DownloadCompanySpreadsheetUploadSourceApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdSourceGetErrors, ThrowOnError> => (options.client ?? client).get<DownloadCompanySpreadsheetUploadSourceApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdSourceGetResponses, DownloadCompanySpreadsheetUploadSourceApiV1CompaniesCompanyIdSpreadsheetUploadsUploadIdSourceGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/companies/{company_id}/spreadsheet-uploads/{upload_id}/source',
    ...options
});

/**
 * Set what the review does about a company's undocumented terminations
 *
 * Sets whether a termination with no supporting document linked to it is `block`ed, `warn`ed about or not checked (`off`) in the review queue of every contract of this company. vyttech staff only.
 *
 * `block` makes the `missing_evidence` flag blocking: the movement's own approval is a `409` and the cycle cannot be signed off while it stands, until a document is linked or the movement is rejected or returned. `warn` is the default and what every company had before the setting existed. `off` raises no `missing_evidence` flag at all; the other flags are unaffected. The queue reflects the change on its next read.
 *
 * Restating the current policy succeeds and records nothing; a real change is in the trail as `company.termination_document_policy_set`, with the policy before and after.
 */
export const setCompanyTerminationDocumentPolicyApiV1CompaniesCompanyIdTerminationDocumentPolicyPut = <ThrowOnError extends boolean = false>(options: Options<SetCompanyTerminationDocumentPolicyApiV1CompaniesCompanyIdTerminationDocumentPolicyPutData, ThrowOnError>): RequestResult<SetCompanyTerminationDocumentPolicyApiV1CompaniesCompanyIdTerminationDocumentPolicyPutResponses, SetCompanyTerminationDocumentPolicyApiV1CompaniesCompanyIdTerminationDocumentPolicyPutErrors, ThrowOnError> => (options.client ?? client).put<SetCompanyTerminationDocumentPolicyApiV1CompaniesCompanyIdTerminationDocumentPolicyPutResponses, SetCompanyTerminationDocumentPolicyApiV1CompaniesCompanyIdTerminationDocumentPolicyPutErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/companies/{company_id}/termination-document-policy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List contracts
 *
 * Every contract in scope. A customer principal sees only its own company's; vyttech staff see all of them, or one company's by sending `X-Company-Id`.
 */
export const listContractsApiV1ContractsGet = <ThrowOnError extends boolean = false>(options?: Options<ListContractsApiV1ContractsGetData, ThrowOnError>): RequestResult<ListContractsApiV1ContractsGetResponses, ListContractsApiV1ContractsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListContractsApiV1ContractsGetResponses, ListContractsApiV1ContractsGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts',
    ...options
});

/**
 * Create a contract
 *
 * Creates the insurance contract a roster hangs off, for the customer company named by `X-Company-Id`. vyttech staff only.
 *
 * `subestipulante` and `modulo` are the insurer's own two codes for this population. They are stored here, independently of one another, and they are never carried on a person, a spreadsheet row or any other payload -- which is what stops two rows of one submission disagreeing about which population they describe.
 *
 * `insurer_contract_number` and `apolice` are the policy's references as the insurer's file prints them (CONTRATO, APÓLICE). Both are optional, both are strings of 1 to 20 digits -- punctuation is refused, not stripped -- and neither is unique: several contracts, in one company or several, may sit under one policy.
 *
 * `submission_cadence`, `cutoff_day` and `reference_date_rule` are the submission cycle the snapshot engine reads: how often a file goes, which day closes the period, and which date within a cycle the population is read at. The last one decides whether somebody terminated mid-month is on that month's file, and it defaults to the cutoff date.
 *
 * `off_cycle_rule` is the term beside them: whether this insurer takes an urgent movement *between* cutoffs, which is what decides whether the off-cycle notice route is open on this contract at all. It defaults to `not_permitted` -- we do not assume an insurer accepts anything outside the monthly file until somebody has asked them.
 */
export const createContractApiV1ContractsPost = <ThrowOnError extends boolean = false>(options: Options<CreateContractApiV1ContractsPostData, ThrowOnError>): RequestResult<CreateContractApiV1ContractsPostResponses, CreateContractApiV1ContractsPostErrors, ThrowOnError> => (options.client ?? client).post<CreateContractApiV1ContractsPostResponses, CreateContractApiV1ContractsPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fetch a contract
 *
 * One contract, with its insurer in full so the insurer's name and code need no second call.
 *
 * A contract belonging to another company is `404`: the company filter is part of the query, so holding the identifier does not reach the row.
 */
export const getContractApiV1ContractsContractIdGet = <ThrowOnError extends boolean = false>(options: Options<GetContractApiV1ContractsContractIdGetData, ThrowOnError>): RequestResult<GetContractApiV1ContractsContractIdGetResponses, GetContractApiV1ContractsContractIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetContractApiV1ContractsContractIdGetResponses, GetContractApiV1ContractsContractIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}',
    ...options
});

/**
 * Update a contract
 *
 * Changes a contract's insurer, its codes, its policy references or its submission cycle. vyttech staff only. Omitted fields are left alone.
 *
 * `insurer_contract_number` and `apolice` are optional on a contract, so for those two an explicit `null` clears the recorded value; for every other field `null` is the same as omitting it.
 *
 * This edits the contract in place, which is safe in a store that otherwise never edits: a contract is live configuration, not a dated assertion about anybody. Correcting a mistyped `subestipulante` changes nothing the roster ever asserted, because the roster never carried it.
 */
export const updateContractApiV1ContractsContractIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateContractApiV1ContractsContractIdPatchData, ThrowOnError>): RequestResult<UpdateContractApiV1ContractsContractIdPatchResponses, UpdateContractApiV1ContractsContractIdPatchErrors, ThrowOnError> => (options.client ?? client).patch<UpdateContractApiV1ContractsContractIdPatchResponses, UpdateContractApiV1ContractsContractIdPatchErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the baseline imports run against a contract
 *
 * Most recent first. Counts and provenance only; the people are read through the roster endpoints.
 */
export const listBaselineImportsApiV1ContractsContractIdBaselineImportsGet = <ThrowOnError extends boolean = false>(options: Options<ListBaselineImportsApiV1ContractsContractIdBaselineImportsGetData, ThrowOnError>): RequestResult<ListBaselineImportsApiV1ContractsContractIdBaselineImportsGetResponses, ListBaselineImportsApiV1ContractsContractIdBaselineImportsGetErrors, ThrowOnError> => (options.client ?? client).get<ListBaselineImportsApiV1ContractsContractIdBaselineImportsGetResponses, ListBaselineImportsApiV1ContractsContractIdBaselineImportsGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}/baseline-imports',
    ...options
});

/**
 * Import the baseline population
 *
 * Loads the population already insured under this contract, effective from `baseline_date` or from each row's own coverage start. vyttech staff only.
 *
 * The source is an `.xlsx` workbook (its first sheet) or a CSV, told apart by the file's content, whose header names `cpf`, `full_name`, `birth_date` and `salary`; the Portuguese spellings `CPF`, `Nome`, `Data de nascimento` and `Salário` are accepted, as are semicolon separators, Latin-1 encoding, `DD/MM/YYYY` dates, `R$ 4.500,00` amounts and a CPF that a number cell stripped of its leading zeros. A pre-2007 `.xls` is refused with a request to save it as `.xlsx` or `.csv`. Extra columns are ignored -- except `subestipulante` and `modulo`, whose presence rejects the file, because those belong to the contract and never to a person; a sheet that lists several of a company's contracts by those columns is imported at `POST /companies/{company_id}/baseline-imports` instead.
 *
 * **Coverage may start per row.** An optional `Início da cobertura` column (also read as `coverage_start`, `Data de início da cobertura`, `Data início` and similar spellings) gives each person the date their coverage and salary start; a filled cell wins over `baseline_date`, and a blank cell or a file without the column uses `baseline_date`. A start before the person's birth date, or a cell that is not a date, is a problem with that row. `Data de vigência` is not this column, and is ignored like any extra column.
 *
 * **Nothing is imported unless everything can be.** A bad CPF, a CPF repeated within the file, an unreadable birth date or coverage start, or an empty required cell rejects the whole upload with `422` and one `details` entry per offending row, naming the row and the reason. No row is written.
 *
 * **Re-running is safe.** A person already on the contract with coverage and a salary at their date is left alone, so the same file applied twice produces the roster once.
 *
 * A contract that has moved on -- an admission, a termination, a snapshot already sent, or coverage or a salary on a date the file does not carry -- is refused with `409` and proceeds only when `override` is set. The file, its media type as read from its content, the staff user and the moment are retained either way.
 */
export const importBaselineApiV1ContractsContractIdBaselineImportsPost = <ThrowOnError extends boolean = false>(options: Options<ImportBaselineApiV1ContractsContractIdBaselineImportsPostData, ThrowOnError>): RequestResult<ImportBaselineApiV1ContractsContractIdBaselineImportsPostResponses, ImportBaselineApiV1ContractsContractIdBaselineImportsPostErrors, ThrowOnError> => (options.client ?? client).post<ImportBaselineApiV1ContractsContractIdBaselineImportsPostResponses, ImportBaselineApiV1ContractsContractIdBaselineImportsPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}/baseline-imports',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Fetch one baseline import
 *
 * One import run, by its own identifier. Counts and provenance, never the people it created -- those are read through the roster endpoints.
 *
 * An import belonging to another contract, or to another company, is `404`.
 */
export const getBaselineImportApiV1ContractsContractIdBaselineImportsBaselineImportIdGet = <ThrowOnError extends boolean = false>(options: Options<GetBaselineImportApiV1ContractsContractIdBaselineImportsBaselineImportIdGetData, ThrowOnError>): RequestResult<GetBaselineImportApiV1ContractsContractIdBaselineImportsBaselineImportIdGetResponses, GetBaselineImportApiV1ContractsContractIdBaselineImportsBaselineImportIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetBaselineImportApiV1ContractsContractIdBaselineImportsBaselineImportIdGetResponses, GetBaselineImportApiV1ContractsContractIdBaselineImportsBaselineImportIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}/baseline-imports/{baseline_import_id}',
    ...options
});

/**
 * Download the file a baseline was imported from
 *
 * The uploaded bytes, unchanged. This is the provenance of everything the roster asserts about the people the import created, so it is the file as it arrived rather than a reconstruction from the rows.
 *
 * It is stored encrypted, like the columns it was loaded into, and decrypted only to serve this response.
 */
export const downloadBaselineImportSourceApiV1ContractsContractIdBaselineImportsBaselineImportIdSourceGet = <ThrowOnError extends boolean = false>(options: Options<DownloadBaselineImportSourceApiV1ContractsContractIdBaselineImportsBaselineImportIdSourceGetData, ThrowOnError>): RequestResult<DownloadBaselineImportSourceApiV1ContractsContractIdBaselineImportsBaselineImportIdSourceGetResponses, DownloadBaselineImportSourceApiV1ContractsContractIdBaselineImportsBaselineImportIdSourceGetErrors, ThrowOnError> => (options.client ?? client).get<DownloadBaselineImportSourceApiV1ContractsContractIdBaselineImportsBaselineImportIdSourceGetResponses, DownloadBaselineImportSourceApiV1ContractsContractIdBaselineImportsBaselineImportIdSourceGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}/baseline-imports/{baseline_import_id}/source',
    ...options
});

/**
 * Submit one delta
 *
 * Records one requested change to one person under this contract. The body carries exactly one action -- `admission`, `termination` or `salary_change` -- chosen by `action`, and each shape forbids the fields belonging to the others. `subestipulante` and `modulo` are contract-level facts and are rejected if sent.
 *
 * The CPF is validated for format and check digits. An admission for somebody already insured on the effective date is refused, as is a termination or salary change for somebody who is not insured then; both say which so the submitter can fix it.
 *
 * Nothing reaches the roster here. A delta is a request, and it becomes a roster fact when it is approved.
 */
export const submitDeltaApiV1ContractsContractIdDeltasPost = <ThrowOnError extends boolean = false>(options: Options<SubmitDeltaApiV1ContractsContractIdDeltasPostData, ThrowOnError>): RequestResult<SubmitDeltaApiV1ContractsContractIdDeltasPostResponses, SubmitDeltaApiV1ContractsContractIdDeltasPostErrors, ThrowOnError> => (options.client ?? client).post<SubmitDeltaApiV1ContractsContractIdDeltasPostResponses, SubmitDeltaApiV1ContractsContractIdDeltasPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}/deltas',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit many deltas in one call
 *
 * For the callers that feed deltas in volume -- the spreadsheet importer and the ERP integration -- rather than one at a time.
 *
 * Each item is validated on its own. An item that is malformed, carries an invalid CPF, or conflicts with the roster on its effective date is reported in `failures` at the index it was sent at; every other item is still submitted. A batch with failures is still a `200`, because the accepted items really were accepted.
 *
 * Send `Idempotency-Key` and a retry of the same batch returns the original response instead of submitting everything twice.
 */
export const submitDeltasInBulkApiV1ContractsContractIdDeltasBulkPost = <ThrowOnError extends boolean = false>(options: Options<SubmitDeltasInBulkApiV1ContractsContractIdDeltasBulkPostData, ThrowOnError>): RequestResult<SubmitDeltasInBulkApiV1ContractsContractIdDeltasBulkPostResponses, SubmitDeltasInBulkApiV1ContractsContractIdDeltasBulkPostErrors, ThrowOnError> => (options.client ?? client).post<SubmitDeltasInBulkApiV1ContractsContractIdDeltasBulkPostResponses, SubmitDeltasInBulkApiV1ContractsContractIdDeltasBulkPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}/deltas/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One person's whole history on a contract
 *
 * Every coverage period, salary version and absence ever recorded for this person, oldest first -- including periods that have ended and salary versions that have been superseded. This is what explains any past projection.
 *
 * The absences are listed beside the coverage and never merged into it: a leave does not interrupt coverage, so the coverage periods here are exactly what they would have been without it.
 */
export const getPersonHistoryApiV1ContractsContractIdInsuredPeopleInsuredPersonIdHistoryGet = <ThrowOnError extends boolean = false>(options: Options<GetPersonHistoryApiV1ContractsContractIdInsuredPeopleInsuredPersonIdHistoryGetData, ThrowOnError>): RequestResult<GetPersonHistoryApiV1ContractsContractIdInsuredPeopleInsuredPersonIdHistoryGetResponses, GetPersonHistoryApiV1ContractsContractIdInsuredPeopleInsuredPersonIdHistoryGetErrors, ThrowOnError> => (options.client ?? client).get<GetPersonHistoryApiV1ContractsContractIdInsuredPeopleInsuredPersonIdHistoryGetResponses, GetPersonHistoryApiV1ContractsContractIdInsuredPeopleInsuredPersonIdHistoryGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}/insured-people/{insured_person_id}/history',
    ...options
});

/**
 * Set a person's insurer values
 *
 * Records what the insurer says about one person: the certificate number (*Certificado*), the capital insured (*IS Segurado*) and the premium (*Prêmio*). vyttech staff only, inside the company named by `X-Company-Id`.
 *
 * A partial update. A field left out is untouched and a field sent as `null` is cleared. Each is one current value, so writing one replaces it; a monthly file already generated is unaffected, because its snapshot stores its rows.
 *
 * Only these three fields are accepted. The person's name, CPF, birth date, coverage and salary change only through a delta, and a body naming any of them -- or any other field -- is refused with `422`.
 *
 * A person on another company's contract, or not on this contract, is `404`, the same answer an unknown identifier gets.
 */
export const setInsurerValuesApiV1ContractsContractIdInsuredPeopleInsuredPersonIdInsurerValuesPatch = <ThrowOnError extends boolean = false>(options: Options<SetInsurerValuesApiV1ContractsContractIdInsuredPeopleInsuredPersonIdInsurerValuesPatchData, ThrowOnError>): RequestResult<SetInsurerValuesApiV1ContractsContractIdInsuredPeopleInsuredPersonIdInsurerValuesPatchResponses, SetInsurerValuesApiV1ContractsContractIdInsuredPeopleInsuredPersonIdInsurerValuesPatchErrors, ThrowOnError> => (options.client ?? client).patch<SetInsurerValuesApiV1ContractsContractIdInsuredPeopleInsuredPersonIdInsurerValuesPatchResponses, SetInsurerValuesApiV1ContractsContractIdInsuredPeopleInsuredPersonIdInsurerValuesPatchErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}/insured-people/{insured_person_id}/insurer-values',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Where this contract's movements stand
 *
 * Every movement this contract has filed, most recently filed first, each with the stage it is in, the month whose file it lands on, the cutoff that file reads the roster at, and whether that cutoff has been signed off.
 *
 * **Nothing is hidden.** Rejected, returned and cancelled movements are in here beside the rest: this listing replaces an email thread, and a thread does not quietly drop the messages that went badly.
 *
 * `cycle_month` is the cutoff the answer is relative to -- the month a movement has to land in or before to count as due now rather than `scheduled`. It defaults to the current month in São Paulo, and naming an earlier one answers what this looked like then.
 *
 * The counts are per stage over this page, with every stage present even at zero, so a client can render a fixed set of headings from them.
 */
export const readMovementStatusApiV1ContractsContractIdMovementStatusGet = <ThrowOnError extends boolean = false>(options: Options<ReadMovementStatusApiV1ContractsContractIdMovementStatusGetData, ThrowOnError>): RequestResult<ReadMovementStatusApiV1ContractsContractIdMovementStatusGetResponses, ReadMovementStatusApiV1ContractsContractIdMovementStatusGetErrors, ThrowOnError> => (options.client ?? client).get<ReadMovementStatusApiV1ContractsContractIdMovementStatusGetResponses, ReadMovementStatusApiV1ContractsContractIdMovementStatusGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}/movement-status',
    ...options
});

/**
 * Project the insured population on a date
 *
 * Everyone insured under the contract on `as_of`, with the name, birth date, CPF and the salary in force on that date.
 *
 * Each person also carries the insurer's values -- certificate number, capital insured and premium -- which are current rather than dated: a projection for a past date shows what the insurer says about the person now, and `null` where nothing has been recorded.
 *
 * A person is included when one of their coverage periods contains the date, counting `effective_from` as the first covered day and `effective_to` as the last. The salary returned is the latest version whose effective date is on or before `as_of`, so two changes in the same month resolve to the right one.
 *
 * The result is derived from dated rows rather than from current state, so a projection for a past date returns what was true then even after later corrections have been recorded.
 */
export const projectRosterApiV1ContractsContractIdRosterGet = <ThrowOnError extends boolean = false>(options: Options<ProjectRosterApiV1ContractsContractIdRosterGetData, ThrowOnError>): RequestResult<ProjectRosterApiV1ContractsContractIdRosterGetResponses, ProjectRosterApiV1ContractsContractIdRosterGetErrors, ThrowOnError> => (options.client ?? client).get<ProjectRosterApiV1ContractsContractIdRosterGetResponses, ProjectRosterApiV1ContractsContractIdRosterGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}/roster',
    ...options
});

/**
 * Project the population a snapshot would be built from
 *
 * The projection half of the engine on its own: who is insured on the reference date and what their values are then, with no layout, no formatting and no file.
 *
 * Send `cycle_month` to have the date chosen by the contract's rule, or `reference_date` to project a date directly. Sending both is refused; sending neither projects the current month's cycle.
 *
 * A person whose admission takes effect after the date is absent; one whose termination takes effect after it is present; the salary is the version in force on the date. Nothing here is special-cased -- all three follow from asking the effective-dated roster about one day.
 */
export const projectSnapshotApiV1ContractsContractIdSnapshotProjectionGet = <ThrowOnError extends boolean = false>(options: Options<ProjectSnapshotApiV1ContractsContractIdSnapshotProjectionGetData, ThrowOnError>): RequestResult<ProjectSnapshotApiV1ContractsContractIdSnapshotProjectionGetResponses, ProjectSnapshotApiV1ContractsContractIdSnapshotProjectionGetErrors, ThrowOnError> => (options.client ?? client).get<ProjectSnapshotApiV1ContractsContractIdSnapshotProjectionGetResponses, ProjectSnapshotApiV1ContractsContractIdSnapshotProjectionGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}/snapshot-projection',
    ...options
});

/**
 * Record that a snapshot was submitted to the insurer
 *
 * Marks everything up to `covers_through` as already reported. A delta dated on or before that day is then accepted and flagged as retroactive, and appears in the review queue.
 *
 * Rendering and sending snapshots belongs to the snapshot task; this endpoint records the one fact the delta layer needs from it, and is the seam that task takes over.
 */
export const recordSnapshotSubmissionApiV1ContractsContractIdSnapshotSubmissionsPost = <ThrowOnError extends boolean = false>(options: Options<RecordSnapshotSubmissionApiV1ContractsContractIdSnapshotSubmissionsPostData, ThrowOnError>): RequestResult<RecordSnapshotSubmissionApiV1ContractsContractIdSnapshotSubmissionsPostResponses, RecordSnapshotSubmissionApiV1ContractsContractIdSnapshotSubmissionsPostErrors, ThrowOnError> => (options.client ?? client).post<RecordSnapshotSubmissionApiV1ContractsContractIdSnapshotSubmissionsPostResponses, RecordSnapshotSubmissionApiV1ContractsContractIdSnapshotSubmissionsPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}/snapshot-submissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate a cycle's snapshot
 *
 * Projects the population at the cycle's reference date, renders it through the insurer's layout, and stores the result as a draft: the rendered rows, the file, and one exception per person the layout would not write.
 *
 * The body carries a cycle month and nothing else. The reference date comes from the contract's `reference_date_rule`; `subestipulante` and `modulo` come from the contract and are identical on every row. None of the three is accepted here, or anywhere per person.
 *
 * **Regenerating replaces the draft.** A second call for the same cycle rebuilds it rather than creating a second snapshot -- the roster may have moved since, and a cycle has one answer.
 *
 * **An approved cycle is refused** with `409`. An approved snapshot is what the insurer is getting, and it does not change.
 */
export const generateSnapshotApiV1ContractsContractIdSnapshotsPost = <ThrowOnError extends boolean = false>(options: Options<GenerateSnapshotApiV1ContractsContractIdSnapshotsPostData, ThrowOnError>): RequestResult<GenerateSnapshotApiV1ContractsContractIdSnapshotsPostResponses, GenerateSnapshotApiV1ContractsContractIdSnapshotsPostErrors, ThrowOnError> => (options.client ?? client).post<GenerateSnapshotApiV1ContractsContractIdSnapshotsPostResponses, GenerateSnapshotApiV1ContractsContractIdSnapshotsPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}/snapshots',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List a contract's spreadsheet uploads
 *
 * Most recent first. Counts and provenance; the rows are read one batch at a time.
 */
export const listSpreadsheetUploadsApiV1ContractsContractIdSpreadsheetUploadsGet = <ThrowOnError extends boolean = false>(options: Options<ListSpreadsheetUploadsApiV1ContractsContractIdSpreadsheetUploadsGetData, ThrowOnError>): RequestResult<ListSpreadsheetUploadsApiV1ContractsContractIdSpreadsheetUploadsGetResponses, ListSpreadsheetUploadsApiV1ContractsContractIdSpreadsheetUploadsGetErrors, ThrowOnError> => (options.client ?? client).get<ListSpreadsheetUploadsApiV1ContractsContractIdSpreadsheetUploadsGetResponses, ListSpreadsheetUploadsApiV1ContractsContractIdSpreadsheetUploadsGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}/spreadsheet-uploads',
    ...options
});

/**
 * Upload a filled spreadsheet and preview it
 *
 * Reads the file, classifies every row against this contract and the roster, and stores all of it. **No delta is created here.** Confirming the returned batch is what creates them.
 *
 * Each row comes back as one of four things. `ready` -- one action marked, a date, and values that parse. `ignored` -- no action column marked, and the person is on the roster exactly as listed, which is most of a customer's sheet and is not an error. `section_title` -- not a person but a heading between blocks of them, text in one cell and nothing else; never refused and never a delta. `rejected` -- refused, with a `rejection_code` to branch on and a sentence to show, and -- for a row refused as an `identity_mismatch` -- a `rejection_context` carrying what the Receita Federal has registered for each field it contradicted. The counts always add up to `row_count`.
 *
 * A row is rejected for marking more than one action, for naming a `Subestipulante` or `Módulo` that is not this contract's, for a CPF that fails its check digits, for having no effective date from any source, for an empty or unreadable cell its action needs, and for asking something the roster cannot accept on that date -- an inclusão for somebody already insured then, an exclusão or alteração for somebody who is not.
 *
 * A row with no action marked claims the person is already insured as listed, and is held to that on the comparison date -- `effective_date` when sent, otherwise today. Its CPF and salary must read, as on a marked row. Somebody not covered under the row's contract then is `unmarked_not_on_roster`; somebody covered on another salary, or with none in force, is `unmarked_salary_differs`, with the salary on record in `rejection_context`. Name and birth date are not compared. When the file has at least one such row, everybody covered under the contract on that date whose CPF is on no line of it is listed in `absences` and counted in `upload.absent_count`. Neither the refusals nor the absences become deltas.
 *
 * A CPF of digits only and fewer than eleven of them -- what a number cell, or a CSV exported from one, leaves of a CPF that began with zeros -- is left-padded with zeros before its check digits are verified. A CPF with punctuation is not padded, and the delta API does not pad at all.
 *
 * Re-sending a file that has already been committed against this contract answers `200` with the batch that holds those deltas and `is_duplicate` set, rather than previewing it again. The same movements are never asked for twice because the same file arrived twice.
 */
export const uploadSpreadsheetApiV1ContractsContractIdSpreadsheetUploadsPost = <ThrowOnError extends boolean = false>(options: Options<UploadSpreadsheetApiV1ContractsContractIdSpreadsheetUploadsPostData, ThrowOnError>): RequestResult<UploadSpreadsheetApiV1ContractsContractIdSpreadsheetUploadsPostResponses, UploadSpreadsheetApiV1ContractsContractIdSpreadsheetUploadsPostErrors, ThrowOnError> => (options.client ?? client).post<UploadSpreadsheetApiV1ContractsContractIdSpreadsheetUploadsPostResponses, UploadSpreadsheetApiV1ContractsContractIdSpreadsheetUploadsPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}/spreadsheet-uploads',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Fetch an upload and its rows
 *
 * The same document the upload itself answered with, re-read at any time -- before the commit to decide on it, after the commit to see what became of each row. `outcome=rejected` narrows it to the rows that need correcting.
 */
export const getSpreadsheetUploadApiV1ContractsContractIdSpreadsheetUploadsUploadIdGet = <ThrowOnError extends boolean = false>(options: Options<GetSpreadsheetUploadApiV1ContractsContractIdSpreadsheetUploadsUploadIdGetData, ThrowOnError>): RequestResult<GetSpreadsheetUploadApiV1ContractsContractIdSpreadsheetUploadsUploadIdGetResponses, GetSpreadsheetUploadApiV1ContractsContractIdSpreadsheetUploadsUploadIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetSpreadsheetUploadApiV1ContractsContractIdSpreadsheetUploadsUploadIdGetResponses, GetSpreadsheetUploadApiV1ContractsContractIdSpreadsheetUploadsUploadIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}/spreadsheet-uploads/{upload_id}',
    ...options
});

/**
 * Read who on the roster an upload's file left out
 *
 * People covered on the comparison date -- the upload's `default_effective_date`, or the day it was sent -- under a contract the upload covers, whose CPF is on no line of the file, ordered by contract and name. Only a file with at least one row with no action marked lists everybody, so a file of movements alone has none. Stored with the batch: the list is the same before and after confirming.
 *
 * Nothing is done about them. An absence is never a delta and never an exclusão; the person stays insured unless an exclusão is sent. Reading a non-empty list is reading personal data, and is recorded in the audit trail.
 */
export const listSpreadsheetUploadAbsencesApiV1ContractsContractIdSpreadsheetUploadsUploadIdAbsencesGet = <ThrowOnError extends boolean = false>(options: Options<ListSpreadsheetUploadAbsencesApiV1ContractsContractIdSpreadsheetUploadsUploadIdAbsencesGetData, ThrowOnError>): RequestResult<ListSpreadsheetUploadAbsencesApiV1ContractsContractIdSpreadsheetUploadsUploadIdAbsencesGetResponses, ListSpreadsheetUploadAbsencesApiV1ContractsContractIdSpreadsheetUploadsUploadIdAbsencesGetErrors, ThrowOnError> => (options.client ?? client).get<ListSpreadsheetUploadAbsencesApiV1ContractsContractIdSpreadsheetUploadsUploadIdAbsencesGetResponses, ListSpreadsheetUploadAbsencesApiV1ContractsContractIdSpreadsheetUploadsUploadIdAbsencesGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}/spreadsheet-uploads/{upload_id}/absences',
    ...options
});

/**
 * Commit the ready rows of an upload
 *
 * Submits one delta per `ready` row, through the delta layer and with the row's own effective date. The deltas are `submitted`, not approved: a spreadsheet is how a change is asked for, and approving it stays where that decision lives.
 *
 * Rejected rows are left rejected and produce nothing, so a sheet with two bad lines out of four hundred commits three hundred and ninety-eight. The customer corrects those two and uploads them again.
 *
 * The roster is re-checked per row as each delta is submitted, because it may have moved since the preview. A row that no longer fits is rejected here, with the roster's own words, and the rows around it still commit.
 *
 * Confirming twice is refused with `409`, as is confirming a batch whose file another batch has already committed; both name the batch that holds the deltas in `details` so the caller can read it.
 */
export const confirmSpreadsheetUploadApiV1ContractsContractIdSpreadsheetUploadsUploadIdConfirmPost = <ThrowOnError extends boolean = false>(options: Options<ConfirmSpreadsheetUploadApiV1ContractsContractIdSpreadsheetUploadsUploadIdConfirmPostData, ThrowOnError>): RequestResult<ConfirmSpreadsheetUploadApiV1ContractsContractIdSpreadsheetUploadsUploadIdConfirmPostResponses, ConfirmSpreadsheetUploadApiV1ContractsContractIdSpreadsheetUploadsUploadIdConfirmPostErrors, ThrowOnError> => (options.client ?? client).post<ConfirmSpreadsheetUploadApiV1ContractsContractIdSpreadsheetUploadsUploadIdConfirmPostResponses, ConfirmSpreadsheetUploadApiV1ContractsContractIdSpreadsheetUploadsUploadIdConfirmPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}/spreadsheet-uploads/{upload_id}/confirm',
    ...options
});

/**
 * Read an upload's rows on their own
 *
 * For a client that already holds the batch and wants only the lines -- the rejected ones, most of the time, to show or to export.
 */
export const listSpreadsheetUploadRowsApiV1ContractsContractIdSpreadsheetUploadsUploadIdRowsGet = <ThrowOnError extends boolean = false>(options: Options<ListSpreadsheetUploadRowsApiV1ContractsContractIdSpreadsheetUploadsUploadIdRowsGetData, ThrowOnError>): RequestResult<ListSpreadsheetUploadRowsApiV1ContractsContractIdSpreadsheetUploadsUploadIdRowsGetResponses, ListSpreadsheetUploadRowsApiV1ContractsContractIdSpreadsheetUploadsUploadIdRowsGetErrors, ThrowOnError> => (options.client ?? client).get<ListSpreadsheetUploadRowsApiV1ContractsContractIdSpreadsheetUploadsUploadIdRowsGetResponses, ListSpreadsheetUploadRowsApiV1ContractsContractIdSpreadsheetUploadsUploadIdRowsGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}/spreadsheet-uploads/{upload_id}/rows',
    ...options
});

/**
 * Download the file an upload came from
 *
 * The uploaded bytes, unchanged. This is the provenance of every delta the batch created, so it is the file as it arrived rather than a reconstruction from the rows.
 *
 * It is stored encrypted, like the columns it turned into, and decrypted only to serve this response.
 */
export const downloadSpreadsheetUploadSourceApiV1ContractsContractIdSpreadsheetUploadsUploadIdSourceGet = <ThrowOnError extends boolean = false>(options: Options<DownloadSpreadsheetUploadSourceApiV1ContractsContractIdSpreadsheetUploadsUploadIdSourceGetData, ThrowOnError>): RequestResult<DownloadSpreadsheetUploadSourceApiV1ContractsContractIdSpreadsheetUploadsUploadIdSourceGetResponses, DownloadSpreadsheetUploadSourceApiV1ContractsContractIdSpreadsheetUploadsUploadIdSourceGetErrors, ThrowOnError> => (options.client ?? client).get<DownloadSpreadsheetUploadSourceApiV1ContractsContractIdSpreadsheetUploadsUploadIdSourceGetResponses, DownloadSpreadsheetUploadSourceApiV1ContractsContractIdSpreadsheetUploadsUploadIdSourceGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}/spreadsheet-uploads/{upload_id}/source',
    ...options
});

/**
 * Which date a cycle reads the roster at
 *
 * Resolves `cycle_month` to the single calendar date this contract's snapshot projects the population at, by applying the contract's `reference_date_rule` to its `cutoff_day`.
 *
 * Exposed on its own so a client can show the cutoff before anything is generated, and so that the rule really being configuration is observable: change `reference_date_rule` on the contract and this answer changes.
 */
export const getSubmissionCycleApiV1ContractsContractIdSubmissionCycleGet = <ThrowOnError extends boolean = false>(options: Options<GetSubmissionCycleApiV1ContractsContractIdSubmissionCycleGetData, ThrowOnError>): RequestResult<GetSubmissionCycleApiV1ContractsContractIdSubmissionCycleGetResponses, GetSubmissionCycleApiV1ContractsContractIdSubmissionCycleGetErrors, ThrowOnError> => (options.client ?? client).get<GetSubmissionCycleApiV1ContractsContractIdSubmissionCycleGetResponses, GetSubmissionCycleApiV1ContractsContractIdSubmissionCycleGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/contracts/{contract_id}/submission-cycle',
    ...options
});

/**
 * List deltas
 *
 * Deltas within the request's company scope, newest submission first. Every filter is optional and they combine with AND.
 *
 * `requires_review=true` is the review queue: the deltas whose effective date falls on or before the last snapshot sent to the insurer, which are accepted and flagged rather than rejected.
 */
export const listDeltasApiV1DeltasGet = <ThrowOnError extends boolean = false>(options?: Options<ListDeltasApiV1DeltasGetData, ThrowOnError>): RequestResult<ListDeltasApiV1DeltasGetResponses, ListDeltasApiV1DeltasGetErrors, ThrowOnError> => (options?.client ?? client).get<ListDeltasApiV1DeltasGetResponses, ListDeltasApiV1DeltasGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/deltas',
    ...options
});

/**
 * Fetch a delta
 *
 * A delta belonging to another company is `404`; the company filter is part of the query, so supplying the identifier directly does not reach the row.
 */
export const getDeltaApiV1DeltasDeltaIdGet = <ThrowOnError extends boolean = false>(options: Options<GetDeltaApiV1DeltasDeltaIdGetData, ThrowOnError>): RequestResult<GetDeltaApiV1DeltasDeltaIdGetResponses, GetDeltaApiV1DeltasDeltaIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetDeltaApiV1DeltasDeltaIdGetResponses, GetDeltaApiV1DeltasDeltaIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/deltas/{delta_id}',
    ...options
});

/**
 * Approve a delta
 *
 * Records the change in the roster, immediately, with the delta's own effective date -- however far ahead that date is. A termination effective in two months is written now and the roster keeps reporting the person as insured until it arrives. No job runs afterwards and none needs to.
 *
 * The roster is re-checked first, because it may have moved while the delta waited. Only a `submitted` delta can be approved; an approved one is corrected by superseding it, never by editing it.
 */
export const approveDeltaApiV1DeltasDeltaIdApprovePost = <ThrowOnError extends boolean = false>(options: Options<ApproveDeltaApiV1DeltasDeltaIdApprovePostData, ThrowOnError>): RequestResult<ApproveDeltaApiV1DeltasDeltaIdApprovePostResponses, ApproveDeltaApiV1DeltasDeltaIdApprovePostErrors, ThrowOnError> => (options.client ?? client).post<ApproveDeltaApiV1DeltasDeltaIdApprovePostResponses, ApproveDeltaApiV1DeltasDeltaIdApprovePostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/deltas/{delta_id}/approve',
    ...options
});

/**
 * Cancel a delta
 *
 * Withdraws a delta that has not been approved. It has no roster effect to undo, so a cancelled delta changes no projection on any date. The row stays visible: that it was asked for and withdrawn is part of the contract's history.
 *
 * An approved delta cannot be cancelled. Correct it by submitting a new delta that names it in `supersedes_delta_id`.
 */
export const cancelDeltaApiV1DeltasDeltaIdCancelPost = <ThrowOnError extends boolean = false>(options: Options<CancelDeltaApiV1DeltasDeltaIdCancelPostData, ThrowOnError>): RequestResult<CancelDeltaApiV1DeltasDeltaIdCancelPostResponses, CancelDeltaApiV1DeltasDeltaIdCancelPostErrors, ThrowOnError> => (options.client ?? client).post<CancelDeltaApiV1DeltasDeltaIdCancelPostResponses, CancelDeltaApiV1DeltasDeltaIdCancelPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/deltas/{delta_id}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the documents linked to a delta
 *
 * The paperwork currently claimed as evidence for one requested change. A delta may have several documents, and a superseded version stays in this list with `is_current: false` until the replacement is linked in its place -- so the history of what was filed is never quietly rewritten.
 */
export const listDocumentsForDeltaApiV1DeltasDeltaIdDocumentsGet = <ThrowOnError extends boolean = false>(options: Options<ListDocumentsForDeltaApiV1DeltasDeltaIdDocumentsGetData, ThrowOnError>): RequestResult<ListDocumentsForDeltaApiV1DeltasDeltaIdDocumentsGetResponses, ListDocumentsForDeltaApiV1DeltasDeltaIdDocumentsGetErrors, ThrowOnError> => (options.client ?? client).get<ListDocumentsForDeltaApiV1DeltasDeltaIdDocumentsGetResponses, ListDocumentsForDeltaApiV1DeltasDeltaIdDocumentsGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/deltas/{delta_id}/documents',
    ...options
});

/**
 * Reject a delta
 *
 * Refuses the request and keeps the reason against it. Nothing is written to the roster. Only a `submitted` delta can be rejected.
 */
export const rejectDeltaApiV1DeltasDeltaIdRejectPost = <ThrowOnError extends boolean = false>(options: Options<RejectDeltaApiV1DeltasDeltaIdRejectPostData, ThrowOnError>): RequestResult<RejectDeltaApiV1DeltasDeltaIdRejectPostResponses, RejectDeltaApiV1DeltasDeltaIdRejectPostErrors, ThrowOnError> => (options.client ?? client).post<RejectDeltaApiV1DeltasDeltaIdRejectPostResponses, RejectDeltaApiV1DeltasDeltaIdRejectPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/deltas/{delta_id}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List documents
 *
 * Documents within the request's company scope, most recently received first. Every filter is optional and they combine with AND.
 *
 * `unmatched=true` is the queue of paperwork nobody has attached to a change yet. `current=true` hides the versions that have been superseded. `delta_id` narrows to the documents currently linked to one delta.
 */
export const listDocumentsApiV1DocumentsGet = <ThrowOnError extends boolean = false>(options?: Options<ListDocumentsApiV1DocumentsGetData, ThrowOnError>): RequestResult<ListDocumentsApiV1DocumentsGetResponses, ListDocumentsApiV1DocumentsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListDocumentsApiV1DocumentsGetResponses, ListDocumentsApiV1DocumentsGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/documents',
    ...options
});

/**
 * Upload a supporting document
 *
 * Stores one piece of signed paperwork for the customer company named by `X-Company-Id`, and returns everything recorded about it.
 *
 * **No delta is required.** A document uploaded on its own comes back with `is_unmatched: true` and stays that way until somebody links it, which is what lets paperwork arrive before anybody knows which change it justifies. Link it afterwards with `POST /documents/{document_id}/links`, as many times as it needs -- one signed agreement can cover somebody across several changes.
 *
 * **The type is read from the file, not from its name.** A PDF saved as `.png` is stored as `application/pdf`; a spreadsheet renamed `.pdf` is rejected with `415`. An upload above the configured ceiling is rejected with `413`, and an empty one with `422`.
 *
 * The bytes are encrypted and kept in object storage, never in a database column, and are readable only through the authenticated download endpoint. Nothing is extracted from the document's contents: the effective date of the change it justifies is keyed in by whoever files the delta.
 */
export const uploadDocumentApiV1DocumentsPost = <ThrowOnError extends boolean = false>(options: Options<UploadDocumentApiV1DocumentsPostData, ThrowOnError>): RequestResult<UploadDocumentApiV1DocumentsPostResponses, UploadDocumentApiV1DocumentsPostErrors, ThrowOnError> => (options.client ?? client).post<UploadDocumentApiV1DocumentsPostResponses, UploadDocumentApiV1DocumentsPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/documents',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Fetch a document's metadata
 *
 * Everything recorded about one document, including which deltas it is linked to and whether it is the current version. A document belonging to another company is `404`, and the attempt is recorded in the audit trail.
 */
export const getDocumentApiV1DocumentsDocumentIdGet = <ThrowOnError extends boolean = false>(options: Options<GetDocumentApiV1DocumentsDocumentIdGetData, ThrowOnError>): RequestResult<GetDocumentApiV1DocumentsDocumentIdGetResponses, GetDocumentApiV1DocumentsDocumentIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetDocumentApiV1DocumentsDocumentIdGetResponses, GetDocumentApiV1DocumentsDocumentIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/documents/{document_id}',
    ...options
});

/**
 * Download a document
 *
 * The file as it was uploaded, decrypted and checked against the checksum recorded at upload.
 *
 * **This is the only way to read a document, and it requires a token.** No durable or public URL to a document exists anywhere in this API: nothing is minted here that would let a holder of a string read a termination agreement without going through the same authentication and tenancy rules as every other read. Every download is recorded in the audit trail, naming the principal, the document and the time.
 */
export const downloadDocumentApiV1DocumentsDocumentIdContentGet = <ThrowOnError extends boolean = false>(options: Options<DownloadDocumentApiV1DocumentsDocumentIdContentGetData, ThrowOnError>): RequestResult<DownloadDocumentApiV1DocumentsDocumentIdContentGetResponses, DownloadDocumentApiV1DocumentsDocumentIdContentGetErrors, ThrowOnError> => (options.client ?? client).get<DownloadDocumentApiV1DocumentsDocumentIdContentGetResponses, DownloadDocumentApiV1DocumentsDocumentIdContentGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/documents/{document_id}/content',
    ...options
});

/**
 * Link a document to a delta
 *
 * Claims that this document is the evidence behind one requested change. This is how an unmatched document -- one that arrived before anybody knew what it was for -- is attached afterwards.
 *
 * **A document may be linked to more than one delta.** One signed termination agreement can cover somebody across several changes, so linking again with a different `delta_id` adds a link rather than moving the existing one. Linking to the same delta twice is `409`.
 *
 * A delta of another company is reported as unknown: evidence is never linked across a tenancy boundary.
 */
export const linkDocumentApiV1DocumentsDocumentIdLinksPost = <ThrowOnError extends boolean = false>(options: Options<LinkDocumentApiV1DocumentsDocumentIdLinksPostData, ThrowOnError>): RequestResult<LinkDocumentApiV1DocumentsDocumentIdLinksPostResponses, LinkDocumentApiV1DocumentsDocumentIdLinksPostErrors, ThrowOnError> => (options.client ?? client).post<LinkDocumentApiV1DocumentsDocumentIdLinksPostResponses, LinkDocumentApiV1DocumentsDocumentIdLinksPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/documents/{document_id}/links',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Withdraw a link between a document and a delta
 *
 * Says that this document is no longer claimed as evidence for that delta. **Nothing is deleted.** The link row is stamped with who withdrew it and when, and it stays in the document's `links` with `is_live: false` -- that the two were attached for a time is itself part of the record. The document is untouched, and becomes unmatched again if this was its last live link.
 *
 * The same pair can be linked again afterwards, which adds a new link rather than reviving this one.
 */
export const unlinkDocumentApiV1DocumentsDocumentIdLinksDeltaIdDelete = <ThrowOnError extends boolean = false>(options: Options<UnlinkDocumentApiV1DocumentsDocumentIdLinksDeltaIdDeleteData, ThrowOnError>): RequestResult<UnlinkDocumentApiV1DocumentsDocumentIdLinksDeltaIdDeleteResponses, UnlinkDocumentApiV1DocumentsDocumentIdLinksDeltaIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<UnlinkDocumentApiV1DocumentsDocumentIdLinksDeltaIdDeleteResponses, UnlinkDocumentApiV1DocumentsDocumentIdLinksDeltaIdDeleteErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/documents/{document_id}/links/{delta_id}',
    ...options
});

/**
 * Replace a document with a corrected version
 *
 * Uploads a replacement for an existing document and records that it supersedes it. **This is the only way to correct a document, and it changes nothing about the original**: both versions are retained, both stay downloadable, and each response says which is current.
 *
 * The response describes the new version, with `supersedes_document_id` naming what it replaced. Fetching the original afterwards returns `is_current: false` and `superseded_by_document_id` pointing here.
 *
 * A version that has already been replaced cannot be replaced again: correct the current version instead, so that a chain of corrections has exactly one end. Links are not carried across -- the new version is linked to the deltas it belongs to explicitly, and the original keeps the links it had, which is what it means for both to be retained.
 */
export const supersedeDocumentApiV1DocumentsDocumentIdSupersedePost = <ThrowOnError extends boolean = false>(options: Options<SupersedeDocumentApiV1DocumentsDocumentIdSupersedePostData, ThrowOnError>): RequestResult<SupersedeDocumentApiV1DocumentsDocumentIdSupersedePostResponses, SupersedeDocumentApiV1DocumentsDocumentIdSupersedePostErrors, ThrowOnError> => (options.client ?? client).post<SupersedeDocumentApiV1DocumentsDocumentIdSupersedePostResponses, SupersedeDocumentApiV1DocumentsDocumentIdSupersedePostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/documents/{document_id}/supersede',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Test the connection to eSocial
 *
 * Runs four checks and answers with one result per check. vyttech staff only.
 *
 * 1. **`certificate`** — an A1 certificate is installed, its envelope opens, the archive parses with the password stored beside it, it is inside its validity window, and the key it holds is one a TLS handshake can be made with. No network.
 * 2. **`handshake`** — a mutual-TLS connection to the configured eSocial endpoint, made with that certificate, completes and is not refused. **No company is needed**, which is the point of it: somebody setting a deployment up has nothing to select yet.
 * 3. **`query`** — only when `company_id` is given: a real `ConsultarIdentificadoresEventos` for that company's CNPJ over a small recent window, reporting eSocial's own `cdResposta` and `descResposta` verbatim in `esocial_response_code` and `esocial_response_message`.
 * 4. **`browser`** — a headless Chromium on the backend visits `browser_url`, or `I8LIFE_BROWSER_DIAGNOSTIC_URL` (the eSocial login page) when none is given, presenting the A1 certificate to the origins in `I8LIFE_BROWSER_CERTIFICATE_ORIGINS` and to no other. It reports `browser_final_url`, `browser_http_status`, `browser_page_title` and a screenshot in `browser_screenshot_png_base64`. `skipped` when no browser is configured (`I8LIFE_BROWSER_BACKEND`).
 *
 * **The web-service stages stop at the first failure.** Later ones are reported `skipped` rather than omitted, so the response always describes all four: a stage that did not run and a stage that passed must not look alike. The `browser` stage is a separate channel and depends on `certificate` alone: a failed `handshake` or `query` never skips it, and a failed `browser` never skips them. A failed stage carries a `failure` code to branch on and a `remedy` sentence saying what to go and do.
 *
 * **A company with no CNPJ recorded is `422` before any network call.** eSocial identifies an employer by its CNPJ and by nothing else, so there is no request to make and reporting a failed stage would suggest one was tried.
 *
 * `503` when no eSocial client is configured for this deployment, which is the default — talking to the government is something a deployment turns on. The message names the settings to set.
 *
 * **Every run is recorded in the audit trail** as `esocial.diagnostic_ran` against the `esocial_connection` entity, because it is a use of the platform's signing credential against a government service by a named person. No response, log line or audit entry carries the certificate, its private key or its password — there is no field anywhere in this API that could. The audit entry records the `browser` stage's outcome, final URL and status, and never the screenshot.
 */
export const runDiagnosticsApiV1EsocialDiagnosticsPost = <ThrowOnError extends boolean = false>(options?: Options<RunDiagnosticsApiV1EsocialDiagnosticsPostData, ThrowOnError>): RequestResult<RunDiagnosticsApiV1EsocialDiagnosticsPostResponses, RunDiagnosticsApiV1EsocialDiagnosticsPostErrors, ThrowOnError> => (options?.client ?? client).post<RunDiagnosticsApiV1EsocialDiagnosticsPostResponses, RunDiagnosticsApiV1EsocialDiagnosticsPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/diagnostics',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * What has been staged
 *
 * The staged events, newest first, narrowed by company, by eSocial event type or by the run that brought them in. vyttech staff only (`esocial:read`).
 *
 * **None of these is a roster change.** A row here is the government's copy of something the employer filed, kept beside the roster and touching nothing in it.
 *
 * The person an event is about is named by their **masked** CPF and by the name eSocial holds. The full registry number is encrypted at rest and is not served by this API at all; there is no field here that could carry it, and no CPF travels in the path or the query string.
 */
export const listEventsApiV1EsocialEventsGet = <ThrowOnError extends boolean = false>(options?: Options<ListEventsApiV1EsocialEventsGetData, ThrowOnError>): RequestResult<ListEventsApiV1EsocialEventsGetResponses, ListEventsApiV1EsocialEventsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListEventsApiV1EsocialEventsGetResponses, ListEventsApiV1EsocialEventsGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/events',
    ...options
});

/**
 * Download one staged event as the employer signed it
 *
 * The event's own XML, byte for byte as eSocial sent it, signature included. Nothing is re-serialised on the way in or on the way out: the employer's signature covers the bytes, and a document that had been parsed and re-emitted would no longer verify.
 *
 * It is stored sealed in the same envelope a supporting document's bytes are, outside PostgreSQL, and its digest is checked before this responds — so a copy that was swapped behind the application's back is an error rather than somebody else's event. vyttech staff only (`esocial:read`).
 */
export const downloadEventSourceApiV1EsocialEventsEventIdSourceGet = <ThrowOnError extends boolean = false>(options: Options<DownloadEventSourceApiV1EsocialEventsEventIdSourceGetData, ThrowOnError>): RequestResult<DownloadEventSourceApiV1EsocialEventsEventIdSourceGetResponses, DownloadEventSourceApiV1EsocialEventsEventIdSourceGetErrors, ThrowOnError> => (options.client ?? client).get<DownloadEventSourceApiV1EsocialEventsEventIdSourceGetResponses, DownloadEventSourceApiV1EsocialEventsEventIdSourceGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/events/{event_id}/source',
    ...options
});

/**
 * The fetch history
 *
 * Every run of the intake, newest first, with the four counts and whatever eSocial last said. `company_id` narrows it to one company's.
 *
 * This is the debugging surface of the whole path, and it is why a run is a row rather than only a log line: an empty staging table means *the employer filed nothing*, *the government refused us* or *nobody has run this*, and those are three different mornings. vyttech staff only (`esocial:read`).
 */
export const listFetchesApiV1EsocialFetchesGet = <ThrowOnError extends boolean = false>(options?: Options<ListFetchesApiV1EsocialFetchesGetData, ThrowOnError>): RequestResult<ListFetchesApiV1EsocialFetchesGetResponses, ListFetchesApiV1EsocialFetchesGetErrors, ThrowOnError> => (options?.client ?? client).get<ListFetchesApiV1EsocialFetchesGetResponses, ListFetchesApiV1EsocialFetchesGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/fetches',
    ...options
});

/**
 * Fetch one company's eSocial events now
 *
 * Asks eSocial what it holds about this employer's workers in the window and **stages** the five event types this product reads — `S-2200` admission, `S-2205` registration change, `S-2206` contract change, `S-2230` leave, `S-2299` termination. vyttech staff only (`esocial:write`).
 *
 * **It asks one worker at a time, because that is the only question that is answered.** `ConsultarIdentificadoresEventosEmpregador` replies `402` — *Solicitação inválida. Redefina sua consulta* — to every one of those five types in produção, so there is no 'what did this employer file?' request to send. The run consults `ConsultarIdentificadoresEventosTrabalhador` per CPF instead, over the union of the latest stored monthly worker list and the company's roster, **likely admissions first** (on the list, not on our roster), then likely terminations (on our roster, not on the list), then everybody else.
 *
 * **One run is a slice of a company, not a sweep of one.** eSocial allows an employer roughly ten calls a day across both services, so a run spends at most the configured budget — consultations and downloads counted together — and then stops. It records `workers_consulted` and `workers_remaining` (masked, never the full number), and **running it again over the same window carries on with the remainder** rather than re-spending the budget on the same people.
 *
 * **No delta is created here, by any event, ever.** Nothing is written to the roster, no review item appears, and the review queue is exactly as long afterwards as it was before. A staged event is the government's copy of something the employer's own system filed; deciding what it means for a roster is a separate decision this endpoint does not make.
 *
 * **Running it twice stages nothing the second time.** An event is identified by eSocial's own event id, per employer, and that pair is unique in the database — so two overlapping windows, or two operators pressing the button at once, cannot produce two copies. The repeats come back in `skipped`.
 *
 * **The four counts account for each other**: `staged + skipped + failed = fetched`, where `fetched` is how many events eSocial listed about the workers consulted. `skipped` is broader than 'we already had it': an event that is not one of the five — an `S-1200`, an `S-1210` — arrives from the same consultation and is counted there, as is a filing the monthly worker list already attributed to that worker, which is skipped **without a download**. `refused_consultations` is beside the four rather than in them, and `refused_event_types` is that same number under the name it had before discovery stopped being able to ask by type.
 *
 * **Zero events is a success.** An employer who filed nothing in the window comes back `completed` with every count at zero, because that is an answer. `budget_exhausted` is how that is told apart from a run that ran out of calls, and `roster_fallback` says the run had no worker list to work from — in which case it could not have found an admission nobody has told us about.
 *
 * Omit the window for the configured default, which is what the staff screen sends. `window_end` must be on or after `window_start`.
 *
 * Refused before any network call, with an actionable message and never a `500`: a company whose CNPJ has not been recorded (`422` — eSocial identifies an employer by its CNPJ and by nothing else), a platform with no A1 certificate installed or none that may still be used (`422`, naming the certificate screen), and a window that ends inside the last hour with nothing before it (`422` — the worker consultation will not look at a stretch eSocial has not finished writing). `503` when no eSocial client is configured for this deployment, which is the default.
 *
 * **Every run is recorded** as `esocial.events_fetched` against the `esocial_fetch` entity, with the person who ran it on it, and is readable afterwards at `GET /esocial/fetches`. Not one CPF and not one name from any event reaches the audit entry, and not one reaches a log line.
 */
export const fetchEventsApiV1EsocialFetchesPost = <ThrowOnError extends boolean = false>(options: Options<FetchEventsApiV1EsocialFetchesPostData, ThrowOnError>): RequestResult<FetchEventsApiV1EsocialFetchesPostResponses, FetchEventsApiV1EsocialFetchesPostErrors, ThrowOnError> => (options.client ?? client).post<FetchEventsApiV1EsocialFetchesPostResponses, FetchEventsApiV1EsocialFetchesPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/fetches',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Turn one run's staged events into requested changes
 *
 * Walks every event this run staged, works out which movement it asks for, and submits it through the delta layer against the contract named in the body. vyttech staff only (`esocial:write`).
 *
 * **Nothing here writes a roster fact.** Every movement is *submitted*, which means it appears in the vyttech review queue with intake channel `esocial` and waits for a reviewer exactly as a movement typed into the portal does. Approving is that reviewer's decision, rejecting one works as it does for any other channel, and neither is this endpoint's.
 *
 * **Nothing here bypasses delta validation either.** Each event goes through the same `submit_delta` a portal filing goes through, so a movement the roster cannot accept on its effective date is refused — and refused *per event*: the refusal's own message is recorded on that event and the rest of the batch still commits. That is the whole reason a sheet with two bad lines out of four hundred commits three hundred and ninety-eight, applied here.
 *
 * **Each event ends in exactly one of three outcomes**, and they are different mornings:
 *
 * - **`committed`** — it became a movement, and `delta_id` names it. `S-2200` an admission, `S-2299` a termination, `S-2206` and `S-2205` a salary change when the payload carries a remuneration, `S-2230` a leave with the return date when eSocial already knows it — each on the event's own effective date.
 * - **`no_action`** — it was read and carries no change this roster models: a cadastral edit to a field we do not track, an *alteração* with no remuneration in it. `outcome_reason` says which, and there is nothing to do about it.
 * - **`refused`** — the delta layer would not accept it, and `outcome_reason` carries its words. Somebody has to look.
 *
 * **`committed + no_action + refused = staged`**, always.
 *
 * **Confirming twice is `409`**, naming the earlier commit in the message and its identifier in `details` — the second press of a button is a retry far more often than it is a mistake, and committing again would ask for every movement a second time. A contract belonging to another company is `422`.
 *
 * **The trail gets both levels.** One `roster_delta.submitted` entry per movement from the delta layer itself, and one `esocial.events_committed` entry for the batch, both carrying the staff principal that confirmed.
 */
export const confirmFetchApiV1EsocialFetchesFetchIdConfirmPost = <ThrowOnError extends boolean = false>(options: Options<ConfirmFetchApiV1EsocialFetchesFetchIdConfirmPostData, ThrowOnError>): RequestResult<ConfirmFetchApiV1EsocialFetchesFetchIdConfirmPostResponses, ConfirmFetchApiV1EsocialFetchesFetchIdConfirmPostErrors, ThrowOnError> => (options.client ?? client).post<ConfirmFetchApiV1EsocialFetchesFetchIdConfirmPostResponses, ConfirmFetchApiV1EsocialFetchesFetchIdConfirmPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/fetches/{fetch_id}/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Which browser this deployment's portal walks drive
 *
 * `I8LIFE_BROWSER_BACKEND`, and whether that browser is remote -- a Chromium somebody else runs, reached over the DevTools protocol, with a person at it who signs in to gov.br and solves the captcha when it shows (#477). vyttech staff only (`esocial:read`). **Never where the browser is**: `I8LIFE_BROWSER_CDP_URL` names a socket into somebody's desktop and appears in no answer.
 */
export const readPortalBrowserApiV1EsocialPortalBrowserGet = <ThrowOnError extends boolean = false>(options?: Options<ReadPortalBrowserApiV1EsocialPortalBrowserGetData, ThrowOnError>): RequestResult<ReadPortalBrowserApiV1EsocialPortalBrowserGetResponses, ReadPortalBrowserApiV1EsocialPortalBrowserGetErrors, ThrowOnError> => (options?.client ?? client).get<ReadPortalBrowserApiV1EsocialPortalBrowserGetResponses, ReadPortalBrowserApiV1EsocialPortalBrowserGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/portal-browser',
    ...options
});

/**
 * The session walk history
 *
 * Every session walk, **newest first**: the shared login stage, one entry per company with its walk id, outcome and duration, and the session's total. vyttech staff only (`esocial:read`). A caller confined to one company sees only the sessions of that company alone.
 */
export const listPortalSessionsApiV1EsocialPortalSessionsGet = <ThrowOnError extends boolean = false>(options?: Options<ListPortalSessionsApiV1EsocialPortalSessionsGetData, ThrowOnError>): RequestResult<ListPortalSessionsApiV1EsocialPortalSessionsGetResponses, ListPortalSessionsApiV1EsocialPortalSessionsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListPortalSessionsApiV1EsocialPortalSessionsGetResponses, ListPortalSessionsApiV1EsocialPortalSessionsGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/portal-sessions',
    ...options
});

/**
 * Log in to the eSocial portal once and walk several companies
 *
 * A **session walk**: one gov.br login with the platform's A1 -- the `login` stage of `POST /esocial/portal-walks`, certificate leg and all -- and then, for each company of `company_ids` **in the order given**, back to the profile chooser (*Trocar Perfil/Módulo*), *Procurador de Pessoa Jurídica - CNPJ* with that company's CNPJ, *Verificar*, the reports module, and the per-company stages of `mode`. A scraping day then costs one human-assisted login, not one per customer. vyttech staff only (`esocial:write`).
 *
 * ### Each company is an ordinary walk
 *
 * Every company walked gets an `EsocialPortalWalk` row with `session_id` set, whose `login` stage is `inherited` and points at the session. `GET /esocial/portal-walks/{walk_id}`, its stage evidence and its bundle read it unchanged; the login's own evidence is the session's, at `/esocial/portal-sessions/{id}/login/{artefact}`. Each walk leaves its own `esocial.portal_walk_ran`, and the session one `esocial.portal_session_ran`.
 *
 * ### One company never stops the next
 *
 * Every company gets an entry with an `outcome`, never an error:
 *
 * - `completed` — every stage planned for it ran.
 * - `failed` with `failure_code` **`procuracao_missing`** — the chooser refused the CNPJ; `portal_message` is the portal's words (*O procurador não possui perfil com autorização de acesso à Web*) and `remedy` names the company and the CNPJ a web-access procuração must be granted to. The next company runs.
 * - `failed` with **`session_expired`** — the browser was back on the eSocial login or gov.br's chooser when the company started. It and **every later company** get it; the session **never signs in again**, because the sign-in may need a person.
 * - `failed` with whatever else the stages produce, as on a single walk.
 * - `skipped` with `skipped_reason` `login_failed` (the shared login failed) or `stop_after` (`stop_after=login`).
 *
 * The session's `outcome` is `completed` when every company ran to its last planned stage, `partial` when at least one failed or was not walked, and `failed` when the shared login failed. Between companies the walk presses the reports module's *Trocar Perfil/Módulo*, **never *SAIR***.
 *
 * ### Budget and time
 *
 * No request the single walk does not make. The portal allows 10 report requests per user, **per employer**, per day, so a session of many companies is within it; each company's `request` run counts towards the limit `POST /esocial/worker-reports` enforces, as a single walk's does. `stop_after=module` makes no request for any company. The reports module counts down 30 minutes from the login: every entry carries `duration_seconds`, and the session its total, so that window can be judged from history.
 *
 * ### When it refuses
 *
 * `422`, **before any browser is opened** and leaving no row: an empty list or more than 50 companies, a company named twice, a company the caller cannot see or without a CNPJ (`field: company_ids`), and everything a single walk refuses. `503` when no portal browser is configured, or the remote one cannot be reached.
 *
 * ### Privacy
 *
 * As the single walk: the session row, the answers, the logs and the trail carry identifiers, outcome words, codes, the portal's scrubbed messages and the filters as given -- never a CPF, a worker's name, a CNPJ in a query string, a cookie or a token.
 */
export const runPortalSessionApiV1EsocialPortalSessionsPost = <ThrowOnError extends boolean = false>(options: Options<RunPortalSessionApiV1EsocialPortalSessionsPostData, ThrowOnError>): RequestResult<RunPortalSessionApiV1EsocialPortalSessionsPostResponses, RunPortalSessionApiV1EsocialPortalSessionsPostErrors, ThrowOnError> => (options.client ?? client).post<RunPortalSessionApiV1EsocialPortalSessionsPostResponses, RunPortalSessionApiV1EsocialPortalSessionsPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/portal-sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One session walk, with its login and every company
 *
 * One session: its plan, the shared login stage as a walk records one, and one entry per company with its walk id, outcome, failure code, remedy and duration. vyttech staff only (`esocial:read`). A session with a company the caller cannot see is `404`, indistinguishable from one that does not exist.
 */
export const readPortalSessionApiV1EsocialPortalSessionsSessionIdGet = <ThrowOnError extends boolean = false>(options: Options<ReadPortalSessionApiV1EsocialPortalSessionsSessionIdGetData, ThrowOnError>): RequestResult<ReadPortalSessionApiV1EsocialPortalSessionsSessionIdGetResponses, ReadPortalSessionApiV1EsocialPortalSessionsSessionIdGetErrors, ThrowOnError> => (options.client ?? client).get<ReadPortalSessionApiV1EsocialPortalSessionsSessionIdGetResponses, ReadPortalSessionApiV1EsocialPortalSessionsSessionIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/portal-sessions/{session_id}',
    ...options
});

/**
 * Read back the screenshot taken after one action of a session walk's login
 *
 * The viewport PNG sealed right after action `number` of the shared login, as the login's `action_screenshots` lists them. vyttech staff only (`esocial:read`), the same gate, scope, headers and audit entry as the login's other artefacts.
 */
export const readPortalSessionActionScreenshotApiV1EsocialPortalSessionsSessionIdLoginActionsNumberGet = <ThrowOnError extends boolean = false>(options: Options<ReadPortalSessionActionScreenshotApiV1EsocialPortalSessionsSessionIdLoginActionsNumberGetData, ThrowOnError>): RequestResult<ReadPortalSessionActionScreenshotApiV1EsocialPortalSessionsSessionIdLoginActionsNumberGetResponses, ReadPortalSessionActionScreenshotApiV1EsocialPortalSessionsSessionIdLoginActionsNumberGetErrors, ThrowOnError> => (options.client ?? client).get<ReadPortalSessionActionScreenshotApiV1EsocialPortalSessionsSessionIdLoginActionsNumberGetResponses, ReadPortalSessionActionScreenshotApiV1EsocialPortalSessionsSessionIdLoginActionsNumberGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/portal-sessions/{session_id}/login/actions/{number}',
    ...options
});

/**
 * Read back one sealed artefact of a session walk's login
 *
 * The shared login's `screenshot`, `html` or `trace`, **byte for byte**, as `/esocial/portal-walks/{run_id}/stages/0/{artefact}` reads a single walk's. vyttech staff only (`esocial:read`); always an attachment, with the same headers. The address is derived from the session, never read from a caller. `404` for an unknown session, one the caller cannot see, or an artefact the login did not keep. Every successful read leaves one `esocial.portal_walk_evidence_read` against the `esocial_portal_session` entity.
 */
export const readPortalSessionEvidenceApiV1EsocialPortalSessionsSessionIdLoginArtefactGet = <ThrowOnError extends boolean = false>(options: Options<ReadPortalSessionEvidenceApiV1EsocialPortalSessionsSessionIdLoginArtefactGetData, ThrowOnError>): RequestResult<ReadPortalSessionEvidenceApiV1EsocialPortalSessionsSessionIdLoginArtefactGetResponses, ReadPortalSessionEvidenceApiV1EsocialPortalSessionsSessionIdLoginArtefactGetErrors, ThrowOnError> => (options.client ?? client).get<ReadPortalSessionEvidenceApiV1EsocialPortalSessionsSessionIdLoginArtefactGetResponses, ReadPortalSessionEvidenceApiV1EsocialPortalSessionsSessionIdLoginArtefactGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/portal-sessions/{session_id}/login/{artefact}',
    ...options
});

/**
 * The portal walk history
 *
 * Every walk, newest first, narrowed by company. vyttech staff only (`esocial:read`). Each walk carries its stages, their outcomes and which artefacts each kept — never a CPF and never a worker's name.
 */
export const listPortalWalksApiV1EsocialPortalWalksGet = <ThrowOnError extends boolean = false>(options?: Options<ListPortalWalksApiV1EsocialPortalWalksGetData, ThrowOnError>): RequestResult<ListPortalWalksApiV1EsocialPortalWalksGetResponses, ListPortalWalksApiV1EsocialPortalWalksGetErrors, ThrowOnError> => (options?.client ?? client).get<ListPortalWalksApiV1EsocialPortalWalksGetResponses, ListPortalWalksApiV1EsocialPortalWalksGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/portal-walks',
    ...options
});

/**
 * Walk the eSocial web portal for one company, sealing every screen
 *
 * Signs in to the eSocial web portal through gov.br with the platform's A1 certificate, as *procurador* of one company, and walks towards the *Relação de Trabalhadores - eSocial* report **one stage at a time**, sealing a full-page screenshot and the HTML of every screen it reaches. vyttech staff only (`esocial:read`), the same gate and tenant scope as the capability probe.
 *
 * **This is an instrument, not a feature.** It is run on staging, where the certificate is, so that what the portal actually showed can be read back and the walk corrected from it. Nothing in the product reads what it records.
 *
 * ### The stages
 *
 * - **`login`** — open `https://login.esocial.gov.br/` (`I8LIFE_BROWSER_PORTAL_LOGIN_URL`), take the gov.br certificate option, arrive logged in on the Web Geral home.
 * - **`profile`** — follow *Trocar Perfil/Módulo* to the profile chooser, choose *Procurador de Pessoa Jurídica - CNPJ*, type the company's CNPJ and press *Verificar*; records the profiles offered. When the portal refuses the procuração, the stage fails and its message is recorded verbatim in `portal_message`. For the company the certificate is itself filed under, the titular profile instead, with no procuração.
 * - **`module`** — open the *Emissão de Relatórios Gerenciais* card, and from the reports module's home its management screen, *Relatórios Gerenciais* (`/relatorios/gerenciamento`); records the report type and employer number shown.
 * - **`request`** — *Solicitar Novo Relatório* with `filters`, *Solicitar relatório*, and record the portal's answer verbatim (*Relatório solicitado com sucesso.*).
 * - **`list`** — read *Relatórios Solicitados*: type, records retrieved, filters, requested at, available until, the state **word verbatim** (*Pendente, Processado, Vazio, Concluído, Excedido*) beside its parsed value, and the enabled download formats. A word the walk does not know is recorded as `unknown` and does not fail the stage.
 * - **`download`** — the newest *Processado* row, or the one whose *Solicitado em* is `collect.requested_at`, in `collect.format` (xlsx by default); the file is sealed with its filename and content type.
 *
 * `mode=request` walks `login` → `profile` → `module` → `request` → `list`; `mode=collect` walks `login` → `profile` → `module` → `list` → `download`. **A collect run never requests and a request run never downloads.** `stop_after` truncates the walk; every stage of the mode is still listed, and those after it are `skipped`.
 *
 * ### The portal's daily limit
 *
 * **The portal allows 10 report requests per user, per employer, per day. This endpoint does not enforce that limit** — but every `request` run that reaches its `request` stage counts towards the limit `POST /esocial/worker-reports` does enforce. Only a `request` run that reaches its `request` stage spends one; use `stop_after` to work on the earlier stages without spending any.
 *
 * ### Failure, and evidence
 *
 * **A failed stage stops the walk**: it is `failed` with a sanitised message, and every later stage is `skipped`. **Its screenshot and HTML are sealed anyway** — evidence is saved before anything a stage found is judged — and are readable from `/esocial/portal-walks/{run_id}/stages/{index}/{artefact}`. A browser that would not start is a failed `login` with no artefacts. When the browser itself failed — it would not start, the certificate could not be bundled, or a page never arrived (the network, the TLS handshake that presents the certificate, the timeout) — the failed stage also carries `failure_code` and `remedy`, the same code and advice the connection diagnostic's `browser` stage gives. Each walk logs in afresh in a browser context that is closed when it ends, failed or not.
 *
 * ### The trace, and a screenshot per action
 *
 * Every stage that ran also seals a **`trace`**: a JSON document of the driver's actions (locator in words, start, end, outcome), the main-frame navigations with their titles, every request the page made (method, URL, resource type, status or the browser's `net::ERR_...` failure, start and end, size), the console's messages by level and first line, and **the requests still pending when the stage ended** — a request that never answered is listed there, which is what tells a hung certificate leg from a slow one. Times are milliseconds since the run's page was opened. **It never holds a header, a request or response body, or a cookie**, and every URL and message in it is scrubbed of anything shaped like a CPF. Each kind is capped at a few hundred entries per stage, and the trace says when the cap was hit. After every `navigate`, `click`, `fill`, `choose` and `set_checked` a **viewport screenshot** is sealed too, numbered in order, at most 20 per stage, listed on the stage as `action_screenshots`; one that cannot be taken never fails the action. When a click lands on Playwright's client-certificate error page, the next call that fails reports the handshake, with the navigation `failure_code`, rather than a locator timeout.
 *
 * ### The timeout
 *
 * `timeout_seconds`, between 5 and 300, is how long each page action may take on this run; absent, the deployment's `I8LIFE_BROWSER_TIMEOUT_SECONDS`. It is recorded on the run and echoed back. A timed-out action's `failure` quotes the milliseconds.
 *
 * ### Privacy
 *
 * The list and download screens and the report name real workers; **they exist only in the sealed artefacts** (AES-GCM, in contexts of their own, under keys that include the company and the run). The answer, the stored run, the logs and the audit entry carry stage names, outcomes, URLs, titles, the portal's messages and states, counts and the filters as given — **never a CPF and never a worker's name**. A `cpf` filter is stored as a blind index and echoed masked.
 *
 * ### When it refuses
 *
 * `422`, **before any browser is launched**: a company without a CNPJ; a platform without a usable A1 certificate; a `stop_after` that is not one of the mode's stages; an invalid `cpf`; a date range that ends before it starts; `filters` on a collect run; `collect` on a request run; a `timeout_seconds` outside 5 to 300. `404` for a company outside the caller's scope. `503` when no portal browser is configured (`I8LIFE_BROWSER_BACKEND`), which is the default, and when the remote browser of `remote_chromium` cannot be reached at `I8LIFE_BROWSER_CDP_URL` -- the tunnel is down, or its Chromium is showing the *Allow remote debugging?* prompt and nobody pressed Allow; no run is recorded then.
 *
 * ### A remote browser
 *
 * With `I8LIFE_BROWSER_BACKEND=remote_chromium` the walk drives a Chromium somebody else runs, in a context of its own that it closes at the end, leaving that browser's other tabs alone. **That browser is never given the certificate**: the backend makes the certificate hop. When gov.br shows a visible captcha challenge, the `login` stage waits for the person at that browser to solve it, up to the run's timeout, and records `captcha_solved_by_person` and `captcha_solve_seconds`. When gov.br asks for its two-step verification (#483), the walk ticks *Não solicitar verificação em duas etapas novamente neste navegador* and waits, up to the run's timeout, for the person to type the code from the gov.br app, and records `two_step_completed_by_person` and `two_step_seconds`; headless, the login fails at once with `browser_two_step_required`, and unanswered with `browser_two_step_unanswered`. A download is fetched again through the backend rather than read from that machine. The run records `browser_backend`.
 *
 * **Every walk leaves exactly one audit entry**, `esocial.portal_walk_ran` against the `esocial_portal_walk` entity, carrying the mode, the stage names, their outcomes and the portal's state words.
 */
export const runPortalWalkApiV1EsocialPortalWalksPost = <ThrowOnError extends boolean = false>(options: Options<RunPortalWalkApiV1EsocialPortalWalksPostData, ThrowOnError>): RequestResult<RunPortalWalkApiV1EsocialPortalWalksPostResponses, RunPortalWalkApiV1EsocialPortalWalksPostErrors, ThrowOnError> => (options.client ?? client).post<RunPortalWalkApiV1EsocialPortalWalksPostResponses, RunPortalWalkApiV1EsocialPortalWalksPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/portal-walks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One portal walk, with its stages
 *
 * One walk, its stages in order with their outcomes, and which sealed artefacts each stage kept. vyttech staff only (`esocial:read`). A walk of a company this request cannot see is `404`, indistinguishable from one that does not exist.
 */
export const readPortalWalkApiV1EsocialPortalWalksRunIdGet = <ThrowOnError extends boolean = false>(options: Options<ReadPortalWalkApiV1EsocialPortalWalksRunIdGetData, ThrowOnError>): RequestResult<ReadPortalWalkApiV1EsocialPortalWalksRunIdGetResponses, ReadPortalWalkApiV1EsocialPortalWalksRunIdGetErrors, ThrowOnError> => (options.client ?? client).get<ReadPortalWalkApiV1EsocialPortalWalksRunIdGetResponses, ReadPortalWalkApiV1EsocialPortalWalksRunIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/portal-walks/{run_id}',
    ...options
});

/**
 * Download a whole portal walk as one zip
 *
 * Every artefact a portal walk sealed -- each stage's screenshot, HTML, trace and after-action screenshots, and the downloaded report when there is one -- with the run's summary, as **one `application/zip`**. vyttech staff only (`esocial:read`), the same gate and tenant scope as the artefact reader.
 *
 * ### What is inside
 *
 * - `README.txt` — the run for a person, in pt-BR: company, CNPJ, mode, stop-after stage, outcome, moments, who asked, and each stage with its outcome and the portal's own words.
 * - `run.json` — the run exactly as `GET /esocial/portal-walks/{run_id}` answers it, with the company's name.
 * - `NN-<stage>/screenshot.png`, `NN-<stage>/page.html`, `NN-<stage>/trace.json` and, on `download`, the report under the portal's own filename. `NN` is the stage index, from zero. A stage that kept nothing has no folder.
 * - `NN-<stage>/AA-<action>-<target>.png` — the viewport screenshot after action `AA` of the stage, e.g. `03-click-seu-certificado-digital.png`.
 *
 * Named `percurso-portal-esocial-<company slug>-<YYYY-MM-DD-HHMM>.zip`, the moment the walk started in São Paulo time, in `Content-Disposition`.
 *
 * **Built in memory, never on disk**, and every artefact is unsealed before the first byte is sent: one that is gone or will not open is a `500` for the whole archive, never a zip missing a stage. `404`, decided from the run's row, for an unknown run or one of a company outside the caller's scope.
 *
 * **Every download leaves exactly one audit entry**, `esocial.portal_walk_bundle_read`, naming the run and listing the artefacts it carried -- not one entry per artefact. A refused or `404` download leaves none.
 */
export const downloadPortalWalkBundleApiV1EsocialPortalWalksRunIdBundleGet = <ThrowOnError extends boolean = false>(options: Options<DownloadPortalWalkBundleApiV1EsocialPortalWalksRunIdBundleGetData, ThrowOnError>): RequestResult<DownloadPortalWalkBundleApiV1EsocialPortalWalksRunIdBundleGetResponses, DownloadPortalWalkBundleApiV1EsocialPortalWalksRunIdBundleGetErrors, ThrowOnError> => (options.client ?? client).get<DownloadPortalWalkBundleApiV1EsocialPortalWalksRunIdBundleGetResponses, DownloadPortalWalkBundleApiV1EsocialPortalWalksRunIdBundleGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/portal-walks/{run_id}/bundle',
    ...options
});

/**
 * Read back the screenshot taken after one action of a portal walk
 *
 * The viewport PNG sealed right after action `number` of stage `index` — the stage's `action_screenshots` lists which numbers it kept and the action each followed. vyttech staff only (`esocial:read`), the same gate, tenant scope and headers as the other artefacts.
 *
 * **`404`, decided from the run's own row**, for an unknown run, an index it does not have, or a number the stage did not keep. A sealed object that is gone or will not open is a `500`.
 *
 * **Every successful read leaves one audit entry**, `esocial.portal_walk_evidence_read`, naming the run, the stage, `screenshot` and the action number.
 */
export const readPortalWalkActionScreenshotApiV1EsocialPortalWalksRunIdStagesIndexActionsNumberGet = <ThrowOnError extends boolean = false>(options: Options<ReadPortalWalkActionScreenshotApiV1EsocialPortalWalksRunIdStagesIndexActionsNumberGetData, ThrowOnError>): RequestResult<ReadPortalWalkActionScreenshotApiV1EsocialPortalWalksRunIdStagesIndexActionsNumberGetResponses, ReadPortalWalkActionScreenshotApiV1EsocialPortalWalksRunIdStagesIndexActionsNumberGetErrors, ThrowOnError> => (options.client ?? client).get<ReadPortalWalkActionScreenshotApiV1EsocialPortalWalksRunIdStagesIndexActionsNumberGetResponses, ReadPortalWalkActionScreenshotApiV1EsocialPortalWalksRunIdStagesIndexActionsNumberGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/portal-walks/{run_id}/stages/{index}/actions/{number}',
    ...options
});

/**
 * Read back one sealed artefact of a portal walk
 *
 * One artefact a portal walk sealed, **byte for byte**: `screenshot` (a full-page PNG, `image/png`), `html` (the page, `text/html`), `trace` (the stage's actions, navigations, network log, console and pending requests, `application/json`) or `file` (the downloaded report, with its own content type and the portal's filename). vyttech staff only (`esocial:read`), the same gate and tenant scope as the walk.
 *
 * **The caller does not say where the bytes are.** The address is computed from the run, the stage index and the artefact, by the code that wrote it.
 *
 * **Always an attachment, never rendered.** The page HTML came from the portal and must not run from this origin: `Content-Disposition: attachment`, `X-Content-Type-Options: nosniff`, a sandboxing `Content-Security-Policy` and `Cache-Control: no-store`.
 *
 * **`404`, decided from the run's own row before the object store is touched**, for an unknown run or one of a company outside the caller's scope, an index the run does not have, and an artefact that stage did not produce (a skipped stage keeps nothing; only `download` keeps a `file`). A sealed object that is gone or will not open is a `500`.
 *
 * **Every successful read leaves one audit entry**, `esocial.portal_walk_evidence_read`, naming the run, the stage and the artefact — because the list and download screens and the report name real workers. A refused or `404` read leaves none.
 */
export const readPortalWalkEvidenceApiV1EsocialPortalWalksRunIdStagesIndexArtefactGet = <ThrowOnError extends boolean = false>(options: Options<ReadPortalWalkEvidenceApiV1EsocialPortalWalksRunIdStagesIndexArtefactGetData, ThrowOnError>): RequestResult<ReadPortalWalkEvidenceApiV1EsocialPortalWalksRunIdStagesIndexArtefactGetResponses, ReadPortalWalkEvidenceApiV1EsocialPortalWalksRunIdStagesIndexArtefactGetErrors, ThrowOnError> => (options.client ?? client).get<ReadPortalWalkEvidenceApiV1EsocialPortalWalksRunIdStagesIndexArtefactGetResponses, ReadPortalWalkEvidenceApiV1EsocialPortalWalksRunIdStagesIndexArtefactGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/portal-walks/{run_id}/stages/{index}/{artefact}',
    ...options
});

/**
 * Run one capability probe against eSocial and keep every byte
 *
 * Runs an ordered list of eSocial calls against one company, **one at a time**, and answers with what the government said to each. vyttech staff only (`esocial:read`), the same gate as the connection diagnostic.
 *
 * **This is an instrument, not a feature.** Nothing it does touches a roster, a delta, the review queue or the staging tables, and nothing in the product reads what it records. It exists to answer, from *produção* rather than from the manual, which shape event discovery should take.
 *
 * ### Budget, and the blackout
 *
 * **eSocial allows one employer roughly 10 calls a day** across `WsConsultarIdentificadoresEventos` and `WsSolicitarDownloadEventos` together, **allows no parallel calls**, and **refuses everything on days 1-7 of the month**. A run is therefore capped at **8 steps** (`422` above that, and nothing is sent). The daily budget itself is **not enforced across runs** — counting it is the caller's, and two runs of eight steps in one morning will be refused by the government rather than by this endpoint.
 *
 * ### The five steps
 *
 * - **`table_query`** (`tp_evt`) — `ConsultarIdentificadoresEventosTabela`. The employer's own registration data; proves certificate, channel and *procuração* without naming a competence, a window or a person.
 * - **`employer_query`** (`tp_evt`, `per_apur`) — `ConsultarIdentificadoresEventosEmpregador`, over exactly that one competence and therefore exactly one call.
 * - **`worker_query`** (`cpf`, `start`, `end`) — `ConsultarIdentificadoresEventosTrabalhador`. The window is over when eSocial *received* each event, may span at most 31 days, and must end at least 1 hour(s) ago. **Both rules are enforced here, before anything is sent** — a refusal we can predict must not cost one of the day's calls.
 * - **`download_by_id`** (`event_id`) — `SolicitarDownloadEventosPorId`.
 * - **`download_by_receipt`** (`receipt`) — `SolicitarDownloadEventosPorNrRecibo`. The only step that reports `receipt_has_cpfs` and `receipt_cpf_count`.
 *
 * `nr_insc_mode` is per step: `full` sends all fourteen digits of the company's CNPJ in `ideEmpregador/nrInsc`, `base` sends the eight-digit root. The schema accepts both and the manual does not say which eSocial wants — running the same query twice and comparing is the point.
 *
 * ### What comes back, and what never does
 *
 * Each step reports eSocial's `cd_resposta` and `desc_resposta` **verbatim**, the HTTP status underneath them, the identifiers or receipts returned, and for a download the event's root element and whether the receipt carried a `cpfs` — **as a count, never as values**.
 *
 * **A refused step does not stop the run.** `402` and `406` are answers and are the *expected* outcome of asking the employer consultation about a worker event; a step that fails at the transport level is recorded in `failure` and the run continues to the next.
 *
 * **Every byte of every exchange is kept, sealed.** The raw request and the raw response go into the object store in the same AES-GCM envelope a staged event's XML uses, under the keys each step reports. **No CPF appears anywhere in plain outside those encrypted payloads**: the answer masks it to `***.***.*NN-NN`, the stored run holds only a blind index of it, and the audit entry has no field that could carry one.
 *
 * **That includes an answer this client could not read.** A SOAP fault is what WCF returns when a request is not shaped the way the service expects, so it is a likely answer here and the one the bytes matter most for; the step reports the fault in `failure` and **still carries its `request_key` and `response_key`**. Only a step where nothing was exchanged — a window refused before sending, a handshake, a timeout — has no keys.
 *
 * ### When it refuses
 *
 * `422`, all of them **before any network call**, so none costs one of the day's ten:
 *
 * - a company whose CNPJ has not been recorded;
 * - a platform with no usable A1 certificate;
 * - a run over the step cap;
 * - a step missing a field its `kind` requires, naming the field;
 * - a `per_apur` that is not a `YYYY-MM` competence;
 * - **a `cpf` that is not a valid CPF** — wrong length, non-digits, or check digits that do not match. An ordinary mistype is refused here rather than spending a call on a refusal eSocial would have made, and the message says which rule failed without echoing the digits.
 *
 * `503` when no eSocial client is configured, which is the default.
 *
 * **Every run leaves exactly one audit entry**, `esocial.probe_ran` against the `esocial_probe_run` entity, carrying the step kinds and eSocial's response codes and **no response body and no CPF**.
 */
export const runProbeApiV1EsocialProbesPost = <ThrowOnError extends boolean = false>(options: Options<RunProbeApiV1EsocialProbesPostData, ThrowOnError>): RequestResult<RunProbeApiV1EsocialProbesPostResponses, RunProbeApiV1EsocialProbesPostErrors, ThrowOnError> => (options.client ?? client).post<RunProbeApiV1EsocialProbesPostResponses, RunProbeApiV1EsocialProbesPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/probes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read back one probe step's sealed request or response
 *
 * One half of one exchange a capability probe kept, **byte for byte as it went over the wire**. vyttech staff only (`esocial:read`), the same gate and the same tenant scope as the probe that produced it.
 *
 * The probe seals every request and every response of every step into the object store. This is the only thing that opens them, and it exists because the alternative is hand-unsealing envelopes against production with the platform's keys in order to settle a question like *this receipt has a `cpfs` element and it counts zero entries — which is it?*
 *
 * **Nothing is re-serialised, and nothing is wrapped.** The body is the bytes: a signed SOAP envelope on the way out, whatever arrived on the way back — which may be a SOAP fault or a load balancer's error page, and those are exactly the answers the bytes are kept for. It is served as `application/octet-stream` and as an attachment, deliberately: this endpoint will not claim a document is XML when the whole reason to read it may be that it is not, and evidence from outside is not a thing to let a browser render from our own origin. `Cache-Control: no-store`.
 *
 * **The caller does not say where the bytes are.** The address in the object store is computed from the run, the step's position in it and the direction, by the same code that wrote it. There is no form of this request that carries a storage key — one that unsealed a key it was handed would be a decryption oracle for every staged event and every supporting document in the same bucket.
 *
 * **`404`, decided from the run's own row and before the object store is touched at all**, for three things: a run that does not exist or belongs to a company this request cannot see; a `step_index` the run does not have; and a step that **exchanged nothing** — a worker window refused before sending, a handshake that did not complete, a timeout. The probe already tells that last case apart by reporting no `request_key` and no `response_key` for the step, and this reads the same distinction. A stored object that is missing or will not open is a `500` and never an empty `200`: zero bytes served as though they were the evidence is the one answer worse than an error.
 *
 * **The integrity check is the envelope itself.** It authenticates its own ciphertext under a context naming the half, so a corrupted object, a truncated one and a response stored where a request should be all fail to open rather than opening into something plausible.
 *
 * **Every successful read leaves one audit entry**, `esocial.probe_evidence_read` against the `esocial_probe_run` entity, naming the run, the step index, the direction and the person — because a `worker_query`'s request bytes carry a CPF in plain, which is what sealed evidence *is*. **No CPF and no byte of the payload reaches that entry, this endpoint's error messages, or any log line.** A refused or `404` request leaves no entry: recording one would say evidence was read when none was.
 */
export const readProbeEvidenceApiV1EsocialProbesRunIdStepsStepIndexDirectionGet = <ThrowOnError extends boolean = false>(options: Options<ReadProbeEvidenceApiV1EsocialProbesRunIdStepsStepIndexDirectionGetData, ThrowOnError>): RequestResult<ReadProbeEvidenceApiV1EsocialProbesRunIdStepsStepIndexDirectionGetResponses, ReadProbeEvidenceApiV1EsocialProbesRunIdStepsStepIndexDirectionGetErrors, ThrowOnError> => (options.client ?? client).get<ReadProbeEvidenceApiV1EsocialProbesRunIdStepsStepIndexDirectionGetResponses, ReadProbeEvidenceApiV1EsocialProbesRunIdStepsStepIndexDirectionGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/probes/{run_id}/steps/{step_index}/{direction}',
    ...options
});

/**
 * The worker-list capture history
 *
 * Every capture, newest first, narrowed by company and by competence. vyttech staff only (`esocial:read`).
 *
 * This is the debugging surface of the path, and it is why a capture is a row rather than only a log line: an empty list means *the employer has not closed the month*, *we already hold this closing*, *the government refused us* or *the closing would not parse*, and those are four different mornings. `status` is which.
 *
 * **Superseded lists are listed too.** A competence captured twice has two rows and neither is deleted; `is_current` and `superseded_at` say which one stands. No worker appears here — the entries are on the detail.
 */
export const listWorkerListsApiV1EsocialWorkerListsGet = <ThrowOnError extends boolean = false>(options?: Options<ListWorkerListsApiV1EsocialWorkerListsGetData, ThrowOnError>): RequestResult<ListWorkerListsApiV1EsocialWorkerListsGetResponses, ListWorkerListsApiV1EsocialWorkerListsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListWorkerListsApiV1EsocialWorkerListsGetResponses, ListWorkerListsApiV1EsocialWorkerListsGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/worker-lists',
    ...options
});

/**
 * Capture one month's worker list from its closing receipt
 *
 * Reads the *Lista de Trabalhadores* for one company and one competence out of that month's `S-1299` closing, and stores it: one row per worker the closing covered. vyttech staff only (`esocial:write`).
 *
 * ### Two calls, and that is the whole point
 *
 * eSocial allows an employer roughly ten calls a day across `WsConsultarIdentificadoresEventos` and `WsSolicitarDownloadEventos` together, so a monthly roster cannot be assembled one worker at a time. This costs **exactly two**:
 *
 * 1. `ConsultarIdentificadoresEventosEmpregador` for `S-1299` over a window covering that one competence — one `perApur`, therefore one request — asking with the **eight-digit CNPJ base root**, which is the form a produção probe run established the service answers to.
 * 2. `SolicitarDownloadEventosPorNrRecibo` for the newest closing the listing returned. **By receipt and not by identifier**, because the `rec` return document — the only place a `cpfs` has ever been seen — travels beside the event in that answer and in no other.
 *
 * If the listing returns several closings the competence was rectified or reopened; the **newest** is taken and `listed_receipts` reports every one that was on offer.
 *
 * ### What is stored, and how
 *
 * Each worker is one entry, with their **CPF encrypted** and a blind index beside it, in the same convention `esocial_event` uses. The row's remaining non-empty fields are that worker's own periodic-event receipt numbers and are kept beside them.
 *
 * **No response, log line or audit entry ever carries a plain CPF.** The detail endpoint shows the masked form and there is no field anywhere on this surface that could carry the eleven digits.
 *
 * **Both calls' raw request and raw response are sealed** in the object store, in the same AES-GCM envelope a staged event's XML uses, under keys recorded on the row.
 *
 * ### Running it again
 *
 * **Re-capturing a competence supersedes the previous list without deleting it**: the new list names the old in `supersedes_id`, the old one gets `superseded_at`, and its entries stay exactly as they were — what we believed when we last reconciled is a question somebody will ask.
 *
 * **The same eSocial receipt is never ingested twice.** A capture whose newest closing is one already held comes back `unchanged`, downloads nothing, writes nothing, and leaves the list already held current.
 *
 * ### When nothing is stored
 *
 * Three of the four endings store no workers and **none of them is a `500`**:
 *
 * - **`no_closing`** — the employer has not closed the month.
 * - **`unchanged`** — we already hold this closing.
 * - **`refused`** — eSocial refused one of the two calls, and **its own `cdResposta` and `descResposta` are recorded verbatim on the row and returned** (a `402` or a `406` is an answer, not a fault); or the `cpfs` that came back could not be read, in which case `failure_reason` **names the failing row's position and never its contents** and **no partial list is stored**. The sealed evidence is kept either way.
 *
 * ### When it refuses before calling
 *
 * - a company whose CNPJ has not been recorded — `422`, **before any network call**: eSocial identifies an employer by its CNPJ and by nothing else;
 * - a platform with no usable A1 certificate — `422`, naming the certificate screen;
 * - a `competence` that is not a `YYYY-MM` month — `422`;
 * - `503` when no eSocial client is configured for this deployment, which is the default.
 *
 * **Every capture leaves exactly one audit entry**, `esocial.worker_list_captured` against the `esocial_worker_list` entity, carrying the competence, the counts and eSocial's response code — and **not one CPF, not even masked**.
 */
export const captureWorkerListApiV1EsocialWorkerListsPost = <ThrowOnError extends boolean = false>(options: Options<CaptureWorkerListApiV1EsocialWorkerListsPostData, ThrowOnError>): RequestResult<CaptureWorkerListApiV1EsocialWorkerListsPostResponses, CaptureWorkerListApiV1EsocialWorkerListsPostErrors, ThrowOnError> => (options.client ?? client).post<CaptureWorkerListApiV1EsocialWorkerListsPostResponses, CaptureWorkerListApiV1EsocialWorkerListsPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/worker-lists',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One month's worker list, with every worker masked
 *
 * The capture and the workers it stored, in the order the government wrote them. vyttech staff only (`esocial:read`).
 *
 * **Every CPF is masked, and there is no unmasked form of this anywhere in the API.** The full registry numbers are encrypted at rest with a blind index beside them; no field here could carry the eleven digits, and no CPF travels in the path or the query string.
 *
 * `workers` is empty for every ending but `captured` — a month with no closing, a closing already held and a refusal all store no workers on purpose.
 *
 * A list of a company this request cannot see was filtered out by the tenancy layer, so it takes the same path as an invented identifier: `404`, indistinguishable, which is the rule the rest of this API keeps.
 */
export const readWorkerListApiV1EsocialWorkerListsListIdGet = <ThrowOnError extends boolean = false>(options: Options<ReadWorkerListApiV1EsocialWorkerListsListIdGetData, ThrowOnError>): RequestResult<ReadWorkerListApiV1EsocialWorkerListsListIdGetResponses, ReadWorkerListApiV1EsocialWorkerListsListIdGetErrors, ThrowOnError> => (options.client ?? client).get<ReadWorkerListApiV1EsocialWorkerListsListIdGetResponses, ReadWorkerListApiV1EsocialWorkerListsListIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/worker-lists/{list_id}',
    ...options
});

/**
 * The Relação de Trabalhadores reports
 *
 * Every report, newest request first, narrowed by company and by status. vyttech staff only (`esocial:read`). Superseded reports are listed too; `is_current` says which collected report stands for its company. No worker appears here — the entries are on the detail.
 */
export const listWorkerReportsApiV1EsocialWorkerReportsGet = <ThrowOnError extends boolean = false>(options?: Options<ListWorkerReportsApiV1EsocialWorkerReportsGetData, ThrowOnError>): RequestResult<ListWorkerReportsApiV1EsocialWorkerReportsGetResponses, ListWorkerReportsApiV1EsocialWorkerReportsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListWorkerReportsApiV1EsocialWorkerReportsGetResponses, ListWorkerReportsApiV1EsocialWorkerReportsGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/worker-reports',
    ...options
});

/**
 * Request one company's Relação de Trabalhadores from the eSocial portal
 *
 * Signs in to the eSocial web portal as *procurador* of one company and requests the *Relação de Trabalhadores - eSocial* report, through the **request half of the portal walk** (`login → profile → module → request → list`). vyttech staff only (`esocial:write`).
 *
 * The portal is asynchronous: it accepts the request, processes it later and keeps the file for thirty days. This records the request as a row in status `requested`, with the filters sent, the portal's own *Solicitado em* (`portal_requested_at`, which identifies it on the portal) and *Disponível até*, and the walk's id (`request_walk_id`) so its screenshots are reachable. Collect it later with `POST /esocial/worker-reports/{id}/collect`.
 *
 * ### Filters
 *
 * Round one: *todos os vínculos* (`active_only: false`, the default) or active only, admission on or after `admission_from`, termination on or after `termination_from`.
 *
 * ### The portal's daily limit, enforced
 *
 * **The portal allows 10 report requests per user, per employer, per day, and this endpoint refuses the next one with `422` before any browser is launched.** The day is the São Paulo calendar day of this platform's clock. What counts is every request-mode portal walk for the employer that reached its `request` stage — this endpoint's own, and runs of `POST /esocial/portal-walks` — whether or not the portal confirmed.
 *
 * ### When it refuses before launching
 *
 * `422` for a company without a CNPJ, a platform without a usable A1 certificate, and the eleventh request of the day for the employer. `404` for a company outside the caller's scope. `503` when no portal browser is configured (`I8LIFE_BROWSER_BACKEND`).
 *
 * ### When it is recorded as refused
 *
 * Everything after the launch is an answer rather than an error: a walk that failed, or a portal that did not confirm, is a `refused` row with `failure_reason`, answered `200`. So is a request the portal lists at the same minute as one another report already holds — the employer and the portal's timestamp are unique together.
 *
 * **Every request leaves one audit entry**, `esocial.worker_report_requested` against the `esocial_worker_report` entity: filters, status, the portal's message and timestamp. No CPF, no name, no salary.
 */
export const requestWorkerReportApiV1EsocialWorkerReportsPost = <ThrowOnError extends boolean = false>(options: Options<RequestWorkerReportApiV1EsocialWorkerReportsPostData, ThrowOnError>): RequestResult<RequestWorkerReportApiV1EsocialWorkerReportsPostResponses, RequestWorkerReportApiV1EsocialWorkerReportsPostErrors, ThrowOnError> => (options.client ?? client).post<RequestWorkerReportApiV1EsocialWorkerReportsPostResponses, RequestWorkerReportApiV1EsocialWorkerReportsPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/worker-reports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One Relação de Trabalhadores, with its entries paged and every CPF masked
 *
 * The report and one page of its entries in the file's order. vyttech staff only (`esocial:read`).
 *
 * **Every CPF is masked `***.NNN.NNN-**`, and there is no unmasked form of it anywhere in the API.** The full numbers are encrypted at rest and exist in plain only inside the sealed file.
 *
 * A report of a company this request cannot see is `404`, indistinguishable from one that does not exist.
 */
export const readWorkerReportApiV1EsocialWorkerReportsReportIdGet = <ThrowOnError extends boolean = false>(options: Options<ReadWorkerReportApiV1EsocialWorkerReportsReportIdGetData, ThrowOnError>): RequestResult<ReadWorkerReportApiV1EsocialWorkerReportsReportIdGetResponses, ReadWorkerReportApiV1EsocialWorkerReportsReportIdGetErrors, ThrowOnError> => (options.client ?? client).get<ReadWorkerReportApiV1EsocialWorkerReportsReportIdGetResponses, ReadWorkerReportApiV1EsocialWorkerReportsReportIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/worker-reports/{report_id}',
    ...options
});

/**
 * Collect a requested Relação de Trabalhadores
 *
 * Runs the **collect half of the portal walk** (`login → profile → module → list → download`), finds this report on the portal's list by its *Solicitado em*, and acts on the state the portal shows. vyttech staff only (`esocial:write`).
 *
 * - *Processado* — downloads the xlsx, **seals it** in the object store, reads it and stores **one entry per row with its position**: `collected`, with `entry_count`. A later collected report of the same company **supersedes** the previous current one (`supersedes_id` here, `superseded_at` there); nothing is deleted.
 * - *Pendente*, *Vazio*, *Excedido* — `pending`, `empty`, `exceeded`. No file, no entries, and not an error: collect a `pending` one again later.
 * - Past *Disponível até* with no file — `expired`; when that date is already known to have passed, no browser is launched.
 * - A failed walk, a state word this reader does not know, or a file it cannot read — `refused`, with `failure_reason`.
 *
 * ### Reading the file is all or nothing
 *
 * xlsx only. Columns are matched by their normalised header label; unknown extra columns are ignored. **A missing required column refuses the whole ingestion naming the column; a row whose CPF is not valid refuses it naming only the row's position.** No partial entry set is ever stored, and no message quotes a value. The file is sealed before it is read, so a refused one is still kept.
 *
 * ### Refusals
 *
 * `409` for a report already `collected`, naming that collection, and for one that never reached the portal's list. `404` for an unknown report or one of a company outside the caller's scope. `503` when no portal browser is configured.
 *
 * **Every collect leaves one audit entry**, `esocial.worker_report_collected`: the statuses, the portal's state, its row count and the entries stored. No CPF, no name, no salary. The first page of the entries is in the answer, every CPF masked.
 */
export const collectWorkerReportApiV1EsocialWorkerReportsReportIdCollectPost = <ThrowOnError extends boolean = false>(options: Options<CollectWorkerReportApiV1EsocialWorkerReportsReportIdCollectPostData, ThrowOnError>): RequestResult<CollectWorkerReportApiV1EsocialWorkerReportsReportIdCollectPostResponses, CollectWorkerReportApiV1EsocialWorkerReportsReportIdCollectPostErrors, ThrowOnError> => (options.client ?? client).post<CollectWorkerReportApiV1EsocialWorkerReportsReportIdCollectPostResponses, CollectWorkerReportApiV1EsocialWorkerReportsReportIdCollectPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/worker-reports/{report_id}/collect',
    ...options
});

/**
 * Read back a report's sealed xlsx
 *
 * The xlsx the portal served for this report, **byte for byte**, as an attachment. vyttech staff only (`esocial:read`), with the tenant scope of the probe and walk evidence readers. The file names every worker in plain.
 *
 * `404` for an unknown report, one of a company outside the caller's scope, and one for which nothing was downloaded; a sealed file that is gone or will not open is a `500`.
 *
 * **Every successful read leaves one audit entry**, `esocial.worker_report_file_read`. A refused or `404` read leaves none.
 */
export const readWorkerReportFileApiV1EsocialWorkerReportsReportIdFileGet = <ThrowOnError extends boolean = false>(options: Options<ReadWorkerReportFileApiV1EsocialWorkerReportsReportIdFileGetData, ThrowOnError>): RequestResult<ReadWorkerReportFileApiV1EsocialWorkerReportsReportIdFileGetResponses, ReadWorkerReportFileApiV1EsocialWorkerReportsReportIdFileGetErrors, ThrowOnError> => (options.client ?? client).get<ReadWorkerReportFileApiV1EsocialWorkerReportsReportIdFileGetResponses, ReadWorkerReportFileApiV1EsocialWorkerReportsReportIdFileGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/esocial/worker-reports/{report_id}/file',
    ...options
});

/**
 * List economic groups
 *
 * *Grupos econômicos*, each with how many companies are in it. vyttech staff only.
 *
 * Every parameter is optional, and a call with none of them returns every group, by name, unpaged. Each filter narrows what the others leave, `q` included. In every text filter the match is case-insensitive and anywhere in the column, `%` and `_` are matched as themselves, and blank is the same as absent.
 *
 * * `q` -- free text, matched anywhere in the name or the slug.
 * * `name` -- text the name contains.
 * * `slug` -- text the slug contains.
 * * `created_from` and `created_to` -- only groups created on those calendar days in São Paulo or between them, both inclusive. Either may be sent alone; `created_from` after `created_to` is a `422`.
 * * `sort` -- `name` (the default), `slug`, `member_count` or `created_at`, and `direction` -- `asc` (the default) or `desc`. Ties are broken by name and then by identifier, both ascending, so the order is the same on every page and paging never repeats or skips a group. Any other value of either is a `422`.
 * * `limit` (1 to 200) and `offset` -- one page of the result. With no `limit` the list is not paged and `offset` is ignored.
 *
 * `count` is how many groups match across every page, so with no `limit` it is the number of `items`.
 */
export const listGroupsApiV1GroupsGet = <ThrowOnError extends boolean = false>(options?: Options<ListGroupsApiV1GroupsGetData, ThrowOnError>): RequestResult<ListGroupsApiV1GroupsGetResponses, ListGroupsApiV1GroupsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListGroupsApiV1GroupsGetResponses, ListGroupsApiV1GroupsGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/groups',
    ...options
});

/**
 * Register an economic group
 *
 * Creates a *grupo econômico*, with no companies in it. vyttech staff only.
 *
 * The slug follows the company slug's rules and is unique across groups: one already taken is a `409`, in the same shape a duplicate company slug is. It is also stable -- a rename changes the name only.
 */
export const createGroupApiV1GroupsPost = <ThrowOnError extends boolean = false>(options: Options<CreateGroupApiV1GroupsPostData, ThrowOnError>): RequestResult<CreateGroupApiV1GroupsPostResponses, CreateGroupApiV1GroupsPostErrors, ThrowOnError> => (options.client ?? client).post<CreateGroupApiV1GroupsPostResponses, CreateGroupApiV1GroupsPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fetch an economic group and its companies
 *
 * One *grupo econômico* and the companies in it, by name -- each with its identifier, name, slug and CNPJ. vyttech staff only.
 */
export const getGroupApiV1GroupsGroupIdGet = <ThrowOnError extends boolean = false>(options: Options<GetGroupApiV1GroupsGroupIdGetData, ThrowOnError>): RequestResult<GetGroupApiV1GroupsGroupIdGetResponses, GetGroupApiV1GroupsGroupIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetGroupApiV1GroupsGroupIdGetResponses, GetGroupApiV1GroupsGroupIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/groups/{group_id}',
    ...options
});

/**
 * Rename an economic group
 *
 * Changes the group's name. The slug is stable and is not part of the body. Restating the current name succeeds and records nothing. vyttech staff only.
 */
export const renameGroupApiV1GroupsGroupIdPatch = <ThrowOnError extends boolean = false>(options: Options<RenameGroupApiV1GroupsGroupIdPatchData, ThrowOnError>): RequestResult<RenameGroupApiV1GroupsGroupIdPatchResponses, RenameGroupApiV1GroupsGroupIdPatchErrors, ThrowOnError> => (options.client ?? client).patch<RenameGroupApiV1GroupsGroupIdPatchResponses, RenameGroupApiV1GroupsGroupIdPatchErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/groups/{group_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Import a group's baseline population across its companies' contracts
 *
 * Loads the population already insured under the contracts of the companies in this economic group from one sheet, effective from `baseline_date` or from each row's own coverage start. vyttech staff only, with `contract:write`; a customer principal is refused with `403` whatever its role. The import spans several companies, so `X-Company-Id` must not be sent.
 *
 * The same import as `POST /companies/{company_id}/baseline-imports`, over a wider population: the candidate contracts are every contract of every company that belongs to the group **now**. A company outside the group is never read or written, even when one of its contracts has a Subestipulante the sheet names.
 *
 * The source is the sheet customers hand over: an `.xlsx` workbook (its first sheet) or a CSV in the legacy layout -- Subestipulante, Módulo, Nome, Data de nascimento, CPF, Salário, INCLUSAO, EXCLUSÃO, ALTERAÇÃO SALARIO -- with the same tolerance as the company import: a CPF that a number cell stripped of its leading zeros, a company name typed alone on a line between blocks of people (skipped), a blank Módulo, blank trailing columns. A pre-2007 `.xls` is refused with a request to save it as `.xlsx` or `.csv`.
 *
 * **Coverage may start per row.** An optional `Início da cobertura` column (also read as `coverage_start`, `Data de início da cobertura`, `Data início` and similar spellings) gives each person the date their coverage and salary start; a filled cell wins over `baseline_date`, and a blank cell or a file without the column uses `baseline_date`. A start before the person's birth date, or a cell that is not a date, is a problem with that row. `Data de vigência` is not this column, and is ignored like any extra column.
 *
 * **Each row goes to the contract its Subestipulante names**, in whichever company of the group holds it. A filled Módulo must be that contract's; a blank one asserts nothing. A Subestipulante that names no contract of the group, or several that Módulo does not tell apart -- including two companies of the group using the same codes -- is a problem with that row. A row marked in EXCLUSÃO is a problem; INCLUSAO and ALTERAÇÃO SALARIO marks are ignored.
 *
 * **Nothing is imported unless everything can be**, in any company. Every problem in the file is reported at once with `422`, one `details` entry per problem naming the row and column and quoting nothing from the file.
 *
 * If any contract the file touches has moved on -- an admission, a termination, a snapshot already sent, or coverage or a salary on a date the file does not carry -- the whole file is refused with `409`, with one `details` entry per such contract. Its `field` is `companies.{company_id}.contracts.{contract_id}` and its message names the company, the subestipulante and the módulo, since codes alone no longer identify a contract within a group. It proceeds only when `override` is set.
 *
 * Each contract that received rows gets its own baseline import record, holding the whole file, readable and downloadable through that contract's import history like any other, and audited under that contract's company with the group named. Re-running the same file writes nothing new and reports every row as `already_present`. An unknown group is `404`.
 */
export const importGroupBaselineApiV1GroupsGroupIdBaselineImportsPost = <ThrowOnError extends boolean = false>(options: Options<ImportGroupBaselineApiV1GroupsGroupIdBaselineImportsPostData, ThrowOnError>): RequestResult<ImportGroupBaselineApiV1GroupsGroupIdBaselineImportsPostResponses, ImportGroupBaselineApiV1GroupsGroupIdBaselineImportsPostErrors, ThrowOnError> => (options.client ?? client).post<ImportGroupBaselineApiV1GroupsGroupIdBaselineImportsPostResponses, ImportGroupBaselineApiV1GroupsGroupIdBaselineImportsPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/groups/{group_id}/baseline-imports',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Set or clear an economic group's insurer file-name label
 *
 * Sets what insurer file names of the group's companies carry in place of their registered names, or -- with `null` -- clears it. A company with a label of its own keeps using its own. vyttech staff only.
 *
 * Letters, digits, `_`, `-` and spaces only, at most 100 characters; anything else, or a blank value, is a `422` on `file_name_label` and nothing is stored. Restating the current label succeeds and records nothing; a real change is in the trail as `company_group.file_name_label_set`, with the label before and after. Files already generated keep their names.
 */
export const setGroupFileNameLabelApiV1GroupsGroupIdFileNameLabelPost = <ThrowOnError extends boolean = false>(options: Options<SetGroupFileNameLabelApiV1GroupsGroupIdFileNameLabelPostData, ThrowOnError>): RequestResult<SetGroupFileNameLabelApiV1GroupsGroupIdFileNameLabelPostResponses, SetGroupFileNameLabelApiV1GroupsGroupIdFileNameLabelPostErrors, ThrowOnError> => (options.client ?? client).post<SetGroupFileNameLabelApiV1GroupsGroupIdFileNameLabelPostResponses, SetGroupFileNameLabelApiV1GroupsGroupIdFileNameLabelPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/groups/{group_id}/file-name-label',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Find one person by CPF across an economic group's contracts
 *
 * The person with this CPF under every contract in scope that carries them, covered today or not, each entry saying whether it is `covered_today` (in America/Sao_Paulo) so a caller knows which are live without a second call. Read an entry's history through `GET /contracts/{contract_id}/insured-people/{insured_person_id}/history`.
 *
 * A `POST` so the CPF travels in the body and never in a URL, where a proxy or an access log would keep it. Punctuated and plain CPFs find the same person; one whose check digits fail is a `422`. A CPF that no contract in scope carries is `404`, with the same message whoever else might carry it. A read, and not audited.
 *
 * The companies read are those in the group **now**, the rule the group baseline import uses: a company moved out is not read, one moved in is. Each entry names its `company_id`, and somebody employed by two companies of the group is one item with entries under both.
 *
 * Callable by vyttech staff and by a user registered at the scope of this group. Anyone else -- a user of one company, a user of another group, a machine client -- gets the `404` an unknown group gets. `X-Company-Id` must not be sent: the read spans the group's companies.
 */
export const lookUpGroupInsuredPersonApiV1GroupsGroupIdInsuredPeopleLookupPost = <ThrowOnError extends boolean = false>(options: Options<LookUpGroupInsuredPersonApiV1GroupsGroupIdInsuredPeopleLookupPostData, ThrowOnError>): RequestResult<LookUpGroupInsuredPersonApiV1GroupsGroupIdInsuredPeopleLookupPostResponses, LookUpGroupInsuredPersonApiV1GroupsGroupIdInsuredPeopleLookupPostErrors, ThrowOnError> => (options.client ?? client).post<LookUpGroupInsuredPersonApiV1GroupsGroupIdInsuredPeopleLookupPostResponses, LookUpGroupInsuredPersonApiV1GroupsGroupIdInsuredPeopleLookupPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/groups/{group_id}/insured-people/lookup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Project an economic group's insured population on a date
 *
 * Everyone insured on `as_of` under any contract of any company of the group, with, for each contract, what `GET /contracts/{contract_id}/roster` says about them on that date.
 *
 * One item per person, merged by CPF: somebody under two contracts is one item with an entry for each, and somebody covered on `as_of` under one contract and not the other has only the covering contract's entry. Each entry carries what the per-contract projection carries for that person on that contract -- the coverage period, the salary in force on `as_of` and the insurer's values, which are current rather than dated.
 *
 * Entries are ordered by contract kind (`vida` before `saude`), then by when the contract was created, then by id; the item's `full_name` and `birth_date` are the first entry's, and two contracts that disagree are not reconciled here. Items are sorted by name without regard to case, then by CPF.
 *
 * A read, and not audited, as the per-contract projection is not.
 *
 * The companies read are those in the group **now**, the rule the group baseline import uses: a company moved out is not read, one moved in is. Each entry names its `company_id`, and somebody employed by two companies of the group is one item with entries under both.
 *
 * Callable by vyttech staff and by a user registered at the scope of this group. Anyone else -- a user of one company, a user of another group, a machine client -- gets the `404` an unknown group gets. `X-Company-Id` must not be sent: the read spans the group's companies.
 */
export const projectGroupRosterApiV1GroupsGroupIdRosterGet = <ThrowOnError extends boolean = false>(options: Options<ProjectGroupRosterApiV1GroupsGroupIdRosterGetData, ThrowOnError>): RequestResult<ProjectGroupRosterApiV1GroupsGroupIdRosterGetResponses, ProjectGroupRosterApiV1GroupsGroupIdRosterGetErrors, ThrowOnError> => (options.client ?? client).get<ProjectGroupRosterApiV1GroupsGroupIdRosterGetResponses, ProjectGroupRosterApiV1GroupsGroupIdRosterGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/groups/{group_id}/roster',
    ...options
});

/**
 * List an economic group's spreadsheet uploads
 *
 * Every sheet sent for the whole group, most recent first, with the counts for the whole file, per company and per contract. The rows are read one batch at a time.
 *
 * Callable by a user registered at the scope of this group with the permission the company upload needs, and by vyttech staff. Anyone else -- a user of one company, a user of another group, a machine client -- gets the `404` an unknown group gets. `X-Company-Id` must not be sent: the operation spans the group's companies.
 */
export const listGroupSpreadsheetUploadsApiV1GroupsGroupIdSpreadsheetUploadsGet = <ThrowOnError extends boolean = false>(options: Options<ListGroupSpreadsheetUploadsApiV1GroupsGroupIdSpreadsheetUploadsGetData, ThrowOnError>): RequestResult<ListGroupSpreadsheetUploadsApiV1GroupsGroupIdSpreadsheetUploadsGetResponses, ListGroupSpreadsheetUploadsApiV1GroupsGroupIdSpreadsheetUploadsGetErrors, ThrowOnError> => (options.client ?? client).get<ListGroupSpreadsheetUploadsApiV1GroupsGroupIdSpreadsheetUploadsGetResponses, ListGroupSpreadsheetUploadsApiV1GroupsGroupIdSpreadsheetUploadsGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/groups/{group_id}/spreadsheet-uploads',
    ...options
});

/**
 * Upload one sheet for every company of an economic group and preview it
 *
 * The company upload, for the one monthly sheet that lists people of every company of the group. **No delta is created here.** Confirming the returned batch is what creates them, each on its row's own contract.
 *
 * Each row is routed among every contract of every company that belongs to the group now, by the rule the company upload uses: `Subestipulante` must match when filled, `Módulo` narrows when filled. A row whose codes fit no contract of the group is rejected as `contract_mismatch`; one they fit more than one contract of -- including two companies of the group holding the same codes -- is rejected as `ambiguous_contract`, and never routed by guess. Such rows belong to no company: their `company` and `contract` are `null`.
 *
 * Unmarked rows are held to the roster of the contract they route to, as in the company upload, and the absences are everybody covered under any contract of any member company whose CPF is on no line of the file. A person listed under another company than the one they are insured in is not treated as a transfer: they are absent in the one, and `unmarked_not_on_roster` in the other.
 *
 * The batch is stored once for the group -- the file, its digest and the totals -- and as one company-level upload per member company with rows or absences, holding that company's part only; `upload.company_counts[].upload_id` names it. A user of that company reads their part through the company's upload routes, and cannot download the group's file there.
 *
 * Re-sending a file that has already been committed for this group answers `200` with the batch that holds those deltas and `is_duplicate` set.
 *
 * Callable by a user registered at the scope of this group with the permission the company upload needs, and by vyttech staff. Anyone else -- a user of one company, a user of another group, a machine client -- gets the `404` an unknown group gets. `X-Company-Id` must not be sent: the operation spans the group's companies.
 */
export const uploadGroupSpreadsheetApiV1GroupsGroupIdSpreadsheetUploadsPost = <ThrowOnError extends boolean = false>(options: Options<UploadGroupSpreadsheetApiV1GroupsGroupIdSpreadsheetUploadsPostData, ThrowOnError>): RequestResult<UploadGroupSpreadsheetApiV1GroupsGroupIdSpreadsheetUploadsPostResponses, UploadGroupSpreadsheetApiV1GroupsGroupIdSpreadsheetUploadsPostErrors, ThrowOnError> => (options.client ?? client).post<UploadGroupSpreadsheetApiV1GroupsGroupIdSpreadsheetUploadsPostResponses, UploadGroupSpreadsheetApiV1GroupsGroupIdSpreadsheetUploadsPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/groups/{group_id}/spreadsheet-uploads',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Fetch a group's upload, every line of it and who it left out
 *
 * The same document the upload answered with, re-read at any time: every line of the sheet with the company and contract it went to, and the absences. `outcome=rejected` narrows the rows to the ones that need correcting.
 *
 * Callable by a user registered at the scope of this group with the permission the company upload needs, and by vyttech staff. Anyone else -- a user of one company, a user of another group, a machine client -- gets the `404` an unknown group gets. `X-Company-Id` must not be sent: the operation spans the group's companies.
 */
export const getGroupSpreadsheetUploadApiV1GroupsGroupIdSpreadsheetUploadsUploadIdGet = <ThrowOnError extends boolean = false>(options: Options<GetGroupSpreadsheetUploadApiV1GroupsGroupIdSpreadsheetUploadsUploadIdGetData, ThrowOnError>): RequestResult<GetGroupSpreadsheetUploadApiV1GroupsGroupIdSpreadsheetUploadsUploadIdGetResponses, GetGroupSpreadsheetUploadApiV1GroupsGroupIdSpreadsheetUploadsUploadIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetGroupSpreadsheetUploadApiV1GroupsGroupIdSpreadsheetUploadsUploadIdGetResponses, GetGroupSpreadsheetUploadApiV1GroupsGroupIdSpreadsheetUploadsUploadIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/groups/{group_id}/spreadsheet-uploads/{upload_id}',
    ...options
});

/**
 * Read who on the group's rosters an upload's file left out
 *
 * People covered on the comparison date under any contract of any member company whose CPF is on no line of the file, by company, contract and name. Only a file with at least one row with no action marked lists everybody. Nothing is done about them; reading a non-empty list is recorded in the audit trail under each company.
 *
 * Callable by a user registered at the scope of this group with the permission the company upload needs, and by vyttech staff. Anyone else -- a user of one company, a user of another group, a machine client -- gets the `404` an unknown group gets. `X-Company-Id` must not be sent: the operation spans the group's companies.
 */
export const listGroupSpreadsheetUploadAbsencesApiV1GroupsGroupIdSpreadsheetUploadsUploadIdAbsencesGet = <ThrowOnError extends boolean = false>(options: Options<ListGroupSpreadsheetUploadAbsencesApiV1GroupsGroupIdSpreadsheetUploadsUploadIdAbsencesGetData, ThrowOnError>): RequestResult<ListGroupSpreadsheetUploadAbsencesApiV1GroupsGroupIdSpreadsheetUploadsUploadIdAbsencesGetResponses, ListGroupSpreadsheetUploadAbsencesApiV1GroupsGroupIdSpreadsheetUploadsUploadIdAbsencesGetErrors, ThrowOnError> => (options.client ?? client).get<ListGroupSpreadsheetUploadAbsencesApiV1GroupsGroupIdSpreadsheetUploadsUploadIdAbsencesGetResponses, ListGroupSpreadsheetUploadAbsencesApiV1GroupsGroupIdSpreadsheetUploadsUploadIdAbsencesGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/groups/{group_id}/spreadsheet-uploads/{upload_id}/absences',
    ...options
});

/**
 * Commit the ready rows of a group's upload, in every company
 *
 * Confirms the group batch once, and with it every company's part: one delta per `ready` row, each on the contract the row was routed to and under its own company, `submitted` and not approved, exactly as the company upload's confirmation does. The deltas go to each company's review queue like any other. A company's part cannot be confirmed on its own.
 *
 * Confirming twice is refused with `409`, as is confirming a batch whose file another batch of this group has already committed; both name the batch that holds the deltas in `details`. If the group's companies have changed since the sheet was read, confirming is refused with `409` and the sheet has to be uploaded again.
 *
 * Callable by a user registered at the scope of this group with the permission the company upload needs, and by vyttech staff. Anyone else -- a user of one company, a user of another group, a machine client -- gets the `404` an unknown group gets. `X-Company-Id` must not be sent: the operation spans the group's companies.
 */
export const confirmGroupSpreadsheetUploadApiV1GroupsGroupIdSpreadsheetUploadsUploadIdConfirmPost = <ThrowOnError extends boolean = false>(options: Options<ConfirmGroupSpreadsheetUploadApiV1GroupsGroupIdSpreadsheetUploadsUploadIdConfirmPostData, ThrowOnError>): RequestResult<ConfirmGroupSpreadsheetUploadApiV1GroupsGroupIdSpreadsheetUploadsUploadIdConfirmPostResponses, ConfirmGroupSpreadsheetUploadApiV1GroupsGroupIdSpreadsheetUploadsUploadIdConfirmPostErrors, ThrowOnError> => (options.client ?? client).post<ConfirmGroupSpreadsheetUploadApiV1GroupsGroupIdSpreadsheetUploadsUploadIdConfirmPostResponses, ConfirmGroupSpreadsheetUploadApiV1GroupsGroupIdSpreadsheetUploadsUploadIdConfirmPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/groups/{group_id}/spreadsheet-uploads/{upload_id}/confirm',
    ...options
});

/**
 * Read a group's upload rows on their own
 *
 * The lines of a group batch in file order, each with the company and contract it went to; `null` on both for a line that went to no company.
 *
 * Callable by a user registered at the scope of this group with the permission the company upload needs, and by vyttech staff. Anyone else -- a user of one company, a user of another group, a machine client -- gets the `404` an unknown group gets. `X-Company-Id` must not be sent: the operation spans the group's companies.
 */
export const listGroupSpreadsheetUploadRowsApiV1GroupsGroupIdSpreadsheetUploadsUploadIdRowsGet = <ThrowOnError extends boolean = false>(options: Options<ListGroupSpreadsheetUploadRowsApiV1GroupsGroupIdSpreadsheetUploadsUploadIdRowsGetData, ThrowOnError>): RequestResult<ListGroupSpreadsheetUploadRowsApiV1GroupsGroupIdSpreadsheetUploadsUploadIdRowsGetResponses, ListGroupSpreadsheetUploadRowsApiV1GroupsGroupIdSpreadsheetUploadsUploadIdRowsGetErrors, ThrowOnError> => (options.client ?? client).get<ListGroupSpreadsheetUploadRowsApiV1GroupsGroupIdSpreadsheetUploadsUploadIdRowsGetResponses, ListGroupSpreadsheetUploadRowsApiV1GroupsGroupIdSpreadsheetUploadsUploadIdRowsGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/groups/{group_id}/spreadsheet-uploads/{upload_id}/rows',
    ...options
});

/**
 * Download the file a group's upload came from
 *
 * The uploaded bytes, unchanged, decrypted only to serve this response. Kept once, here: no company's part of the batch carries a copy, since the file lists every company's people.
 *
 * Callable by a user registered at the scope of this group with the permission the company upload needs, and by vyttech staff. Anyone else -- a user of one company, a user of another group, a machine client -- gets the `404` an unknown group gets. `X-Company-Id` must not be sent: the operation spans the group's companies.
 */
export const downloadGroupSpreadsheetUploadSourceApiV1GroupsGroupIdSpreadsheetUploadsUploadIdSourceGet = <ThrowOnError extends boolean = false>(options: Options<DownloadGroupSpreadsheetUploadSourceApiV1GroupsGroupIdSpreadsheetUploadsUploadIdSourceGetData, ThrowOnError>): RequestResult<DownloadGroupSpreadsheetUploadSourceApiV1GroupsGroupIdSpreadsheetUploadsUploadIdSourceGetResponses, DownloadGroupSpreadsheetUploadSourceApiV1GroupsGroupIdSpreadsheetUploadsUploadIdSourceGetErrors, ThrowOnError> => (options.client ?? client).get<DownloadGroupSpreadsheetUploadSourceApiV1GroupsGroupIdSpreadsheetUploadsUploadIdSourceGetResponses, DownloadGroupSpreadsheetUploadSourceApiV1GroupsGroupIdSpreadsheetUploadsUploadIdSourceGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/groups/{group_id}/spreadsheet-uploads/{upload_id}/source',
    ...options
});

/**
 * Service health
 *
 * Reports the running build and whether its database is reachable. Returns 503 when any checked dependency is unhealthy, so it can be used directly as a readiness probe.
 */
export const healthApiV1HealthGet = <ThrowOnError extends boolean = false>(options?: Options<HealthApiV1HealthGetData, ThrowOnError>): RequestResult<HealthApiV1HealthGetResponses, HealthApiV1HealthGetErrors, ThrowOnError> => (options?.client ?? client).get<HealthApiV1HealthGetResponses, HealthApiV1HealthGetErrors, ThrowOnError>({ url: '/api/v1/health', ...options });

/**
 * List insurers
 *
 * Every insurer, retired ones included -- past contracts still point at them.
 */
export const listInsurersApiV1InsurersGet = <ThrowOnError extends boolean = false>(options?: Options<ListInsurersApiV1InsurersGetData, ThrowOnError>): RequestResult<ListInsurersApiV1InsurersGetResponses, ListInsurersApiV1InsurersGetErrors, ThrowOnError> => (options?.client ?? client).get<ListInsurersApiV1InsurersGetResponses, ListInsurersApiV1InsurersGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/insurers',
    ...options
});

/**
 * Register an insurer
 *
 * vyttech staff only. The code is stored upper-cased and is unique, so `bradesco` and `BRADESCO` are the same insurer rather than two rows that both claim to be it.
 *
 * `layout_code` names the file layout their snapshots are rendered through. Omit it for the default layout; see `GET /snapshot-layouts` for the registered codes.
 */
export const createInsurerApiV1InsurersPost = <ThrowOnError extends boolean = false>(options: Options<CreateInsurerApiV1InsurersPostData, ThrowOnError>): RequestResult<CreateInsurerApiV1InsurersPostResponses, CreateInsurerApiV1InsurersPostErrors, ThrowOnError> => (options.client ?? client).post<CreateInsurerApiV1InsurersPostResponses, CreateInsurerApiV1InsurersPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/insurers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fetch an insurer
 *
 * One insurer, by its own identifier. Insurers belong to no customer company, so every principal that can read a contract can read the insurer behind it.
 */
export const getInsurerApiV1InsurersInsurerIdGet = <ThrowOnError extends boolean = false>(options: Options<GetInsurerApiV1InsurersInsurerIdGetData, ThrowOnError>): RequestResult<GetInsurerApiV1InsurersInsurerIdGetResponses, GetInsurerApiV1InsurersInsurerIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetInsurerApiV1InsurersInsurerIdGetResponses, GetInsurerApiV1InsurersInsurerIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/insurers/{insurer_id}',
    ...options
});

/**
 * Change the file layout an insurer's snapshots are rendered through
 *
 * vyttech staff only. `layout_code` must be one of the codes `GET /snapshot-layouts` lists, or `null` for the default layout; any other code is refused with 422.
 *
 * Affects snapshots generated from now on. A snapshot already generated keeps the layout it was rendered through, and its file downloads exactly as before. The change is recorded in the audit trail with the old and the new code.
 */
export const setInsurerLayoutApiV1InsurersInsurerIdLayoutPut = <ThrowOnError extends boolean = false>(options: Options<SetInsurerLayoutApiV1InsurersInsurerIdLayoutPutData, ThrowOnError>): RequestResult<SetInsurerLayoutApiV1InsurersInsurerIdLayoutPutResponses, SetInsurerLayoutApiV1InsurersInsurerIdLayoutPutErrors, ThrowOnError> => (options.client ?? client).put<SetInsurerLayoutApiV1InsurersInsurerIdLayoutPutResponses, SetInsurerLayoutApiV1InsurersInsurerIdLayoutPutErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/insurers/{insurer_id}/layout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List machine client credentials
 *
 * Credentials within the request's company scope. Secrets are never included. vyttech staff see every company's, or one company's with `X-Company-Id`.
 */
export const listMachineClientsApiV1MachineClientsGet = <ThrowOnError extends boolean = false>(options?: Options<ListMachineClientsApiV1MachineClientsGetData, ThrowOnError>): RequestResult<ListMachineClientsApiV1MachineClientsGetResponses, ListMachineClientsApiV1MachineClientsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListMachineClientsApiV1MachineClientsGetResponses, ListMachineClientsApiV1MachineClientsGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/machine-clients',
    ...options
});

/**
 * Issue a machine client credential
 *
 * Issues a client id and client secret for one customer company, named by `X-Company-Id`. vyttech staff only.
 *
 * **The client secret is in this response and nowhere else.** It is stored only as an Argon2id hash, so it cannot be shown again; a client that loses it needs a new credential.
 */
export const issueMachineClientApiV1MachineClientsPost = <ThrowOnError extends boolean = false>(options: Options<IssueMachineClientApiV1MachineClientsPostData, ThrowOnError>): RequestResult<IssueMachineClientApiV1MachineClientsPostResponses, IssueMachineClientApiV1MachineClientsPostErrors, ThrowOnError> => (options.client ?? client).post<IssueMachineClientApiV1MachineClientsPostResponses, IssueMachineClientApiV1MachineClientsPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/machine-clients',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fetch a machine client credential
 *
 * One credential, by its own identifier. Never includes the secret.
 *
 * A credential belonging to another company is `404`: the company filter is part of the query, so holding the identifier does not reach the row.
 */
export const getMachineClientApiV1MachineClientsMachineClientIdGet = <ThrowOnError extends boolean = false>(options: Options<GetMachineClientApiV1MachineClientsMachineClientIdGetData, ThrowOnError>): RequestResult<GetMachineClientApiV1MachineClientsMachineClientIdGetResponses, GetMachineClientApiV1MachineClientsMachineClientIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetMachineClientApiV1MachineClientsMachineClientIdGetResponses, GetMachineClientApiV1MachineClientsMachineClientIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/machine-clients/{machine_client_id}',
    ...options
});

/**
 * Revoke a machine client credential
 *
 * Refuses the credential from this moment on. Any token already issued to it stops working on its next request, because the client is re-read on every request rather than trusted from the token.
 *
 * vyttech staff only. Revoking an already-revoked credential is a no-op with the same response, so a retry is safe.
 */
export const revokeMachineClientApiV1MachineClientsMachineClientIdRevocationPost = <ThrowOnError extends boolean = false>(options: Options<RevokeMachineClientApiV1MachineClientsMachineClientIdRevocationPostData, ThrowOnError>): RequestResult<RevokeMachineClientApiV1MachineClientsMachineClientIdRevocationPostResponses, RevokeMachineClientApiV1MachineClientsMachineClientIdRevocationPostErrors, ThrowOnError> => (options.client ?? client).post<RevokeMachineClientApiV1MachineClientsMachineClientIdRevocationPostResponses, RevokeMachineClientApiV1MachineClientsMachineClientIdRevocationPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/machine-clients/{machine_client_id}/revocation',
    ...options
});

/**
 * Rotate a machine client credential's secret
 *
 * Replaces the secret and keeps the client id, the role and the company. vyttech staff only.
 *
 * **The new secret is in this response and nowhere else**, exactly as at issue. The previous secret stops being accepted by `POST /api/v1/auth/machine/token` the moment this returns.
 *
 * A token the credential already holds keeps working until it expires, because a token is verified against the credential's identity rather than against its secret. That is the window a partner rotates in: take the new secret, deploy it, and the integration never stops -- its next token exchange simply uses the new value.
 *
 * Rotating a revoked credential is refused. Revocation is final; what a revoked integration needs is a new credential.
 */
export const rotateMachineClientApiV1MachineClientsMachineClientIdRotationPost = <ThrowOnError extends boolean = false>(options: Options<RotateMachineClientApiV1MachineClientsMachineClientIdRotationPostData, ThrowOnError>): RequestResult<RotateMachineClientApiV1MachineClientsMachineClientIdRotationPostResponses, RotateMachineClientApiV1MachineClientsMachineClientIdRotationPostErrors, ThrowOnError> => (options.client ?? client).post<RotateMachineClientApiV1MachineClientsMachineClientIdRotationPostResponses, RotateMachineClientApiV1MachineClientsMachineClientIdRotationPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/machine-clients/{machine_client_id}/rotation',
    ...options
});

/**
 * Every message the bridge has read
 *
 * Newest first. Every message gets a line whether or not anything could be made of it -- that is the point of a path built to be watched and then taken down, and 'I sent it on Tuesday' is answered from here.
 *
 * `outstanding=true` is the queue: the `unrouted` and the `refused`, which are the messages somebody still has to do something about. `outstanding_count` is that number for the whole mailbox regardless of the filters, so a screen can show it without a second request.
 *
 * **vyttech staff only.** The mailbox holds several companies' paperwork at once, and a message from an address nobody has registered belongs to no company, so this surface is gated on `mailbox:read`/`mailbox:write` rather than on the tenant permissions.
 */
export const listMessagesApiV1MailboxMessagesGet = <ThrowOnError extends boolean = false>(options?: Options<ListMessagesApiV1MailboxMessagesGetData, ThrowOnError>): RequestResult<ListMessagesApiV1MailboxMessagesGetResponses, ListMessagesApiV1MailboxMessagesGetErrors, ThrowOnError> => (options?.client ?? client).get<ListMessagesApiV1MailboxMessagesGetResponses, ListMessagesApiV1MailboxMessagesGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/mailbox/messages',
    ...options
});

/**
 * One message and what became of each attachment
 *
 * The attachments of the latest attempt by default; `attempt=1` reads what we made of the message before somebody registered its sender, which is kept rather than overwritten.
 *
 * A `spreadsheet` attachment carries the id of the **preview** it became. No delta exists until that batch is confirmed through `POST /contracts/{contract_id}/spreadsheet-uploads/{upload_id}/confirm`, which is the same endpoint the portal uses and the same decision a person makes there.
 *
 * **vyttech staff only.** The mailbox holds several companies' paperwork at once, and a message from an address nobody has registered belongs to no company, so this surface is gated on `mailbox:read`/`mailbox:write` rather than on the tenant permissions.
 */
export const getMessageApiV1MailboxMessagesMessageIdGet = <ThrowOnError extends boolean = false>(options: Options<GetMessageApiV1MailboxMessagesMessageIdGetData, ThrowOnError>): RequestResult<GetMessageApiV1MailboxMessagesMessageIdGetResponses, GetMessageApiV1MailboxMessagesMessageIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetMessageApiV1MailboxMessagesMessageIdGetResponses, GetMessageApiV1MailboxMessagesMessageIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/mailbox/messages/{message_id}',
    ...options
});

/**
 * Take a message off the queue without acting on it
 *
 * For the mail that is not ours: a supplier's invoice, a newsletter, a reply to a reply. The message is kept, and who decided and why are recorded on it and in the audit trail.
 *
 * A message that has already been ingested cannot be discarded: what it produced has a lifecycle of its own, and discarding the email would say nothing about it.
 *
 * **vyttech staff only.** The mailbox holds several companies' paperwork at once, and a message from an address nobody has registered belongs to no company, so this surface is gated on `mailbox:read`/`mailbox:write` rather than on the tenant permissions.
 */
export const discardMessageApiV1MailboxMessagesMessageIdDiscardPost = <ThrowOnError extends boolean = false>(options: Options<DiscardMessageApiV1MailboxMessagesMessageIdDiscardPostData, ThrowOnError>): RequestResult<DiscardMessageApiV1MailboxMessagesMessageIdDiscardPostResponses, DiscardMessageApiV1MailboxMessagesMessageIdDiscardPostErrors, ThrowOnError> => (options.client ?? client).post<DiscardMessageApiV1MailboxMessagesMessageIdDiscardPostResponses, DiscardMessageApiV1MailboxMessagesMessageIdDiscardPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/mailbox/messages/{message_id}/discard',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run ingestion over a message again
 *
 * The other half of registering an address that was missing: the message that was left over goes back through the same path, from the bytes as they arrived.
 *
 * Only a message that produced **nothing** can be retried -- `unrouted` or `refused`. One that is already `ingested` produced a preview, and running it again would ask for the same movements twice; that is refused with `409` naming the message.
 *
 * The previous attempt's lines are kept. A fresh set is written under the next `attempt`, so what we made of the message before the fix stays readable at `GET /mailbox/messages/{id}?attempt=1`.
 *
 * A message that still cannot be read comes back `refused` with the attempt recorded, rather than failing: this path applies the same size ceiling and the same parser a message meets on arrival.
 *
 * **vyttech staff only.** The mailbox holds several companies' paperwork at once, and a message from an address nobody has registered belongs to no company, so this surface is gated on `mailbox:read`/`mailbox:write` rather than on the tenant permissions.
 */
export const retryMessageApiV1MailboxMessagesMessageIdRetryPost = <ThrowOnError extends boolean = false>(options: Options<RetryMessageApiV1MailboxMessagesMessageIdRetryPostData, ThrowOnError>): RequestResult<RetryMessageApiV1MailboxMessagesMessageIdRetryPostResponses, RetryMessageApiV1MailboxMessagesMessageIdRetryPostErrors, ThrowOnError> => (options.client ?? client).post<RetryMessageApiV1MailboxMessagesMessageIdRetryPostResponses, RetryMessageApiV1MailboxMessagesMessageIdRetryPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/mailbox/messages/{message_id}/retry',
    ...options
});

/**
 * Download the message as it arrived
 *
 * The raw RFC 5322 bytes, headers included, unchanged. This is the provenance of everything the message produced, so it is what arrived rather than a reconstruction of it.
 *
 * It is stored sealed in the same envelope a supporting document's bytes are, outside PostgreSQL, and its digest is checked before this responds -- so a copy that was swapped behind the application's back is an error rather than somebody else's mail.
 *
 * **vyttech staff only.** The mailbox holds several companies' paperwork at once, and a message from an address nobody has registered belongs to no company, so this surface is gated on `mailbox:read`/`mailbox:write` rather than on the tenant permissions.
 */
export const downloadMessageSourceApiV1MailboxMessagesMessageIdSourceGet = <ThrowOnError extends boolean = false>(options: Options<DownloadMessageSourceApiV1MailboxMessagesMessageIdSourceGetData, ThrowOnError>): RequestResult<DownloadMessageSourceApiV1MailboxMessagesMessageIdSourceGetResponses, DownloadMessageSourceApiV1MailboxMessagesMessageIdSourceGetErrors, ThrowOnError> => (options.client ?? client).get<DownloadMessageSourceApiV1MailboxMessagesMessageIdSourceGetResponses, DownloadMessageSourceApiV1MailboxMessagesMessageIdSourceGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/mailbox/messages/{message_id}/source',
    ...options
});

/**
 * Read the mailbox now
 *
 * Fetches the messages not yet marked read, ingests each one and marks every one examined -- including the ones nothing could be made of, which are in the log for somebody to act on rather than left to be re-read on every poll.
 *
 * A spreadsheet becomes a **preview** and a document is stored with `channel: email`. **No delta is created here**, by any message, ever.
 *
 * A message we have already read is recognised by the digest of its bytes and counted as a duplicate; nothing is done twice. One malformed message costs one message and the rest of the batch still lands.
 *
 * `503` when no mailbox is configured for this deployment, which is the default -- the bridge is something a deployment turns on.
 *
 * **vyttech staff only.** The mailbox holds several companies' paperwork at once, and a message from an address nobody has registered belongs to no company, so this surface is gated on `mailbox:read`/`mailbox:write` rather than on the tenant permissions.
 */
export const pollMailboxApiV1MailboxPollsPost = <ThrowOnError extends boolean = false>(options?: Options<PollMailboxApiV1MailboxPollsPostData, ThrowOnError>): RequestResult<PollMailboxApiV1MailboxPollsPostResponses, PollMailboxApiV1MailboxPollsPostErrors, ThrowOnError> => (options?.client ?? client).post<PollMailboxApiV1MailboxPollsPostResponses, PollMailboxApiV1MailboxPollsPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/mailbox/polls',
    ...options
});

/**
 * List the addresses registered against contracts
 *
 * Live registrations first, newest first within that. `include_revoked=true` adds the withdrawn ones: nothing is deleted here, because that we trusted an address between two dates is part of the record.
 *
 * **vyttech staff only.** The mailbox holds several companies' paperwork at once, and a message from an address nobody has registered belongs to no company, so this surface is gated on `mailbox:read`/`mailbox:write` rather than on the tenant permissions.
 */
export const listSendersApiV1MailboxSendersGet = <ThrowOnError extends boolean = false>(options?: Options<ListSendersApiV1MailboxSendersGetData, ThrowOnError>): RequestResult<ListSendersApiV1MailboxSendersGetResponses, ListSendersApiV1MailboxSendersGetErrors, ThrowOnError> => (options?.client ?? client).get<ListSendersApiV1MailboxSendersGetResponses, ListSendersApiV1MailboxSendersGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/mailbox/senders',
    ...options
});

/**
 * Trust an address to file movements for a contract
 *
 * The whole of the bridge's security model, and it is short on purpose. An address that is not registered is not trusted: a message from one is kept and logged as `unrouted`, and it is **never** matched to a company by the codes written inside its spreadsheet, which are a thing the sender typed.
 *
 * One live registration per address, across every company -- `409` names the registration that already holds it, including one belonging to another company, because 'whose movements are these?' has to have one answer for the whole mailbox.
 *
 * `default_document_kind` is what this sender's attached paperwork is recorded as. It is configuration rather than inference: nothing in this product reads a document, and that includes reading its filename.
 *
 * **vyttech administrators only** (`contract:write`). Deciding that an address may file movements against a contract is the same kind of statement as the insurer's own codes on that contract, and it is recorded the same way.
 */
export const registerSenderApiV1MailboxSendersPost = <ThrowOnError extends boolean = false>(options: Options<RegisterSenderApiV1MailboxSendersPostData, ThrowOnError>): RequestResult<RegisterSenderApiV1MailboxSendersPostResponses, RegisterSenderApiV1MailboxSendersPostErrors, ThrowOnError> => (options.client ?? client).post<RegisterSenderApiV1MailboxSendersPostResponses, RegisterSenderApiV1MailboxSendersPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/mailbox/senders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Withdraw trust from a registered address
 *
 * The address stops routing immediately; the next message from it is `unrouted`. The registration itself is kept and stays readable with `include_revoked=true`, stamped with who withdrew it and why -- messages already ingested under it still name it.
 *
 * **vyttech administrators only** (`contract:write`), like registering one.
 */
export const revokeSenderApiV1MailboxSendersSenderIdRevocationPost = <ThrowOnError extends boolean = false>(options: Options<RevokeSenderApiV1MailboxSendersSenderIdRevocationPostData, ThrowOnError>): RequestResult<RevokeSenderApiV1MailboxSendersSenderIdRevocationPostResponses, RevokeSenderApiV1MailboxSendersSenderIdRevocationPostErrors, ThrowOnError> => (options.client ?? client).post<RevokeSenderApiV1MailboxSendersSenderIdRevocationPostResponses, RevokeSenderApiV1MailboxSendersSenderIdRevocationPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/mailbox/senders/{sender_id}/revocation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * What this company has been told
 *
 * Notifications within the request's company scope, most recent first, with the number still unread beside them.
 *
 * Every one of them is something vyttech did to a request the company filed, or to the cutoff their requests are on. Acknowledgements of what the company did itself are deliberately not in here: the screen they did it on already said so, and a four-hundred-row spreadsheet would produce four hundred of them.
 *
 * `unread_count` counts everything unread, not just this page, so it is the number to put on a badge.
 */
export const listNotificationsApiV1NotificationsGet = <ThrowOnError extends boolean = false>(options?: Options<ListNotificationsApiV1NotificationsGetData, ThrowOnError>): RequestResult<ListNotificationsApiV1NotificationsGetResponses, ListNotificationsApiV1NotificationsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListNotificationsApiV1NotificationsGetResponses, ListNotificationsApiV1NotificationsGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/notifications',
    ...options
});

/**
 * Mark everything read
 *
 * Marks everything currently unread in the request's company scope, and answers how many that was. Bounded, so a company with a very large backlog clears it in more than one call rather than holding a transaction open across a page load; `unread_count` in the response says whether anything is left.
 */
export const markAllNotificationsReadApiV1NotificationsReadPost = <ThrowOnError extends boolean = false>(options?: Options<MarkAllNotificationsReadApiV1NotificationsReadPostData, ThrowOnError>): RequestResult<MarkAllNotificationsReadApiV1NotificationsReadPostResponses, MarkAllNotificationsReadApiV1NotificationsReadPostErrors, ThrowOnError> => (options?.client ?? client).post<MarkAllNotificationsReadApiV1NotificationsReadPostResponses, MarkAllNotificationsReadApiV1NotificationsReadPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/notifications/read',
    ...options
});

/**
 * Mark one notification read
 *
 * Idempotent: a notification that was already read keeps the first reading, because who saw it first is the fact worth having and the second person to open the inbox would overwrite it.
 *
 * The mark is per company rather than per person. A customer's team share an inbox the way they share the mailbox this replaces, and two of them chasing the same termination is what is being removed.
 */
export const markNotificationReadApiV1NotificationsNotificationIdReadPost = <ThrowOnError extends boolean = false>(options: Options<MarkNotificationReadApiV1NotificationsNotificationIdReadPostData, ThrowOnError>): RequestResult<MarkNotificationReadApiV1NotificationsNotificationIdReadPostResponses, MarkNotificationReadApiV1NotificationsNotificationIdReadPostErrors, ThrowOnError> => (options.client ?? client).post<MarkNotificationReadApiV1NotificationsNotificationIdReadPostResponses, MarkNotificationReadApiV1NotificationsNotificationIdReadPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/notifications/{notification_id}/read',
    ...options
});

/**
 * Off-cycle notices in scope
 *
 * Every notice the request's scope can see, most recently raised first, refused ones included -- for the same reason the monthly history keeps them: "we tried to tell them about Ana and the portal would not take it" is the thing this record exists to leave behind, and a listing that showed only what worked would leave only the version that suits us.
 *
 * vyttech staff read every company by default. Send `X-Company-Id` to work inside one.
 *
 * **Staff only.** This operation requires `submission:read`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const listNoticesApiV1OffCycleNoticesGet = <ThrowOnError extends boolean = false>(options?: Options<ListNoticesApiV1OffCycleNoticesGetData, ThrowOnError>): RequestResult<ListNoticesApiV1OffCycleNoticesGetResponses, ListNoticesApiV1OffCycleNoticesGetErrors, ThrowOnError> => (options?.client ?? client).get<ListNoticesApiV1OffCycleNoticesGetResponses, ListNoticesApiV1OffCycleNoticesGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/off-cycle-notices',
    ...options
});

/**
 * Compose an off-cycle notice
 *
 * Renders the movements named into a file in the insurer's own layout and records that it left the building. The insurer has not been told when this returns -- somebody takes the file to their portal or attaches it to an email and comes back to mark it sent, and a notice that sat unmarked for three days is the failure this whole route exists to prevent.
 *
 * Every movement is re-checked here rather than trusted from whatever listing was read: approved, on this contract, not already covered by a file the insurer holds, and not already named by a notice standing. All of them have to share one action.
 *
 * Each person is rendered **at their own movement's effective date**, so an admission on the 25th describes them as they are from the 25th. Somebody the layout will not write is a `422` rather than a row quietly left out: the monthly file reports an exception and carries on because a cycle of ten thousand cannot stop for one person, and a notice raised *because* of one person cannot do the same.
 *
 * **This does not take the movement off the next monthly file**, and nothing here moves the submission watermark.
 *
 * **Whether this route is open at all is the contract's `off_cycle_rule`**, which is a term of the insurer's policy and defaults to `not_permitted`. On a contract whose insurer processes only the monthly file, every notice is a `409` -- that is the contract being quoted back, not a fault. Recording the permission on the contract is how one that really does accept notices opts in.
 *
 * **Staff only.** This operation requires `submission:write`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const raiseNoticeApiV1OffCycleNoticesContractsContractIdPost = <ThrowOnError extends boolean = false>(options: Options<RaiseNoticeApiV1OffCycleNoticesContractsContractIdPostData, ThrowOnError>): RequestResult<RaiseNoticeApiV1OffCycleNoticesContractsContractIdPostResponses, RaiseNoticeApiV1OffCycleNoticesContractsContractIdPostErrors, ThrowOnError> => (options.client ?? client).post<RaiseNoticeApiV1OffCycleNoticesContractsContractIdPostResponses, RaiseNoticeApiV1OffCycleNoticesContractsContractIdPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/off-cycle-notices/contracts/{contract_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Approved movements the insurer has not been told about
 *
 * Every approved movement on this contract that no file the insurer holds covers, with the cycle whose file *will* carry it, that cycle's cutoff and how many days away it is.
 *
 * This is the question the off-cycle route exists to answer: **is anybody going to be uninsured while they wait for the next file?** An admission on the 25th under a cutoff on the 20th lands next month, and this listing is where that shows up as a number rather than as something an analyst works out from a calendar.
 *
 * Three things put a movement here, and each is a question already answered elsewhere: it is `approved`, so it is a roster fact rather than a request; its effective date is after the last day the insurer has a file for; and no notice standing already names it. A notice that was refused does not count -- its movements come back into this listing.
 *
 * `is_notifiable` says whether the contract's rule lets each one go early. Movements it does not are reported rather than hidden, so the listing stays honest on a monthly-only contract: these people are waiting, and the contract says waiting is what happens.
 *
 * **Staff only.** This operation requires `submission:read`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const readEligibleApiV1OffCycleNoticesContractsContractIdEligibleGet = <ThrowOnError extends boolean = false>(options: Options<ReadEligibleApiV1OffCycleNoticesContractsContractIdEligibleGetData, ThrowOnError>): RequestResult<ReadEligibleApiV1OffCycleNoticesContractsContractIdEligibleGetResponses, ReadEligibleApiV1OffCycleNoticesContractsContractIdEligibleGetErrors, ThrowOnError> => (options.client ?? client).get<ReadEligibleApiV1OffCycleNoticesContractsContractIdEligibleGetResponses, ReadEligibleApiV1OffCycleNoticesContractsContractIdEligibleGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/off-cycle-notices/contracts/{contract_id}/eligible',
    ...options
});

/**
 * One off-cycle notice
 *
 * Everything recorded about one notice: why it could not wait, the movements it named, the rows the insurer was sent about them, who sent it and what came back.
 *
 * The rows are the rendered cells rather than the projected values, because the row is the record of what was *written* -- and each person is rendered at their own movement's effective date rather than at the day the notice was raised, which is what makes each row true.
 *
 * **The file itself is at `GET /off-cycle-notices/{notice_id}/file`.**
 *
 * **Staff only.** This operation requires `submission:read`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const readNoticeApiV1OffCycleNoticesNoticeIdGet = <ThrowOnError extends boolean = false>(options: Options<ReadNoticeApiV1OffCycleNoticesNoticeIdGetData, ThrowOnError>): RequestResult<ReadNoticeApiV1OffCycleNoticesNoticeIdGetResponses, ReadNoticeApiV1OffCycleNoticesNoticeIdGetErrors, ThrowOnError> => (options.client ?? client).get<ReadNoticeApiV1OffCycleNoticesNoticeIdGetResponses, ReadNoticeApiV1OffCycleNoticesNoticeIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/off-cycle-notices/{notice_id}',
    ...options
});

/**
 * Record a notice the insurer would not take
 *
 * Marks the notice as refused, with a mandatory reason, and frees the movements it held -- they come back into the eligible listing and can go on a fresh notice.
 *
 * The reason matters more here than on a month. "A operadora respondeu que inclusões só entram pelo arquivo mensal" is not only what the next person needs to know: it is the evidence that this contract's `off_cycle_rule` was wrong, and the thing that gets it corrected.
 *
 * **Staff only.** This operation requires `submission:write`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const markNoticeFailedApiV1OffCycleNoticesNoticeIdFailedPost = <ThrowOnError extends boolean = false>(options: Options<MarkNoticeFailedApiV1OffCycleNoticesNoticeIdFailedPostData, ThrowOnError>): RequestResult<MarkNoticeFailedApiV1OffCycleNoticesNoticeIdFailedPostResponses, MarkNoticeFailedApiV1OffCycleNoticesNoticeIdFailedPostErrors, ThrowOnError> => (options.client ?? client).post<MarkNoticeFailedApiV1OffCycleNoticesNoticeIdFailedPostResponses, MarkNoticeFailedApiV1OffCycleNoticesNoticeIdFailedPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/off-cycle-notices/{notice_id}/failed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The composed notice, as bytes
 *
 * The file exactly as it was composed, in the insurer's own layout, served as an attachment. Composed once when the notice was raised and never rewritten, so this is what went out rather than a re-rendering of what the roster says now.
 *
 * Its name is deliberately not the monthly file's: the two must not be confused in an operations mailbox, because one is the month's whole population and the other is two people who could not wait for it.
 *
 * **Staff only.** This operation requires `submission:read`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const downloadNoticeFileApiV1OffCycleNoticesNoticeIdFileGet = <ThrowOnError extends boolean = false>(options: Options<DownloadNoticeFileApiV1OffCycleNoticesNoticeIdFileGetData, ThrowOnError>): RequestResult<DownloadNoticeFileApiV1OffCycleNoticesNoticeIdFileGetResponses, DownloadNoticeFileApiV1OffCycleNoticesNoticeIdFileGetErrors, ThrowOnError> => (options.client ?? client).get<DownloadNoticeFileApiV1OffCycleNoticesNoticeIdFileGetResponses, DownloadNoticeFileApiV1OffCycleNoticesNoticeIdFileGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/off-cycle-notices/{notice_id}/file',
    ...options
});

/**
 * Mark the notice as sent, with proof
 *
 * Records that the insurer was told, through which door, when, and with whatever came back.
 *
 * **At least one of `reference`, `proof_document_id` and `notes` is required**, and a request with none of them is refused with `422`. The same rule the monthly marker holds, and it binds harder here: a month leaves a frozen file and a sign-off behind it whatever the marker says, and an off-cycle notice leaves nothing but this row. "We told them on the 25th" with nothing behind it is precisely the claim somebody will dispute.
 *
 * `sent_at` is accepted because an urgent notice goes out first and gets written up afterwards; a moment in the future is refused. Send an offset -- a value without one is read as São Paulo wall-clock time.
 *
 * **This does not move the watermark.** A movement dated inside the period this notice covers is exactly as retroactive afterwards as it was before, because the insurer has been told about named people rather than told everything up to a day. Only a monthly submission marked sent moves it.
 *
 * **Nothing is transmitted by this call.** It records what a person did.
 *
 * **Staff only.** This operation requires `submission:write`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const markNoticeSentApiV1OffCycleNoticesNoticeIdSentPost = <ThrowOnError extends boolean = false>(options: Options<MarkNoticeSentApiV1OffCycleNoticesNoticeIdSentPostData, ThrowOnError>): RequestResult<MarkNoticeSentApiV1OffCycleNoticesNoticeIdSentPostResponses, MarkNoticeSentApiV1OffCycleNoticesNoticeIdSentPostErrors, ThrowOnError> => (options.client ?? client).post<MarkNoticeSentApiV1OffCycleNoticesNoticeIdSentPostResponses, MarkNoticeSentApiV1OffCycleNoticesNoticeIdSentPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/off-cycle-notices/{notice_id}/sent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One contract's cycle, movement by movement
 *
 * Every movement whose effective date falls in this cutoff, with the action, the person, the effective date, the channel it arrived through, the validation flags raised against it and the identifiers of any supporting documents linked to it.
 *
 * **Carry-over is included and late arrivals are not.** A movement filed for a cycle already past has still not been reported, so the next file is the one it goes on and it is listed here. A movement dated inside a month whose file the insurer already has is *never* here; it is at `/late-arrivals`, counted separately, with no correction path offered.
 *
 * Rejected, returned and cancelled movements are not in this list and are not in the snapshot preview either -- deciding against one is what takes it out of the cycle.
 *
 * **Staff only.** This operation requires `review:read`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const readCycleApiV1ReviewCyclesContractIdGet = <ThrowOnError extends boolean = false>(options: Options<ReadCycleApiV1ReviewCyclesContractIdGetData, ThrowOnError>): RequestResult<ReadCycleApiV1ReviewCyclesContractIdGetResponses, ReadCycleApiV1ReviewCyclesContractIdGetErrors, ThrowOnError> => (options.client ?? client).get<ReadCycleApiV1ReviewCyclesContractIdGetResponses, ReadCycleApiV1ReviewCyclesContractIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/review/cycles/{contract_id}',
    ...options
});

/**
 * Every sign-off of one contract
 *
 * The gate's history, withdrawn sign-offs included, most recent cycle first. A cycle that was approved and then reopened appears as the row it is, stamped with who withdrew it and why -- which is the point of keeping it rather than deleting it.
 *
 * **Staff only.** This operation requires `review:read`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const readApprovalsApiV1ReviewCyclesContractIdApprovalsGet = <ThrowOnError extends boolean = false>(options: Options<ReadApprovalsApiV1ReviewCyclesContractIdApprovalsGetData, ThrowOnError>): RequestResult<ReadApprovalsApiV1ReviewCyclesContractIdApprovalsGetResponses, ReadApprovalsApiV1ReviewCyclesContractIdApprovalsGetErrors, ThrowOnError> => (options.client ?? client).get<ReadApprovalsApiV1ReviewCyclesContractIdApprovalsGetResponses, ReadApprovalsApiV1ReviewCyclesContractIdApprovalsGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/review/cycles/{contract_id}/approvals',
    ...options
});

/**
 * Approve the cycle, freezing its file
 *
 * The point of the whole queue. Records the approving user, the cutoff date and the exact snapshot that was previewed, freezes that snapshot so it can no longer be rewritten by anything -- the database refuses it too -- and marks the cycle ready for submission.
 *
 * **Refused while any movement in the cycle carries a blocking validation error.** Decide each of them -- approve, reject, return, or correct the date -- and approve again. A warning is not a blocker: a termination with no paperwork attached is for the analyst to look at and then decide -- unless its company's `termination_document_policy` is `block`, in which case it is a blocking flag lifted by linking a document to it.
 *
 * **Refused when the cycle is already approved.** An approved cycle is immutable; reopen it first, which is itself recorded.
 *
 * Send `snapshot_id` and `snapshot_sha256` from the preview you read. Either one that does not match the cycle's stored snapshot is a `409`: it means the file was regenerated between reading it and signing it, and approving anyway would sign off something nobody looked at.
 *
 * **Staff only.** This operation requires `review:write`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const approveCycleApiV1ReviewCyclesContractIdApprovePost = <ThrowOnError extends boolean = false>(options: Options<ApproveCycleApiV1ReviewCyclesContractIdApprovePostData, ThrowOnError>): RequestResult<ApproveCycleApiV1ReviewCyclesContractIdApprovePostResponses, ApproveCycleApiV1ReviewCyclesContractIdApprovePostErrors, ThrowOnError> => (options.client ?? client).post<ApproveCycleApiV1ReviewCyclesContractIdApprovePostResponses, ApproveCycleApiV1ReviewCyclesContractIdApprovePostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/review/cycles/{contract_id}/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Movements that arrived after their own month had been submitted
 *
 * Movements whose effective date falls on or before the last day already reported to the insurer. Approving one would change a month whose file has gone out.
 *
 * **They are listed and nothing else.** There is no correction or resubmission path here, deliberately: what this insurer accepts by way of an amendment is an open question, and offering a path before we know the answer would be worse than saying so. Off-cycle submission is a separate piece of work.
 *
 * They are never folded into the current cycle and never counted as part of it.
 *
 * **Staff only.** This operation requires `review:read`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const readLateArrivalsApiV1ReviewCyclesContractIdLateArrivalsGet = <ThrowOnError extends boolean = false>(options: Options<ReadLateArrivalsApiV1ReviewCyclesContractIdLateArrivalsGetData, ThrowOnError>): RequestResult<ReadLateArrivalsApiV1ReviewCyclesContractIdLateArrivalsGetResponses, ReadLateArrivalsApiV1ReviewCyclesContractIdLateArrivalsGetErrors, ThrowOnError> => (options.client ?? client).get<ReadLateArrivalsApiV1ReviewCyclesContractIdLateArrivalsGetResponses, ReadLateArrivalsApiV1ReviewCyclesContractIdLateArrivalsGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/review/cycles/{contract_id}/late-arrivals',
    ...options
});

/**
 * Read the file already built for this cutoff
 *
 * The same document the preview produces, without generating anything. `404` when nothing has been built for the cycle yet.
 *
 * Safe on an approved cycle, and the way its frozen file is read back after the fact.
 *
 * **Staff only.** This operation requires `review:read`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const readPreviewApiV1ReviewCyclesContractIdPreviewGet = <ThrowOnError extends boolean = false>(options: Options<ReadPreviewApiV1ReviewCyclesContractIdPreviewGetData, ThrowOnError>): RequestResult<ReadPreviewApiV1ReviewCyclesContractIdPreviewGetResponses, ReadPreviewApiV1ReviewCyclesContractIdPreviewGetErrors, ThrowOnError> => (options.client ?? client).get<ReadPreviewApiV1ReviewCyclesContractIdPreviewGetResponses, ReadPreviewApiV1ReviewCyclesContractIdPreviewGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/review/cycles/{contract_id}/preview',
    ...options
});

/**
 * Build the file this cutoff would produce, and compare it
 *
 * Generates the cycle's snapshot through the snapshot engine and returns it with the difference against the last *approved* snapshot of the same contract: who is new, who has gone, and whose cells moved, with the before and after of each.
 *
 * Calling it again replaces the draft, which is what an analyst wants after deciding a handful of movements. A cycle that has already been signed off is refused -- read its approved file with `GET .../preview` instead.
 *
 * The `file_sha256` in the response is what to send back as `snapshot_sha256` when approving, which is how the gate knows you signed off the file you read.
 *
 * **Staff only.** This operation requires `review:write`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const previewCycleApiV1ReviewCyclesContractIdPreviewPost = <ThrowOnError extends boolean = false>(options: Options<PreviewCycleApiV1ReviewCyclesContractIdPreviewPostData, ThrowOnError>): RequestResult<PreviewCycleApiV1ReviewCyclesContractIdPreviewPostResponses, PreviewCycleApiV1ReviewCyclesContractIdPreviewPostErrors, ThrowOnError> => (options.client ?? client).post<PreviewCycleApiV1ReviewCyclesContractIdPreviewPostResponses, PreviewCycleApiV1ReviewCyclesContractIdPreviewPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/review/cycles/{contract_id}/preview',
    ...options
});

/**
 * Reopen an approved cycle
 *
 * Withdraws the sign-off, with a reason, and records the withdrawal as an action of its own. The cycle stops being ready for submission and its movements become decidable again.
 *
 * **The approved file stays frozen.** It is the evidence of what had been signed off, and a file that could be edited after approval would not be evidence of anything -- so reopening does not make the cycle regenerable. What gets corrected afterwards changes what the *next* cycle's file says, which is the rule the snapshot engine has always had.
 *
 * `409` when no sign-off stands for the cycle.
 *
 * **Staff only.** This operation requires `review:write`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const reopenCycleApiV1ReviewCyclesContractIdReopenPost = <ThrowOnError extends boolean = false>(options: Options<ReopenCycleApiV1ReviewCyclesContractIdReopenPostData, ThrowOnError>): RequestResult<ReopenCycleApiV1ReviewCyclesContractIdReopenPostResponses, ReopenCycleApiV1ReviewCyclesContractIdReopenPostErrors, ThrowOnError> => (options.client ?? client).post<ReopenCycleApiV1ReviewCyclesContractIdReopenPostResponses, ReopenCycleApiV1ReviewCyclesContractIdReopenPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/review/cycles/{contract_id}/reopen',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Movements scheduled for a later cycle
 *
 * The pipeline ahead: movements already filed whose effective date falls after this cutoff, each showing the cycle it will land in.
 *
 * Here so that a termination filed in April for the end of May is visible in April rather than arriving as a surprise at May's cutoff.
 *
 * **Staff only.** This operation requires `review:read`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const readUpcomingApiV1ReviewCyclesContractIdUpcomingGet = <ThrowOnError extends boolean = false>(options: Options<ReadUpcomingApiV1ReviewCyclesContractIdUpcomingGetData, ThrowOnError>): RequestResult<ReadUpcomingApiV1ReviewCyclesContractIdUpcomingGetResponses, ReadUpcomingApiV1ReviewCyclesContractIdUpcomingGetErrors, ThrowOnError> => (options.client ?? client).get<ReadUpcomingApiV1ReviewCyclesContractIdUpcomingGetResponses, ReadUpcomingApiV1ReviewCyclesContractIdUpcomingGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/review/cycles/{contract_id}/upcoming',
    ...options
});

/**
 * Approve one movement
 *
 * Records the change in the roster through the delta lifecycle, with the movement's own effective date. Nothing is queued and nothing runs afterwards.
 *
 * Refused with `409` when the movement's cycle has already been signed off: an approved cycle does not move. Reopen it first if this really has to change before the file goes out.
 *
 * Refused with `409` too when the movement is a termination with no supporting document linked to it and its company's `termination_document_policy` is `block`. Link the paperwork, or reject or return the movement.
 *
 * **Staff only.** This operation requires `review:write`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const approveItemApiV1ReviewItemsDeltaIdApprovePost = <ThrowOnError extends boolean = false>(options: Options<ApproveItemApiV1ReviewItemsDeltaIdApprovePostData, ThrowOnError>): RequestResult<ApproveItemApiV1ReviewItemsDeltaIdApprovePostResponses, ApproveItemApiV1ReviewItemsDeltaIdApprovePostErrors, ThrowOnError> => (options.client ?? client).post<ApproveItemApiV1ReviewItemsDeltaIdApprovePostResponses, ApproveItemApiV1ReviewItemsDeltaIdApprovePostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/review/items/{delta_id}/approve',
    ...options
});

/**
 * Correct one movement's effective date
 *
 * Replaces the effective date with the one the signed paperwork says. The value being replaced is kept on the movement as `original_effective_date`, beside the principal who replaced it and when -- so the record still answers what the customer filed as well as what we are acting on.
 *
 * The one field of a movement anybody may change, and only while it is `submitted`: once approved the date is in the roster, and the correction for that is a superseding movement.
 *
 * The new date is checked against the roster exactly as submission checked the old one, so moving a termination onto a day the person is not insured is a `409` rather than a broken file. Moving a movement into a cycle that has already been signed off is refused for the same reason moving one out of one is.
 *
 * **Staff only.** This operation requires `review:write`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const correctEffectiveDateApiV1ReviewItemsDeltaIdEffectiveDatePost = <ThrowOnError extends boolean = false>(options: Options<CorrectEffectiveDateApiV1ReviewItemsDeltaIdEffectiveDatePostData, ThrowOnError>): RequestResult<CorrectEffectiveDateApiV1ReviewItemsDeltaIdEffectiveDatePostResponses, CorrectEffectiveDateApiV1ReviewItemsDeltaIdEffectiveDatePostErrors, ThrowOnError> => (options.client ?? client).post<CorrectEffectiveDateApiV1ReviewItemsDeltaIdEffectiveDatePostResponses, CorrectEffectiveDateApiV1ReviewItemsDeltaIdEffectiveDatePostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/review/items/{delta_id}/effective-date',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reject one movement, with a reason
 *
 * Refuses the change and keeps the reason against it. Nothing is written to the roster, and the movement drops out of the cycle -- it will not be in the snapshot preview.
 *
 * A rejection says we are not making this change. Use `/return` instead when the customer is expected to correct it and file it again.
 *
 * **Staff only.** This operation requires `review:write`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const rejectItemApiV1ReviewItemsDeltaIdRejectPost = <ThrowOnError extends boolean = false>(options: Options<RejectItemApiV1ReviewItemsDeltaIdRejectPostData, ThrowOnError>): RequestResult<RejectItemApiV1ReviewItemsDeltaIdRejectPostResponses, RejectItemApiV1ReviewItemsDeltaIdRejectPostErrors, ThrowOnError> => (options.client ?? client).post<RejectItemApiV1ReviewItemsDeltaIdRejectPostResponses, RejectItemApiV1ReviewItemsDeltaIdRejectPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/review/items/{delta_id}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Return one movement to the customer for correction
 *
 * Hands the movement back with what has to be fixed. Nothing is written to the roster, and it drops out of the cycle exactly as a rejection does.
 *
 * Its own outcome rather than a flavour of rejection because it means something different to whoever receives it: a rejection is a refusal, a return is a request to file it again properly. The status it leaves behind is `returned`, and the customer corrects it by submitting a fresh movement.
 *
 * **Staff only.** This operation requires `review:write`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const returnItemApiV1ReviewItemsDeltaIdReturnPost = <ThrowOnError extends boolean = false>(options: Options<ReturnItemApiV1ReviewItemsDeltaIdReturnPostData, ThrowOnError>): RequestResult<ReturnItemApiV1ReviewItemsDeltaIdReturnPostResponses, ReturnItemApiV1ReviewItemsDeltaIdReturnPostErrors, ThrowOnError> => (options.client ?? client).post<ReturnItemApiV1ReviewItemsDeltaIdReturnPostResponses, ReturnItemApiV1ReviewItemsDeltaIdReturnPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/review/items/{delta_id}/return',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Every contract's cycle, one line each
 *
 * The back-office's front page: for one cycle month, every contract the request's scope can see, with how many movements are waiting on it, how many of them are blocked, how many are scheduled for a later cycle, how many arrived after their own month had gone, and whether the cutoff has been signed off.
 *
 * vyttech staff read every company by default. Send `X-Company-Id` to work inside one.
 *
 * **Staff only.** This operation requires `review:read`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const readQueueApiV1ReviewQueueGet = <ThrowOnError extends boolean = false>(options?: Options<ReadQueueApiV1ReviewQueueGetData, ThrowOnError>): RequestResult<ReadQueueApiV1ReviewQueueGetResponses, ReadQueueApiV1ReviewQueueGetErrors, ThrowOnError> => (options?.client ?? client).get<ReadQueueApiV1ReviewQueueGetResponses, ReadQueueApiV1ReviewQueueGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/review/queue',
    ...options
});

/**
 * List the registered insurer file layouts
 *
 * Every layout an insurer can be pointed at, with its columns and its formatting as configured. Served so that reconciling our output against an insurer's written specification does not require reading the source.
 *
 * A layout is not any tenant's data, so every authenticated principal may read this.
 */
export const listLayoutsApiV1SnapshotLayoutsGet = <ThrowOnError extends boolean = false>(options?: Options<ListLayoutsApiV1SnapshotLayoutsGetData, ThrowOnError>): RequestResult<ListLayoutsApiV1SnapshotLayoutsGetResponses, ListLayoutsApiV1SnapshotLayoutsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListLayoutsApiV1SnapshotLayoutsGetResponses, ListLayoutsApiV1SnapshotLayoutsGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/snapshot-layouts',
    ...options
});

/**
 * List snapshots
 *
 * Snapshots within the request's company scope, most recent cycle first. Every filter is optional and they combine with AND. Metadata only; the rows come with the individual snapshot.
 */
export const listSnapshotsApiV1SnapshotsGet = <ThrowOnError extends boolean = false>(options?: Options<ListSnapshotsApiV1SnapshotsGetData, ThrowOnError>): RequestResult<ListSnapshotsApiV1SnapshotsGetResponses, ListSnapshotsApiV1SnapshotsGetErrors, ThrowOnError> => (options?.client ?? client).get<ListSnapshotsApiV1SnapshotsGetResponses, ListSnapshotsApiV1SnapshotsGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/snapshots',
    ...options
});

/**
 * Fetch a snapshot with its rows
 *
 * The cycle, the layout's columns, every rendered row and every person the layout would not write.
 *
 * A snapshot belonging to another company is `404`; the company filter is part of the query, so supplying the identifier directly does not reach the row.
 */
export const getSnapshotApiV1SnapshotsSnapshotIdGet = <ThrowOnError extends boolean = false>(options: Options<GetSnapshotApiV1SnapshotsSnapshotIdGetData, ThrowOnError>): RequestResult<GetSnapshotApiV1SnapshotsSnapshotIdGetResponses, GetSnapshotApiV1SnapshotsSnapshotIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetSnapshotApiV1SnapshotsSnapshotIdGetResponses, GetSnapshotApiV1SnapshotsSnapshotIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/snapshots/{snapshot_id}',
    ...options
});

/**
 * Approve a snapshot, freezing it
 *
 * Marks the snapshot as the file the insurer gets. After this it is immutable: regeneration is refused, and a delta approved tomorrow or a roster correction next week changes what the *next* cycle says and nothing here. The database enforces it as well as this endpoint does.
 *
 * A snapshot with exceptions is incomplete, and approving it needs `acknowledge_exceptions: true` -- sending the insurer a file that is missing people has to be somebody's decision rather than a default.
 */
export const approveSnapshotApiV1SnapshotsSnapshotIdApprovePost = <ThrowOnError extends boolean = false>(options: Options<ApproveSnapshotApiV1SnapshotsSnapshotIdApprovePostData, ThrowOnError>): RequestResult<ApproveSnapshotApiV1SnapshotsSnapshotIdApprovePostResponses, ApproveSnapshotApiV1SnapshotsSnapshotIdApprovePostErrors, ThrowOnError> => (options.client ?? client).post<ApproveSnapshotApiV1SnapshotsSnapshotIdApprovePostResponses, ApproveSnapshotApiV1SnapshotsSnapshotIdApprovePostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/snapshots/{snapshot_id}/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Compare a snapshot with the previous approved one, or the roster
 *
 * Who is new this cycle, who has gone, and whose cells moved -- with the before and after of each changed cell.
 *
 * The comparison is against the last *approved* snapshot of the same contract before this cycle, because that is the file the insurer holds. Rendered values are compared, not projected ones: a change here is a change the insurer will see in the file.
 *
 * When there is none, the previous side is the roster as of the previous cycle's reference date -- the side the file's movements were read from -- and `previous_snapshot_id` is `null`. A row stored as an inclusion is added, an alteration is changed with its salary before and after, an unchanged row is in no list, and somebody on that roster with no row here is removed, whether or not the layout writes exclusion rows.
 */
export const compareSnapshotApiV1SnapshotsSnapshotIdComparisonGet = <ThrowOnError extends boolean = false>(options: Options<CompareSnapshotApiV1SnapshotsSnapshotIdComparisonGetData, ThrowOnError>): RequestResult<CompareSnapshotApiV1SnapshotsSnapshotIdComparisonGetResponses, CompareSnapshotApiV1SnapshotsSnapshotIdComparisonGetErrors, ThrowOnError> => (options.client ?? client).get<CompareSnapshotApiV1SnapshotsSnapshotIdComparisonGetResponses, CompareSnapshotApiV1SnapshotsSnapshotIdComparisonGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/snapshots/{snapshot_id}/comparison',
    ...options
});

/**
 * Download a snapshot's rendered file
 *
 * The bytes as they were rendered, in the layout's own encoding and media type. Stored encrypted like the roster columns they came from, and decrypted only to serve this response.
 *
 * For an approved snapshot these bytes are frozen: re-rendering its stored rows reproduces them exactly, whatever has happened to the roster since.
 */
export const downloadSnapshotFileApiV1SnapshotsSnapshotIdFileGet = <ThrowOnError extends boolean = false>(options: Options<DownloadSnapshotFileApiV1SnapshotsSnapshotIdFileGetData, ThrowOnError>): RequestResult<DownloadSnapshotFileApiV1SnapshotsSnapshotIdFileGetResponses, DownloadSnapshotFileApiV1SnapshotsSnapshotIdFileGetErrors, ThrowOnError> => (options.client ?? client).get<DownloadSnapshotFileApiV1SnapshotsSnapshotIdFileGetResponses, DownloadSnapshotFileApiV1SnapshotsSnapshotIdFileGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/snapshots/{snapshot_id}/file',
    ...options
});

/**
 * Download the i8life spreadsheet template
 *
 * The sheet we ask customers to fill in: the nine columns their current file already has, plus `Data de vigência` -- one effective date per row, which every movement needs and which the legacy layout has nowhere to put.
 *
 * `format=xlsx` (the default) returns a workbook with the header frozen and the CPF column formatted as text, so a leading zero survives being typed. `format=csv` returns a semicolon-separated UTF-8 file with a byte-order mark, which is what Excel on a Brazilian machine opens correctly.
 *
 * Filling it in and posting it back is the whole of the upload path. The legacy sheet is still accepted; this one simply does not need a date supplied alongside it.
 */
export const downloadTemplateApiV1SpreadsheetUploadsTemplateGet = <ThrowOnError extends boolean = false>(options?: Options<DownloadTemplateApiV1SpreadsheetUploadsTemplateGetData, ThrowOnError>): RequestResult<DownloadTemplateApiV1SpreadsheetUploadsTemplateGetResponses, DownloadTemplateApiV1SpreadsheetUploadsTemplateGetErrors, ThrowOnError> => (options?.client ?? client).get<DownloadTemplateApiV1SpreadsheetUploadsTemplateGetResponses, DownloadTemplateApiV1SpreadsheetUploadsTemplateGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/spreadsheet-uploads/template',
    ...options
});

/**
 * Every contract's month, one line each
 *
 * The month at a glance: for one cycle month, every contract the request's scope can see, with how far through the rhythm it has got -- `open`, `approved`, `prepared`, `sent` or `failed` -- the cutoff it reads the roster at, and whether that cutoff has passed with nothing filed.
 *
 * `outstanding_count` is the number this screen exists to drive to zero every month, and `overdue_count` is how many of those are already late by our own calendar.
 *
 * vyttech staff read every company by default. Send `X-Company-Id` to work inside one.
 *
 * **Staff only.** This operation requires `submission:read`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const readCalendarApiV1SubmissionsGet = <ThrowOnError extends boolean = false>(options?: Options<ReadCalendarApiV1SubmissionsGetData, ThrowOnError>): RequestResult<ReadCalendarApiV1SubmissionsGetResponses, ReadCalendarApiV1SubmissionsGetErrors, ThrowOnError> => (options?.client ?? client).get<ReadCalendarApiV1SubmissionsGetResponses, ReadCalendarApiV1SubmissionsGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/submissions',
    ...options
});

/**
 * One company's month with an insurer, filed as one file
 *
 * Every contract the company holds with the insurer, in the file's order -- ascending subestipulante, then módulo -- each with its own stage and the rows its approved snapshot puts in the file; whether the file can be prepared now and, when not, which contracts still lack a sign-off; and every file prepared for the month, refused ones included.
 *
 * A company outside the request's scope, or one holding no contract with the insurer, is `404`.
 *
 * A company that belongs to an economic group is answered too, with `group_id` and `group_name` set and `can_prepare` false: its month is filed in the group's file.
 *
 * Only for an insurer whose layout files one file per company and month (`consolidated: true` on each contract's standing). Any other insurer is refused with `409`: its contracts are filed one by one.
 *
 * **Staff only.** This operation requires `submission:read`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const readConsolidatedStandingApiV1SubmissionsCompaniesCompanyIdInsurersInsurerIdGet = <ThrowOnError extends boolean = false>(options: Options<ReadConsolidatedStandingApiV1SubmissionsCompaniesCompanyIdInsurersInsurerIdGetData, ThrowOnError>): RequestResult<ReadConsolidatedStandingApiV1SubmissionsCompaniesCompanyIdInsurersInsurerIdGetResponses, ReadConsolidatedStandingApiV1SubmissionsCompaniesCompanyIdInsurersInsurerIdGetErrors, ThrowOnError> => (options.client ?? client).get<ReadConsolidatedStandingApiV1SubmissionsCompaniesCompanyIdInsurersInsurerIdGetResponses, ReadConsolidatedStandingApiV1SubmissionsCompaniesCompanyIdInsurersInsurerIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/submissions/companies/{company_id}/insurers/{insurer_id}',
    ...options
});

/**
 * Package one company's month as a single file
 *
 * Prepares every member contract's own submission -- reusing one already prepared for the month -- and renders one file from their approved snapshots' stored rows: contracts in ascending subestipulante then módulo, each contract's rows in its snapshot's order, every row carrying its own contract's Subestipulante and Módulo. Each member snapshot's digest is checked against its sign-off first. The file is named by the layout's template for the company and the month, never for one contract.
 *
 * **All or nothing.** When any member has no approved cycle for the month the request is refused with `409`, naming each such contract in the message and in `details` (`contracts.{contract_id}`), and nothing is prepared for the others.
 *
 * **Refused with `409` when a file is already standing** for the company, insurer and month, prepared or filed -- concurrent requests included. Record what became of it first.
 *
 * Download the file from `GET /submissions/consolidated/{id}/file`.
 *
 * Only for an insurer whose layout files one file per company and month (`consolidated: true` on each contract's standing). Any other insurer is refused with `409`: its contracts are filed one by one.
 *
 * **Refused with `409` for a company that belongs to an economic group.** Its month goes out in the group's single file, at `/submissions/groups/{group_id}/insurers/{insurer_id}`, and the message says so.
 *
 * **Staff only.** This operation requires `submission:write`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const prepareConsolidatedApiV1SubmissionsCompaniesCompanyIdInsurersInsurerIdPreparePost = <ThrowOnError extends boolean = false>(options: Options<PrepareConsolidatedApiV1SubmissionsCompaniesCompanyIdInsurersInsurerIdPreparePostData, ThrowOnError>): RequestResult<PrepareConsolidatedApiV1SubmissionsCompaniesCompanyIdInsurersInsurerIdPreparePostResponses, PrepareConsolidatedApiV1SubmissionsCompaniesCompanyIdInsurersInsurerIdPreparePostErrors, ThrowOnError> => (options.client ?? client).post<PrepareConsolidatedApiV1SubmissionsCompaniesCompanyIdInsurersInsurerIdPreparePostResponses, PrepareConsolidatedApiV1SubmissionsCompaniesCompanyIdInsurersInsurerIdPreparePostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/submissions/companies/{company_id}/insurers/{insurer_id}/prepare',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One company-wide file
 *
 * Everything recorded about one consolidated file: the month and insurer, the member submissions it packages, its digest, who prepared it and what became of it.
 *
 * **Staff only.** This operation requires `submission:read`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const readConsolidatedApiV1SubmissionsConsolidatedConsolidatedIdGet = <ThrowOnError extends boolean = false>(options: Options<ReadConsolidatedApiV1SubmissionsConsolidatedConsolidatedIdGetData, ThrowOnError>): RequestResult<ReadConsolidatedApiV1SubmissionsConsolidatedConsolidatedIdGetResponses, ReadConsolidatedApiV1SubmissionsConsolidatedConsolidatedIdGetErrors, ThrowOnError> => (options.client ?? client).get<ReadConsolidatedApiV1SubmissionsConsolidatedConsolidatedIdGetResponses, ReadConsolidatedApiV1SubmissionsConsolidatedConsolidatedIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/submissions/consolidated/{consolidated_id}',
    ...options
});

/**
 * Record a company-wide file the insurer refused
 *
 * Marks the file failed with a mandatory reason, and every member contract's submission with it, in one transaction. The sign-offs still stand: a new file can be prepared for the same month, and this one stays in the month's `attempts`. A failed file never moves any watermark.
 *
 * **Still available after the company joins an economic group.** No company file can be prepared for a grouped company, but one prepared before it joined is settled here: the group's file waits for it, and leaves out any contract it filed.
 *
 * **Staff only.** This operation requires `submission:write`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const markConsolidatedFailedApiV1SubmissionsConsolidatedConsolidatedIdFailedPost = <ThrowOnError extends boolean = false>(options: Options<MarkConsolidatedFailedApiV1SubmissionsConsolidatedConsolidatedIdFailedPostData, ThrowOnError>): RequestResult<MarkConsolidatedFailedApiV1SubmissionsConsolidatedConsolidatedIdFailedPostResponses, MarkConsolidatedFailedApiV1SubmissionsConsolidatedConsolidatedIdFailedPostErrors, ThrowOnError> => (options.client ?? client).post<MarkConsolidatedFailedApiV1SubmissionsConsolidatedConsolidatedIdFailedPostResponses, MarkConsolidatedFailedApiV1SubmissionsConsolidatedConsolidatedIdFailedPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/submissions/consolidated/{consolidated_id}/failed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download a company-wide file
 *
 * The bytes as they were rendered when the file was prepared, in the layout's own media type, served as an attachment under the stored name. Stored encrypted and decrypted only to serve this response; every download returns the same bytes, whose SHA-256 is the record's `file_sha256`.
 *
 * **Staff only.** This operation requires `submission:read`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const downloadConsolidatedFileApiV1SubmissionsConsolidatedConsolidatedIdFileGet = <ThrowOnError extends boolean = false>(options: Options<DownloadConsolidatedFileApiV1SubmissionsConsolidatedConsolidatedIdFileGetData, ThrowOnError>): RequestResult<DownloadConsolidatedFileApiV1SubmissionsConsolidatedConsolidatedIdFileGetResponses, DownloadConsolidatedFileApiV1SubmissionsConsolidatedConsolidatedIdFileGetErrors, ThrowOnError> => (options.client ?? client).get<DownloadConsolidatedFileApiV1SubmissionsConsolidatedConsolidatedIdFileGetResponses, DownloadConsolidatedFileApiV1SubmissionsConsolidatedConsolidatedIdFileGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/submissions/consolidated/{consolidated_id}/file',
    ...options
});

/**
 * Mark a company-wide file as sent, and every contract in it
 *
 * Records that the file reached the insurer, and marks every member contract's submission sent in the same transaction with the same channel, moment, protocol, receipt and notes -- so each contract's watermark moves exactly as it would have filed alone.
 *
 * The rule is the per-contract marker's: a `channel` always, and **at least one of `reference`, `proof_document_id` and `notes`**, refused with `422` otherwise; a `sent_at` in the future is refused too. Nothing moves unless every member can be marked.
 *
 * **Still available after the company joins an economic group.** No company file can be prepared for a grouped company, but one prepared before it joined is settled here: the group's file waits for it, and leaves out any contract it filed.
 *
 * **Staff only.** This operation requires `submission:write`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const markConsolidatedSentApiV1SubmissionsConsolidatedConsolidatedIdSentPost = <ThrowOnError extends boolean = false>(options: Options<MarkConsolidatedSentApiV1SubmissionsConsolidatedConsolidatedIdSentPostData, ThrowOnError>): RequestResult<MarkConsolidatedSentApiV1SubmissionsConsolidatedConsolidatedIdSentPostResponses, MarkConsolidatedSentApiV1SubmissionsConsolidatedConsolidatedIdSentPostErrors, ThrowOnError> => (options.client ?? client).post<MarkConsolidatedSentApiV1SubmissionsConsolidatedConsolidatedIdSentPostResponses, MarkConsolidatedSentApiV1SubmissionsConsolidatedConsolidatedIdSentPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/submissions/consolidated/{consolidated_id}/sent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One contract's month
 *
 * Where this contract's cycle has got to, with the sign-off standing over it and the attempt standing against it. The most recent refused attempt is beside them rather than instead of them: a month refused once and then filed reads as `sent`, and the refusal is still worth seeing.
 *
 * **Staff only.** This operation requires `submission:read`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const readStandingApiV1SubmissionsContractsContractIdGet = <ThrowOnError extends boolean = false>(options: Options<ReadStandingApiV1SubmissionsContractsContractIdGetData, ThrowOnError>): RequestResult<ReadStandingApiV1SubmissionsContractsContractIdGetResponses, ReadStandingApiV1SubmissionsContractsContractIdGetErrors, ThrowOnError> => (options.client ?? client).get<ReadStandingApiV1SubmissionsContractsContractIdGetResponses, ReadStandingApiV1SubmissionsContractsContractIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/submissions/contracts/{contract_id}',
    ...options
});

/**
 * Every attempt on one contract
 *
 * The filing history, refused attempts included, most recent cycle first. "March was refused on the 3rd for a malformed CPF and filed on the 4th" is the thing this listing exists to say, and one that showed only what worked would leave only the version that suits us.
 *
 * Watermarks asserted by hand through `POST /contracts/{contract_id}/snapshot-submissions` appear here too, as `source: manual`, carrying no cycle month and no file.
 *
 * **Staff only.** This operation requires `submission:read`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const readHistoryApiV1SubmissionsContractsContractIdHistoryGet = <ThrowOnError extends boolean = false>(options: Options<ReadHistoryApiV1SubmissionsContractsContractIdHistoryGetData, ThrowOnError>): RequestResult<ReadHistoryApiV1SubmissionsContractsContractIdHistoryGetResponses, ReadHistoryApiV1SubmissionsContractsContractIdHistoryGetErrors, ThrowOnError> => (options.client ?? client).get<ReadHistoryApiV1SubmissionsContractsContractIdHistoryGetResponses, ReadHistoryApiV1SubmissionsContractsContractIdHistoryGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/submissions/contracts/{contract_id}/history',
    ...options
});

/**
 * Package the approved file for filing
 *
 * Takes the file the cutoff was signed off over and records that it has left the building. The step between "an analyst approved this" and "somebody filed it", and a step of its own because the gap between the two is real: the file is downloaded, carried to the insurer's portal, and uploaded. A month that sat `prepared` for a fortnight is a month nobody filed, and a lifecycle without this state would show it as not started.
 *
 * **Refused with `409` when the cycle has no sign-off standing.** The gate is what guarantees the bytes leaving the building are the ones an analyst read; packaging around it would make the gate decorative.
 *
 * **Refused with `409` when an attempt is already standing** -- prepared or filed. Record what became of that one first.
 *
 * Send `snapshot_sha256` from the approval you read: one that does not match is a `409` rather than a file filed by mistake.
 *
 * Download what to file from `GET /snapshots/{snapshot_id}/file`, using the `snapshot_id` this returns.
 *
 * **Refused with `409` for a contract whose insurer's layout files one file per company** (`consolidated: true` on its standing). Its month is prepared, marked sent and marked failed only through the company's file, at `/submissions/companies/{company_id}/insurers/{insurer_id}` and `/submissions/consolidated/{id}`, so the contract's record and the file the insurer received cannot drift apart. When the contract's company belongs to an economic group (`group_id` on its standing), the refusal names the group's file instead, at `/submissions/groups/{group_id}/insurers/{insurer_id}`.
 *
 * **Staff only.** This operation requires `submission:write`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const prepareSubmissionApiV1SubmissionsContractsContractIdPreparePost = <ThrowOnError extends boolean = false>(options: Options<PrepareSubmissionApiV1SubmissionsContractsContractIdPreparePostData, ThrowOnError>): RequestResult<PrepareSubmissionApiV1SubmissionsContractsContractIdPreparePostResponses, PrepareSubmissionApiV1SubmissionsContractsContractIdPreparePostErrors, ThrowOnError> => (options.client ?? client).post<PrepareSubmissionApiV1SubmissionsContractsContractIdPreparePostResponses, PrepareSubmissionApiV1SubmissionsContractsContractIdPreparePostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/submissions/contracts/{contract_id}/prepare',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One group-wide file
 *
 * Everything recorded about one group file: the group, month and insurer, the companies and member submissions it packages, its digest, who prepared it and what became of it.
 *
 * **Staff only.** Requires `submission:read` (`submission:write` to change anything) and a vyttech role. A customer's user -- including one registered at the group -- and a machine client are refused with `403`.
 */
export const readGroupFileApiV1SubmissionsGroupFilesGroupFileIdGet = <ThrowOnError extends boolean = false>(options: Options<ReadGroupFileApiV1SubmissionsGroupFilesGroupFileIdGetData, ThrowOnError>): RequestResult<ReadGroupFileApiV1SubmissionsGroupFilesGroupFileIdGetResponses, ReadGroupFileApiV1SubmissionsGroupFilesGroupFileIdGetErrors, ThrowOnError> => (options.client ?? client).get<ReadGroupFileApiV1SubmissionsGroupFilesGroupFileIdGetResponses, ReadGroupFileApiV1SubmissionsGroupFilesGroupFileIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/submissions/group-files/{group_file_id}',
    ...options
});

/**
 * Record a group-wide file the insurer refused
 *
 * Marks the file failed with a mandatory reason, and every member contract's submission with it, in one transaction. The sign-offs still stand: a new file can be prepared for the same month, and this one stays in the month's `attempts`. A failed file never moves any watermark.
 *
 * **Staff only.** Requires `submission:read` (`submission:write` to change anything) and a vyttech role. A customer's user -- including one registered at the group -- and a machine client are refused with `403`.
 */
export const markGroupFileFailedApiV1SubmissionsGroupFilesGroupFileIdFailedPost = <ThrowOnError extends boolean = false>(options: Options<MarkGroupFileFailedApiV1SubmissionsGroupFilesGroupFileIdFailedPostData, ThrowOnError>): RequestResult<MarkGroupFileFailedApiV1SubmissionsGroupFilesGroupFileIdFailedPostResponses, MarkGroupFileFailedApiV1SubmissionsGroupFilesGroupFileIdFailedPostErrors, ThrowOnError> => (options.client ?? client).post<MarkGroupFileFailedApiV1SubmissionsGroupFilesGroupFileIdFailedPostResponses, MarkGroupFileFailedApiV1SubmissionsGroupFilesGroupFileIdFailedPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/submissions/group-files/{group_file_id}/failed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download a group-wide file
 *
 * The bytes as they were rendered when the file was prepared, in the layout's own media type, served as an attachment under the stored name. Every download returns the same bytes, whose SHA-256 is the record's `file_sha256`.
 *
 * **Staff only.** Requires `submission:read` (`submission:write` to change anything) and a vyttech role. A customer's user -- including one registered at the group -- and a machine client are refused with `403`.
 */
export const downloadGroupFileApiV1SubmissionsGroupFilesGroupFileIdFileGet = <ThrowOnError extends boolean = false>(options: Options<DownloadGroupFileApiV1SubmissionsGroupFilesGroupFileIdFileGetData, ThrowOnError>): RequestResult<DownloadGroupFileApiV1SubmissionsGroupFilesGroupFileIdFileGetResponses, DownloadGroupFileApiV1SubmissionsGroupFilesGroupFileIdFileGetErrors, ThrowOnError> => (options.client ?? client).get<DownloadGroupFileApiV1SubmissionsGroupFilesGroupFileIdFileGetResponses, DownloadGroupFileApiV1SubmissionsGroupFilesGroupFileIdFileGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/submissions/group-files/{group_file_id}/file',
    ...options
});

/**
 * Mark a group-wide file as sent, and every contract in it
 *
 * Records that the file reached the insurer, and marks every member contract's submission sent in the same transaction with the same channel, moment, protocol and notes -- so each contract's watermark moves exactly as it would have filed alone.
 *
 * A `channel` always, and **at least one of `reference` and `notes`**, refused with `422` otherwise. A receipt document is not accepted here: it would belong to one company, and the file to several. A `sent_at` in the future is refused. Nothing moves unless every member can be marked.
 *
 * **Staff only.** Requires `submission:read` (`submission:write` to change anything) and a vyttech role. A customer's user -- including one registered at the group -- and a machine client are refused with `403`.
 */
export const markGroupFileSentApiV1SubmissionsGroupFilesGroupFileIdSentPost = <ThrowOnError extends boolean = false>(options: Options<MarkGroupFileSentApiV1SubmissionsGroupFilesGroupFileIdSentPostData, ThrowOnError>): RequestResult<MarkGroupFileSentApiV1SubmissionsGroupFilesGroupFileIdSentPostResponses, MarkGroupFileSentApiV1SubmissionsGroupFilesGroupFileIdSentPostErrors, ThrowOnError> => (options.client ?? client).post<MarkGroupFileSentApiV1SubmissionsGroupFilesGroupFileIdSentPostResponses, MarkGroupFileSentApiV1SubmissionsGroupFilesGroupFileIdSentPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/submissions/group-files/{group_file_id}/sent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One economic group's month with an insurer, filed as one file
 *
 * Every contract the group's companies hold with the insurer, in the file's order -- ascending subestipulante, then módulo -- each with its company, its own stage and the rows its approved snapshot puts in the file; whether the file can be prepared now and, when not, which members lack a sign-off or share their codes with another; and every file prepared for the month, refused ones included.
 *
 * While a file stands for the month, `members` are the contracts it packaged, whatever the group holds now.
 *
 * An unknown group, or one none of whose companies holds a contract with the insurer, is `404`.
 *
 * Only for an insurer whose layout files one file per customer and month (`consolidated: true` on each contract's standing); any other insurer is refused with `409`. A company with no group is filed per company at `/submissions/companies/{company_id}/insurers/{insurer_id}`.
 *
 * A group file spans companies, so it is read and worked outside any one of them: a request sending `X-Company-Id` is refused with `400`.
 *
 * **Staff only.** Requires `submission:read` (`submission:write` to change anything) and a vyttech role. A customer's user -- including one registered at the group -- and a machine client are refused with `403`.
 */
export const readGroupStandingApiV1SubmissionsGroupsGroupIdInsurersInsurerIdGet = <ThrowOnError extends boolean = false>(options: Options<ReadGroupStandingApiV1SubmissionsGroupsGroupIdInsurersInsurerIdGetData, ThrowOnError>): RequestResult<ReadGroupStandingApiV1SubmissionsGroupsGroupIdInsurersInsurerIdGetResponses, ReadGroupStandingApiV1SubmissionsGroupsGroupIdInsurersInsurerIdGetErrors, ThrowOnError> => (options.client ?? client).get<ReadGroupStandingApiV1SubmissionsGroupsGroupIdInsurersInsurerIdGetResponses, ReadGroupStandingApiV1SubmissionsGroupsGroupIdInsurersInsurerIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/submissions/groups/{group_id}/insurers/{insurer_id}',
    ...options
});

/**
 * Package one economic group's month as a single file
 *
 * Prepares every member contract's own submission -- reusing one already prepared for the month -- and renders one file from their approved snapshots' stored rows: contracts in ascending subestipulante, then módulo, then contract id; each contract's rows in its snapshot's order, every row carrying its own contract's Subestipulante and Módulo. The members are the contracts with the insurer of the companies in the group at this moment, and stay the file's members whatever happens to the group later. The file is named by the layout's template with the group's file-name label, or its name when it has none.
 *
 * **All or nothing.** Refused with `409`, before anything is written, when any member has no approved cycle for the month (named by company and contract in the message and in `details`, `contracts.{contract_id}`); when two members share a subestipulante and módulo (both named); or when a member stands *prepared* in another file -- a company file prepared before its company joined the group -- naming that file to mark sent or failed first.
 *
 * A member whose month was already **sent** in another file is left out rather than filed twice (`already_filed_contract_ids` on the standing).
 *
 * **Refused with `409` when a file is already standing** for the group, insurer and month, prepared or filed -- concurrent requests included.
 *
 * Download the file from `GET /submissions/group-files/{id}/file`.
 *
 * Only for an insurer whose layout files one file per customer and month (`consolidated: true` on each contract's standing); any other insurer is refused with `409`. A company with no group is filed per company at `/submissions/companies/{company_id}/insurers/{insurer_id}`.
 *
 * A group file spans companies, so it is read and worked outside any one of them: a request sending `X-Company-Id` is refused with `400`.
 *
 * **Staff only.** Requires `submission:read` (`submission:write` to change anything) and a vyttech role. A customer's user -- including one registered at the group -- and a machine client are refused with `403`.
 */
export const prepareGroupFileApiV1SubmissionsGroupsGroupIdInsurersInsurerIdPreparePost = <ThrowOnError extends boolean = false>(options: Options<PrepareGroupFileApiV1SubmissionsGroupsGroupIdInsurersInsurerIdPreparePostData, ThrowOnError>): RequestResult<PrepareGroupFileApiV1SubmissionsGroupsGroupIdInsurersInsurerIdPreparePostResponses, PrepareGroupFileApiV1SubmissionsGroupsGroupIdInsurersInsurerIdPreparePostErrors, ThrowOnError> => (options.client ?? client).post<PrepareGroupFileApiV1SubmissionsGroupsGroupIdInsurersInsurerIdPreparePostResponses, PrepareGroupFileApiV1SubmissionsGroupsGroupIdInsurersInsurerIdPreparePostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/submissions/groups/{group_id}/insurers/{insurer_id}/prepare',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One attempt at filing a month
 *
 * Everything recorded about one attempt: the cycle it files, the frozen file it pins, who packaged it, who filed it and what came back.
 *
 * **The file itself is not here.** `snapshot_id` names it and `snapshot_sha256` identifies its bytes; read them at `GET /snapshots/{snapshot_id}/file`, which is the one authenticated path to a snapshot's file and audits every read of one.
 *
 * **Staff only.** This operation requires `submission:read`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const readSubmissionApiV1SubmissionsSubmissionIdGet = <ThrowOnError extends boolean = false>(options: Options<ReadSubmissionApiV1SubmissionsSubmissionIdGetData, ThrowOnError>): RequestResult<ReadSubmissionApiV1SubmissionsSubmissionIdGetResponses, ReadSubmissionApiV1SubmissionsSubmissionIdGetErrors, ThrowOnError> => (options.client ?? client).get<ReadSubmissionApiV1SubmissionsSubmissionIdGetResponses, ReadSubmissionApiV1SubmissionsSubmissionIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/submissions/{submission_id}',
    ...options
});

/**
 * Record an attempt the insurer refused
 *
 * Marks this attempt as having not landed, with a mandatory reason, and frees the cycle to be packaged again. Terminal for the attempt rather than for the cycle: the sign-off still stands, and preparing again produces a fresh row beside this one.
 *
 * Keeping both is the point. "We tried to file March three times" is then a count of rows rather than a story reassembled from the audit trail, and the reason is mandatory because an attempt refused for reasons nobody wrote down is an attempt that gets made again the same way.
 *
 * A failed attempt never moves the watermark: the insurer does not have this file.
 *
 * **Refused with `409` for a contract whose insurer's layout files one file per company** (`consolidated: true` on its standing). Its month is prepared, marked sent and marked failed only through the company's file, at `/submissions/companies/{company_id}/insurers/{insurer_id}` and `/submissions/consolidated/{id}`, so the contract's record and the file the insurer received cannot drift apart. When the contract's company belongs to an economic group (`group_id` on its standing), the refusal names the group's file instead, at `/submissions/groups/{group_id}/insurers/{insurer_id}`.
 *
 * **Staff only.** This operation requires `submission:write`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const markSubmissionFailedApiV1SubmissionsSubmissionIdFailedPost = <ThrowOnError extends boolean = false>(options: Options<MarkSubmissionFailedApiV1SubmissionsSubmissionIdFailedPostData, ThrowOnError>): RequestResult<MarkSubmissionFailedApiV1SubmissionsSubmissionIdFailedPostResponses, MarkSubmissionFailedApiV1SubmissionsSubmissionIdFailedPostErrors, ThrowOnError> => (options.client ?? client).post<MarkSubmissionFailedApiV1SubmissionsSubmissionIdFailedPostResponses, MarkSubmissionFailedApiV1SubmissionsSubmissionIdFailedPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/submissions/{submission_id}/failed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark the file as sent, with proof of submission
 *
 * The marker this whole pipeline is for. Records that the packaged file reached the insurer, through which door, when, and with whatever came back.
 *
 * **At least one of `reference`, `proof_document_id` and `notes` is required**, and a request with none of them is refused with `422`. Which of the three is a matter of what the insurer gave back -- a protocol number, a receipt worth filing, or a note saying that nothing came back and what was done. A month marked as sent with nothing behind it evidences nothing, which is the failure this endpoint exists to prevent.
 *
 * `sent_at` is accepted because a month is usually recorded the morning after it went out; a moment in the future is refused. Send an offset with it -- a value without one is read as São Paulo wall-clock time.
 *
 * **This is what moves the watermark.** From here on, a movement dated on or before this submission's `covers_through` is a late arrival rather than part of the next file, and it appears in the review queue's late-arrival listing. The cycle's sign-off also stops being withdrawable: a file the insurer has cannot be un-approved.
 *
 * **Nothing is transmitted by this call.** It records what a person did. Handing the file to the insurer's own system is separate work, pending a decision on what that system accepts.
 *
 * **Refused with `409` for a contract whose insurer's layout files one file per company** (`consolidated: true` on its standing). Its month is prepared, marked sent and marked failed only through the company's file, at `/submissions/companies/{company_id}/insurers/{insurer_id}` and `/submissions/consolidated/{id}`, so the contract's record and the file the insurer received cannot drift apart. When the contract's company belongs to an economic group (`group_id` on its standing), the refusal names the group's file instead, at `/submissions/groups/{group_id}/insurers/{insurer_id}`.
 *
 * **Staff only.** This operation requires `submission:write`, which only the vyttech roles hold. A customer's user and a machine client are refused with `403`, whatever company they name.
 */
export const markSubmissionSentApiV1SubmissionsSubmissionIdSentPost = <ThrowOnError extends boolean = false>(options: Options<MarkSubmissionSentApiV1SubmissionsSubmissionIdSentPostData, ThrowOnError>): RequestResult<MarkSubmissionSentApiV1SubmissionsSubmissionIdSentPostResponses, MarkSubmissionSentApiV1SubmissionsSubmissionIdSentPostErrors, ThrowOnError> => (options.client ?? client).post<MarkSubmissionSentApiV1SubmissionsSubmissionIdSentPostResponses, MarkSubmissionSentApiV1SubmissionsSubmissionIdSentPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/submissions/{submission_id}/sent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List users
 *
 * Users within the request's company scope. A customer principal sees its own company's people and nobody else's; vyttech staff see everyone, or one company's people by sending `X-Company-Id`.
 *
 * A listing scoped to one company shows the people registered at that company only: users registered at a company group are not among them. Read without a company scope, the list includes them, and `group_id` narrows it to one group's users.
 */
export const listUsersApiV1UsersGet = <ThrowOnError extends boolean = false>(options?: Options<ListUsersApiV1UsersGetData, ThrowOnError>): RequestResult<ListUsersApiV1UsersGetResponses, ListUsersApiV1UsersGetErrors, ThrowOnError> => (options?.client ?? client).get<ListUsersApiV1UsersGetResponses, ListUsersApiV1UsersGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/users',
    ...options
});

/**
 * Create a user
 *
 * Creates a human account. Requires `user:write`, which a customer user does not have.
 *
 * A vyttech role creates staff and ignores company scope. A customer role creates a user of the scoped company -- and only vyttech staff may create vyttech staff.
 *
 * A customer role with `group_id` creates a user registered at that company group instead, who may act for any company currently in it. Only vyttech staff may, and without `X-Company-Id`: naming a company and a group at once, a group for a vyttech role, or a group that does not exist is a `422`.
 *
 * The password is hashed with Argon2id before it is stored and is never returned, logged, or recoverable.
 */
export const createUserApiV1UsersPost = <ThrowOnError extends boolean = false>(options: Options<CreateUserApiV1UsersPostData, ThrowOnError>): RequestResult<CreateUserApiV1UsersPostResponses, CreateUserApiV1UsersPostErrors, ThrowOnError> => (options.client ?? client).post<CreateUserApiV1UsersPostResponses, CreateUserApiV1UsersPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fetch a user
 *
 * A user in another company is `404`, whether or not the identifier exists -- the company filter is applied inside the query, so the row is never loaded.
 */
export const getUserApiV1UsersUserIdGet = <ThrowOnError extends boolean = false>(options: Options<GetUserApiV1UsersUserIdGetData, ThrowOnError>): RequestResult<GetUserApiV1UsersUserIdGetResponses, GetUserApiV1UsersUserIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetUserApiV1UsersUserIdGetResponses, GetUserApiV1UsersUserIdGetErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/users/{user_id}',
    ...options
});

/**
 * Deactivate a user
 *
 * Stops the account signing in, and invalidates any token it already holds on that token's next request. Requires `user:write`. A user registered at a company group is outside every company scope, so only vyttech staff can reach one to deactivate it.
 */
export const deactivateUserApiV1UsersUserIdDeactivationPost = <ThrowOnError extends boolean = false>(options: Options<DeactivateUserApiV1UsersUserIdDeactivationPostData, ThrowOnError>): RequestResult<DeactivateUserApiV1UsersUserIdDeactivationPostResponses, DeactivateUserApiV1UsersUserIdDeactivationPostErrors, ThrowOnError> => (options.client ?? client).post<DeactivateUserApiV1UsersUserIdDeactivationPostResponses, DeactivateUserApiV1UsersUserIdDeactivationPostErrors, ThrowOnError>({
    security: [{
            key: 'userSessionToken',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'machineToken',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/users/{user_id}/deactivation',
    ...options
});
